// Auto-generated by scripts/update-rules.ts — DO NOT EDIT
// Source: TruffleHog detectors (https://github.com/trufflesecurity/trufflehog.git)
// Commit: 6961f2bace57ab32b23b3ba40f8f420f6bc7e004
// Generated: 2026-02-16T03:36:35.361Z
// Detectors: 874 extracted, 19 skipped
// Rules: 1108 compiled (some detectors have multiple regex patterns)

export interface AllowlistRegex {
  regex: RegExp
  target?: 'match' | 'line'
}

export interface RuleAllowlist {
  regexes?: AllowlistRegex[]
  stopwords?: string[]
}

export interface Rule {
  id: string
  label: string
  regex: RegExp
  keywords: string[]
  entropy?: number
  secretGroup?: number
  allowlist?: RuleAllowlist
}

export interface GlobalAllowlist {
  regexes: AllowlistRegex[]
  stopwords: string[]
}

// Global allowlist — filter out common false positives
export const globalAllowlist: GlobalAllowlist = {
  regexes: [
    { regex: /^(?:true|false|null)$/i },
    { regex: /^(?:a+|b+|c+|d+|e+|f+|g+|h+|i+|j+|k+|l+|m+|n+|o+|p+|q+|r+|s+|t+|u+|v+|w+|x+|y+|z+|\*+|\.+)$/i },
    { regex: /^\$(?:\d+|{\d+})$/ },
    { regex: /^\$(?:[A-Z_]+|[a-z_]+)$/ },
    { regex: /^\$\{(?:[A-Z_]+|[a-z_]+)\}$/ },
    { regex: /^\{\{[ \t]*[\w ().|]+[ \t]*\}\}$/ },
    { regex: /^\$\{\{[ \t]*(?:(?:env|github|secrets|vars)(?:\.[A-Za-z]\w+)+[\w "'&.\/=|]*)[ \t]*\}\}$/ },
    { regex: /^%(?:[A-Z_]+|[a-z_]+)%$/ },
    { regex: /^%[+\-# 0]?[bcdeEfFgGoOpqstTUvxX]$/ },
    { regex: /^\{\d{0,2}\}$/ },
    { regex: /^@(?:[A-Z_]+|[a-z_]+)@$/ },
    { regex: /^\/Users\/[a-z0-9]+\/[\w .\-\/]+$/i },
    { regex: /^\/(?:bin|etc|home|opt|tmp|usr|var)\/[\w .\/-]+$/ },
  ],
  stopwords: [
    '014df517-39d1-4453-b7b3-9930c563627c',
    'abcdefghijklmnopqrstuvwxyz',
  ],
}

export const rules: Rule[] = [
  {
    id: 'abstract',
    label: 'Abstract',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['abstract'],
  },
  {
    id: 'abuseipdb',
    label: 'Abuseipdb',
    regex: new RegExp("\\b([a-z0-9]{80})\\b", ''),
    keywords: ['abuseipdb'],
  },
  {
    id: 'abyssale',
    label: 'Abyssale',
    regex: new RegExp("\\b([a-z0-9A-Z]{40})\\b", ''),
    keywords: ['abyssale'],
  },
  {
    id: 'accuweather-v1',
    label: 'Accuweather V1',
    regex: new RegExp("([a-z0-9A-Z\\%]{35})\\b", ''),
    keywords: ['accuweather'],
  },
  {
    id: 'adafruitio',
    label: 'Adafruitio',
    regex: new RegExp("\\b(aio\\_[a-zA-Z0-9]{28})\\b", ''),
    keywords: ['aio_'],
  },
  {
    id: 'adobeio-1',
    label: 'Adobeio (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['adobe'],
  },
  {
    id: 'adobeio-2',
    label: 'Adobeio (2)',
    regex: new RegExp("\\b([a-zA-Z0-9.]{12})\\b", ''),
    keywords: ['adobe'],
  },
  {
    id: 'adzuna-1',
    label: 'Adzuna (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['adzuna'],
  },
  {
    id: 'adzuna-2',
    label: 'Adzuna (2)',
    regex: new RegExp("\\b([a-z0-9]{8})\\b", ''),
    keywords: ['adzuna'],
  },
  {
    id: 'aeroworkflow-1',
    label: 'Aeroworkflow (1)',
    regex: new RegExp("\\b([a-zA-Z0-9^!?#:*;]{20})", ''),
    keywords: ['aeroworkflow'],
  },
  {
    id: 'aeroworkflow-2',
    label: 'Aeroworkflow (2)',
    regex: new RegExp("\\b([0-9]{1,})\\b", ''),
    keywords: ['aeroworkflow'],
  },
  {
    id: 'agora-1',
    label: 'Agora (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['agora'],
  },
  {
    id: 'agora-2',
    label: 'Agora (2)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['agora'],
  },
  {
    id: 'aha-1',
    label: 'Aha (1)',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['aha.io'],
  },
  {
    id: 'aha-2',
    label: 'Aha (2)',
    regex: new RegExp("\\b([A-Za-z0-9](?:[A-Za-z0-9\\-]{0,61}[A-Za-z0-9])\\.aha\\.io)", ''),
    keywords: ['aha.io'],
  },
  {
    id: 'airbrakeprojectkey-1',
    label: 'Airbrakeprojectkey (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['airbrake'],
  },
  {
    id: 'airbrakeprojectkey-2',
    label: 'Airbrakeprojectkey (2)',
    regex: new RegExp("\\b([0-9]{6})\\b", ''),
    keywords: ['airbrake'],
  },
  {
    id: 'airbrakeuserkey',
    label: 'Airbrakeuserkey',
    regex: new RegExp("\\b([a-zA-Z-0-9]{40})\\b", ''),
    keywords: ['airbrake'],
  },
  {
    id: 'airship',
    label: 'Airship',
    regex: new RegExp("\\b([0-9a-zA-Z]{91})\\b", ''),
    keywords: ['airship'],
  },
  {
    id: 'airtableoauth',
    label: 'Airtableoauth',
    regex: new RegExp("\\b([a-zA-Z0-9]+\\.v1\\.[a-zA-Z0-9_-]+\\.[a-f0-9]+)\\b", ''),
    keywords: ['airtable'],
  },
  {
    id: 'airtablepersonalaccesstoken',
    label: 'Airtablepersonalaccesstoken',
    regex: new RegExp("\\b(pat[a-zA-Z0-9]{14}\\.[a-f0-9]{64})\\b", ''),
    keywords: ['airtable'],
  },
  {
    id: 'airvisual',
    label: 'Airvisual',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['airvisual'],
  },
  {
    id: 'aiven',
    label: 'Aiven',
    regex: new RegExp("([a-zA-Z0-9/+=]{372})", ''),
    keywords: ['aiven'],
  },
  {
    id: 'alchemy',
    label: 'Alchemy',
    regex: new RegExp("\\b([0-9a-zA-Z_]{32}|alcht_[0-9a-zA-Z]{30})\\b", ''),
    keywords: ['alchemy', 'alcht_'],
  },
  {
    id: 'alconost',
    label: 'Alconost',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['alconost'],
  },
  {
    id: 'alegra',
    label: 'Alegra',
    regex: new RegExp("\\b([a-z0-9-]{20})\\b", ''),
    keywords: ['alegra'],
  },
  {
    id: 'aletheiaapi',
    label: 'Aletheiaapi',
    regex: new RegExp("\\b([A-Z0-9]{32})\\b", ''),
    keywords: ['aletheiaapi'],
  },
  {
    id: 'algoliaadminkey',
    label: 'Algoliaadminkey',
    regex: new RegExp("\\b([A-Z0-9]{10})\\b", ''),
    keywords: ['algolia', 'docsearch'],
  },
  {
    id: 'alibaba-1',
    label: 'Alibaba (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{30})\\b", ''),
    keywords: ['ltai'],
  },
  {
    id: 'alibaba-2',
    label: 'Alibaba (2)',
    regex: new RegExp("\\b(LTAI[a-zA-Z0-9]{17,21})[\\\"';\\s]*", ''),
    keywords: ['ltai'],
  },
  {
    id: 'alienvault',
    label: 'Alienvault',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['alienvault'],
  },
  {
    id: 'allsports',
    label: 'Allsports',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['allsports'],
  },
  {
    id: 'amadeus-1',
    label: 'Amadeus (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['amadeus'],
  },
  {
    id: 'amadeus-2',
    label: 'Amadeus (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{16})\\b", ''),
    keywords: ['amadeus'],
  },
  {
    id: 'ambee',
    label: 'Ambee',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['ambee'],
  },
  {
    id: 'amplitudeapikey-1',
    label: 'Amplitudeapikey (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['amplitude'],
  },
  {
    id: 'amplitudeapikey-2',
    label: 'Amplitudeapikey (2)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['amplitude'],
  },
  {
    id: 'anthropic',
    label: 'Anthropic',
    regex: new RegExp("\\b(sk-ant-(?:admin01|api03)-[\\w\\-]{93}AA)\\b", ''),
    keywords: ['sk-ant-api03', 'sk-ant-admin01'],
  },
  {
    id: 'anypoint-1',
    label: 'Anypoint (1)',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['anypoint'],
  },
  {
    id: 'anypoint-2',
    label: 'Anypoint (2)',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['anypoint'],
  },
  {
    id: 'anypointoauth2-1',
    label: 'Anypointoauth2 (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['anypoint'],
  },
  {
    id: 'anypointoauth2-2',
    label: 'Anypointoauth2 (2)',
    regex: new RegExp("\\b([0-9a-fA-F]{32})\\b", ''),
    keywords: ['anypoint'],
  },
  {
    id: 'apacta',
    label: 'Apacta',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['apacta'],
  },
  {
    id: 'api2cart',
    label: 'Api2cart',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['api2cart'],
  },
  {
    id: 'apideck-1',
    label: 'Apideck (1)',
    regex: new RegExp("\\b(sk_live_[a-z0-9A-Z-]{93})\\b", ''),
    keywords: ['apideck'],
  },
  {
    id: 'apideck-2',
    label: 'Apideck (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{40})\\b", ''),
    keywords: ['apideck'],
  },
  {
    id: 'apiflash',
    label: 'Apiflash',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['apiflash'],
  },
  {
    id: 'apifonica',
    label: 'Apifonica',
    regex: new RegExp("\\b([0-9a-z]{11}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['apifonica'],
  },
  {
    id: 'apify',
    label: 'Apify',
    regex: new RegExp("\\b(apify\\_api\\_[a-zA-Z-0-9]{36})\\b", ''),
    keywords: ['apify'],
  },
  {
    id: 'apimatic',
    label: 'Apimatic',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{64})\\b", ''),
    keywords: ['apimatic'],
  },
  {
    id: 'apitemplate',
    label: 'Apitemplate',
    regex: new RegExp("\\b([0-9a-zA-Z]{39})\\b", ''),
    keywords: ['apitemplate'],
  },
  {
    id: 'apollo',
    label: 'Apollo',
    regex: new RegExp("\\b([a-zA-Z0-9]{22})\\b", ''),
    keywords: ['apollo'],
  },
  {
    id: 'appcues-1',
    label: 'Appcues (1)',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['appcues'],
  },
  {
    id: 'appcues-2',
    label: 'Appcues (2)',
    regex: new RegExp("\\b([a-z0-9-]{39})\\b", ''),
    keywords: ['appcues'],
  },
  {
    id: 'appcues-3',
    label: 'Appcues (3)',
    regex: new RegExp("\\b([0-9]{5})\\b", ''),
    keywords: ['appcues'],
  },
  {
    id: 'appfollow',
    label: 'Appfollow',
    regex: new RegExp("\\b(eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9\\.[0-9A-Za-z]{74}\\.[0-9A-Z-a-z\\-_]{43})\\b", ''),
    keywords: ['appfollow'],
  },
  {
    id: 'appointedd',
    label: 'Appointedd',
    regex: new RegExp("\\b([a-zA-Z0-9=+]{88})", ''),
    keywords: ['appointedd'],
  },
  {
    id: 'appoptics',
    label: 'Appoptics',
    regex: new RegExp("\\b([0-9a-zA-Z_-]{71})\\b", ''),
    keywords: ['appoptics'],
  },
  {
    id: 'appsynergy',
    label: 'Appsynergy',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['appsynergy'],
  },
  {
    id: 'apptivo-1',
    label: 'Apptivo (1)',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['apptivo'],
  },
  {
    id: 'apptivo-2',
    label: 'Apptivo (2)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{32})\\b", ''),
    keywords: ['apptivo'],
  },
  {
    id: 'artifactory-1',
    label: 'Artifactory (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64,73})\\b", ''),
    keywords: ['artifactory', 'jfrog.io'],
  },
  {
    id: 'artifactory-2',
    label: 'Artifactory (2)',
    regex: new RegExp("\\b([A-Za-z0-9][A-Za-z0-9\\-]{0,61}[A-Za-z0-9]\\.jfrog\\.io)", ''),
    keywords: ['artifactory', 'jfrog.io'],
  },
  {
    id: 'artsy-1',
    label: 'Artsy (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['artsy'],
  },
  {
    id: 'artsy-2',
    label: 'Artsy (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['artsy'],
  },
  {
    id: 'asanaoauth',
    label: 'Asanaoauth',
    regex: new RegExp("\\b([a-z\\/:0-9]{51})\\b", ''),
    keywords: ['asana'],
  },
  {
    id: 'asanapersonalaccesstoken',
    label: 'Asanapersonalaccesstoken',
    regex: new RegExp("\\b([0-9]{1,}\\/[0-9]{16,}(?:\\/[0-9]{16,})?:[A-Za-z0-9]{32,})\\b", ''),
    keywords: ['asana'],
  },
  {
    id: 'assemblyai',
    label: 'Assemblyai',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['assemblyai'],
  },
  {
    id: 'atera',
    label: 'Atera',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['atera'],
  },
  {
    id: 'atlassian-v1',
    label: 'Atlassian V1',
    regex: new RegExp("\\b([a-zA-Z-0-9]{24})\\b", ''),
    keywords: ['atlassian'],
  },
  {
    id: 'atlassian-v2-1',
    label: 'Atlassian V2 (1)',
    regex: new RegExp("\\b(ATCTT3xFfG[A-Za-z0-9+/=_-]+=[A-Za-z0-9]{8})\\b", ''),
    keywords: ['atctt3xffg'],
  },
  {
    id: 'atlassian-v2-2',
    label: 'Atlassian V2 (2)',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['atctt3xffg'],
  },
  {
    id: 'audd',
    label: 'Audd',
    regex: new RegExp("\\b([a-z0-9-]{32})\\b", ''),
    keywords: ['audd'],
  },
  {
    id: 'auth0managementapitoken-1',
    label: 'Auth0managementapitoken (1)',
    regex: new RegExp("\\b(ey[a-zA-Z0-9._-]+)\\b", ''),
    keywords: ['auth0'],
  },
  {
    id: 'auth0managementapitoken-2',
    label: 'Auth0managementapitoken (2)',
    regex: new RegExp("([a-zA-Z0-9\\-]{2,16}\\.[a-zA-Z0-9_-]{2,3}\\.auth0\\.com)", ''),
    keywords: ['auth0'],
  },
  {
    id: 'auth0oauth-1',
    label: 'Auth0oauth (1)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{32,60})\\b", ''),
    keywords: ['auth0'],
  },
  {
    id: 'auth0oauth-2',
    label: 'Auth0oauth (2)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{64,})\\b", ''),
    keywords: ['auth0'],
  },
  {
    id: 'auth0oauth-3',
    label: 'Auth0oauth (3)',
    regex: new RegExp("\\b([a-zA-Z0-9][a-zA-Z0-9._-]*auth0\\.com)\\b", ''),
    keywords: ['auth0'],
  },
  {
    id: 'autodesk-1',
    label: 'Autodesk (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['autodesk'],
  },
  {
    id: 'autodesk-2',
    label: 'Autodesk (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{16})\\b", ''),
    keywords: ['autodesk'],
  },
  {
    id: 'autoklose',
    label: 'Autoklose',
    regex: new RegExp("\\b([a-zA-Z0-9-]{32})\\b", ''),
    keywords: ['autoklose'],
  },
  {
    id: 'autopilot',
    label: 'Autopilot',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['autopilot'],
  },
  {
    id: 'avazapersonalaccesstoken',
    label: 'Avazapersonalaccesstoken',
    regex: new RegExp("\\b([0-9]+-[0-9a-f]{40})\\b", ''),
    keywords: ['avaza'],
  },
  {
    id: 'aviationstack',
    label: 'Aviationstack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['aviationstack'],
  },
  {
    id: 'aws-access_keys',
    label: 'AWS Access_keys',
    regex: new RegExp("\\b((?:AKIA|ABIA|ACCA)[A-Z0-9]{16})\\b", ''),
    keywords: ['akia', 'abia', 'acca'],
  },
  {
    id: 'aws-session_keys-1',
    label: 'AWS Session_keys (1)',
    regex: new RegExp("\\b((?:ASIA)[A-Z0-9]{16})\\b", ''),
    keywords: ['asia'],
  },
  {
    id: 'aws-session_keys-2',
    label: 'AWS Session_keys (2)',
    regex: new RegExp("(?:[^A-Za-z0-9+/]|\\A)([a-zA-Z0-9+/]{100,}={0,3})(?:[^A-Za-z0-9+/=]|$)", ''),
    keywords: ['asia'],
  },
  {
    id: 'axonaut',
    label: 'Axonaut',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['axonaut'],
  },
  {
    id: 'aylien-1',
    label: 'Aylien (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['aylien'],
  },
  {
    id: 'aylien-2',
    label: 'Aylien (2)',
    regex: new RegExp("\\b([a-z0-9]{8})\\b", ''),
    keywords: ['aylien'],
  },
  {
    id: 'ayrshare',
    label: 'Ayrshare',
    regex: new RegExp("\\b([A-Z0-9]{8}-[A-Z0-9]{8}-[A-Z0-9]{8}-[A-Z0-9]{8})\\b", ''),
    keywords: ['ayrshare'],
  },
  {
    id: 'azure_batch-1',
    label: 'Azure_batch (1)',
    regex: new RegExp("https://(.{1,50})\\.(.{1,50})\\.batch\\.azure\\.com", ''),
    keywords: ['.batch.azure.com'],
  },
  {
    id: 'azure_batch-2',
    label: 'Azure_batch (2)',
    regex: new RegExp("[A-Za-z0-9+/=]{88}", ''),
    keywords: ['.batch.azure.com'],
  },
  {
    id: 'azure_cosmosdb-1',
    label: 'Azure_cosmosdb (1)',
    regex: new RegExp("([A-Za-z0-9]{86}==)", ''),
    keywords: ['.documents.azure.com', '.table.cosmos.azure.com'],
  },
  {
    id: 'azure_cosmosdb-2',
    label: 'Azure_cosmosdb (2)',
    regex: new RegExp("([a-z0-9-]{3,44}\\.(?:documents|table\\.cosmos)\\.azure\\.com)", ''),
    keywords: ['.documents.azure.com', '.table.cosmos.azure.com'],
  },
  {
    id: 'azure_entra-refreshtoken',
    label: 'Azure_entra Refreshtoken',
    regex: new RegExp("\\b[01]\\.A[\\w-]{50,}(?:\\.\\d)?\\.Ag[\\w-]{250,}(?:\\.A[\\w-]{200,})?", ''),
    keywords: ['0.a', '1.a'],
  },
  {
    id: 'azure_openai-1',
    label: 'Azure_openai (1)',
    regex: new RegExp("([a-z0-9-]+\\.openai\\.azure\\.com)", 'i'),
    keywords: ['.openai.azure.com'],
  },
  {
    id: 'azure_openai-2',
    label: 'Azure_openai (2)',
    regex: new RegExp("\\b(?:([a-f0-9]{32}))\\b", ''),
    keywords: ['.openai.azure.com'],
  },
  {
    id: 'azure_storage-1',
    label: 'Azure_storage (1)',
    regex: new RegExp("(?:Account[_.-]?Name|Storage[_.-]?(?:Account|Name))(?:.|\\s){0,20}?\\b([a-z0-9]{3,24})\\b|([a-z0-9]{3,24})(?:\\.blob\\.core\\.windows\\.net)", 'i'),
    keywords: ['defaultendpointsprotocol=http', 'endpointsuffix', 'core.windows.net', 'accountname', 'account_name', 'account.name', 'account-name', 'storageaccount', 'storage_account', 'storage.account', 'storage-account', 'accountkey', 'account_key', 'account.key', 'account-key'],
  },
  {
    id: 'azure_storage-2',
    label: 'Azure_storage (2)',
    regex: new RegExp("(?:(?:Access|Account|Storage)[_.-]?Key)(?:.|\\s){0,25}?([a-zA-Z0-9+\\/-]{86,88}={0,2})", 'i'),
    keywords: ['defaultendpointsprotocol=http', 'endpointsuffix', 'core.windows.net', 'accountname', 'account_name', 'account.name', 'account-name', 'storageaccount', 'storage_account', 'storage.account', 'storage-account', 'accountkey', 'account_key', 'account.key', 'account-key'],
  },
  {
    id: 'azureapimanagement-repositorykey-1',
    label: 'Azureapimanagement Repositorykey (1)',
    regex: new RegExp("([a-z0-9][a-z0-9-]{0,48}[a-z0-9]\\.scm\\.azure-api\\.net)", ''),
    keywords: ['azure', '.scm.azure-api.net'],
  },
  {
    id: 'azureapimanagement-repositorykey-2',
    label: 'Azureapimanagement Repositorykey (2)',
    regex: new RegExp("\\b(git&[0-9]{12}&[a-zA-Z0-9\\/+]{85}[a-zA-Z0-9]==)", ''),
    keywords: ['azure', '.scm.azure-api.net'],
  },
  {
    id: 'azureapimanagement-repositorykey-3',
    label: 'Azureapimanagement Repositorykey (3)',
    regex: new RegExp("\\d+\\.\\d+\\.\\d+", ''),
    keywords: ['azure', '.scm.azure-api.net'],
  },
  {
    id: 'azureapimanagementsubscriptionkey-1',
    label: 'Azureapimanagementsubscriptionkey (1)',
    regex: new RegExp("https://([a-z0-9][a-z0-9-]{0,48}[a-z0-9])\\.azure-api\\.net", ''),
    keywords: ['.azure-api.net'],
  },
  {
    id: 'azureapimanagementsubscriptionkey-2',
    label: 'Azureapimanagementsubscriptionkey (2)',
    regex: new RegExp("([a-zA-Z-0-9]{32})", ''),
    keywords: ['.azure-api.net'],
  },
  {
    id: 'azureappconfigconnectionstring',
    label: 'Azureappconfigconnectionstring',
    regex: new RegExp("Endpoint=(https:\\/\\/[a-zA-Z0-9-]+\\.azconfig\\.io);Id=([a-zA-Z0-9+\\/=]+);Secret=([a-zA-Z0-9+\\/=]+)", ''),
    keywords: ['.azconfig.io'],
  },
  {
    id: 'azurecontainerregistry-1',
    label: 'Azurecontainerregistry (1)',
    regex: new RegExp("([a-z0-9][a-z0-9-]{1,100}[a-z0-9])\\.azurecr\\.io", ''),
    keywords: ['.azurecr.io'],
  },
  {
    id: 'azurecontainerregistry-2',
    label: 'Azurecontainerregistry (2)',
    regex: new RegExp("\\b[a-zA-Z0-9+/]{42}\\+ACR[a-zA-Z0-9]{6}\\b", ''),
    keywords: ['.azurecr.io'],
  },
  {
    id: 'azuredevopspersonalaccesstoken-1',
    label: 'Azuredevopspersonalaccesstoken (1)',
    regex: new RegExp("\\b([0-9a-z]{52})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuredevopspersonalaccesstoken-2',
    label: 'Azuredevopspersonalaccesstoken (2)',
    regex: new RegExp("\\b([0-9a-zA-Z][0-9a-zA-Z-]{5,48}[0-9a-zA-Z])\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuredirectmanagementkey-1',
    label: 'Azuredirectmanagementkey (1)',
    regex: new RegExp("https://([a-z0-9][a-z0-9-]{0,48}[a-z0-9])\\.management\\.azure-api\\.net", ''),
    keywords: ['.management.azure-api.net'],
  },
  {
    id: 'azuredirectmanagementkey-2',
    label: 'Azuredirectmanagementkey (2)',
    regex: new RegExp("([a-zA-Z0-9+\\/]{83,85}[a-zA-Z0-9]==)", ''),
    keywords: ['.management.azure-api.net'],
  },
  {
    id: 'azurefunctionkey-1',
    label: 'Azurefunctionkey (1)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{20,56})\\b={0,2}", ''),
    keywords: ['azure'],
  },
  {
    id: 'azurefunctionkey-2',
    label: 'Azurefunctionkey (2)',
    regex: new RegExp("\\bhttps:\\/\\/([a-zA-Z0-9-]{2,30})\\.azurewebsites\\.net\\/api\\/([a-zA-Z0-9-]{2,30})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuresastoken',
    label: 'Azuresastoken',
    regex: new RegExp("https://([a-zA-Z0-9][a-z0-9_-]{1,22}[a-zA-Z0-9])\\.blob\\.core\\.windows\\.net/[a-z0-9]([a-z0-9-]{1,61}[a-z0-9])?(?:/[a-zA-Z0-9._-]+)*", ''),
    keywords: ['azure', '.blob.core.windows.net'],
  },
  {
    id: 'azuresearchadminkey-1',
    label: 'Azuresearchadminkey (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{52})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuresearchadminkey-2',
    label: 'Azuresearchadminkey (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{7,40})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuresearchquerykey-1',
    label: 'Azuresearchquerykey (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{52})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'azuresearchquerykey-2',
    label: 'Azuresearchquerykey (2)',
    regex: new RegExp("https:\\/\\/([0-9a-z]{5,40})\\.search\\.windows\\.net\\/indexes\\/([0-9a-z]{5,40})\\b", ''),
    keywords: ['azure'],
  },
  {
    id: 'bannerbear-v1',
    label: 'Bannerbear V1',
    regex: new RegExp("\\b([0-9a-zA-Z]{22}tt)\\b", ''),
    keywords: ['bannerbear'],
  },
  {
    id: 'bannerbear-v2',
    label: 'Bannerbear V2',
    regex: new RegExp("\\b(bb_(?:pr|ma)_[a-f0-9]{30})\\b", ''),
    keywords: ['bb_pr_', 'bb_ma_'],
  },
  {
    id: 'baremetrics',
    label: 'Baremetrics',
    regex: new RegExp("\\b((?:sk|lk)_[a-zA-Z0-9]{18,25})\\b", ''),
    keywords: ['baremetrics'],
  },
  {
    id: 'beamer',
    label: 'Beamer',
    regex: new RegExp("\\b([a-zA-Z0-9_+/]{45}=)", ''),
    keywords: ['beamer'],
  },
  {
    id: 'beebole',
    label: 'Beebole',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['beebole'],
  },
  {
    id: 'besnappy',
    label: 'Besnappy',
    regex: new RegExp("\\b([a-f0-9]{64})\\b", ''),
    keywords: ['besnappy'],
  },
  {
    id: 'besttime',
    label: 'Besttime',
    regex: new RegExp("\\b(pri_[a-f0-9]{32})\\b", ''),
    keywords: ['besttime'],
  },
  {
    id: 'betterstack',
    label: 'Betterstack',
    regex: new RegExp("\\b([0-9a-zA-Z]{24})\\b", ''),
    keywords: ['betterstack'],
  },
  {
    id: 'billomat-1',
    label: 'Billomat (1)',
    regex: new RegExp("\\b([0-9a-z]{4,20})\\b", ''),
    keywords: ['billomat'],
  },
  {
    id: 'billomat-2',
    label: 'Billomat (2)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['billomat'],
  },
  {
    id: 'bingsubscriptionkey',
    label: 'Bingsubscriptionkey',
    regex: new RegExp("\\b([a-fA-F0-9]{32})\\b", ''),
    keywords: ['bing'],
  },
  {
    id: 'bitbar',
    label: 'Bitbar',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['bitbar'],
  },
  {
    id: 'bitbucketapppassword-1',
    label: 'Bitbucketapppassword (1)',
    regex: new RegExp("(?:^|[^A-Za-z0-9-_])(?<username>[A-Za-z0-9-_]{1,30}):(?<password>ATBB[A-Za-z0-9_=.-]+)\\b", ''),
    keywords: ['bitbucket', 'atbb'],
  },
  {
    id: 'bitbucketapppassword-2',
    label: 'Bitbucketapppassword (2)',
    regex: new RegExp("https://(?<username>[A-Za-z0-9-_]{1,30}):(?<password>ATBB[A-Za-z0-9_=.-]+)@bitbucket\\.org", ''),
    keywords: ['bitbucket', 'atbb'],
  },
  {
    id: 'bitbucketapppassword-3',
    label: 'Bitbucketapppassword (3)',
    regex: new RegExp("\"(?<username>[A-Za-z0-9-_]{1,30})\",\\s*\"(?<password>ATBB[A-Za-z0-9_=.-]+)\"", ''),
    keywords: ['bitbucket', 'atbb'],
  },
  {
    id: 'bitcoinaverage',
    label: 'Bitcoinaverage',
    regex: new RegExp("\\b([a-zA-Z0-9]{43})\\b", ''),
    keywords: ['bitcoinaverage'],
  },
  {
    id: 'bitfinex-1',
    label: 'Bitfinex (1)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{43})\\b", ''),
    keywords: ['bitfinex'],
  },
  {
    id: 'bitfinex-2',
    label: 'Bitfinex (2)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{43})\\b", ''),
    keywords: ['bitfinex'],
  },
  {
    id: 'bitlyaccesstoken',
    label: 'Bitlyaccesstoken',
    regex: new RegExp("\\b([a-zA-Z-0-9]{40})\\b", ''),
    keywords: ['bitly'],
  },
  {
    id: 'bitmex-1',
    label: 'Bitmex (1)',
    regex: new RegExp("([ \\r\\n]{1}[0-9a-zA-Z\\-\\_]{24}[ \\r\\n]{1})", ''),
    keywords: ['bitmex'],
  },
  {
    id: 'bitmex-2',
    label: 'Bitmex (2)',
    regex: new RegExp("([ \\r\\n]{1}[0-9a-zA-Z\\-\\_]{48}[ \\r\\n]{1})", ''),
    keywords: ['bitmex'],
  },
  {
    id: 'blazemeter',
    label: 'Blazemeter',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['blazemeter', 'runscope'],
  },
  {
    id: 'blitapp',
    label: 'Blitapp',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{39})\\b", ''),
    keywords: ['blitapp'],
  },
  {
    id: 'blocknative',
    label: 'Blocknative',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['blocknative'],
  },
  {
    id: 'blogger',
    label: 'Blogger',
    regex: new RegExp("\\b([0-9A-Za-z-]{39})\\b", ''),
    keywords: ['blogger'],
  },
  {
    id: 'boostnote',
    label: 'Boostnote',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['boostnote'],
  },
  {
    id: 'borgbase',
    label: 'Borgbase',
    regex: new RegExp("\\b([a-zA-Z0-9/_.-]{148,152})\\b", ''),
    keywords: ['borgbase'],
  },
  {
    id: 'box',
    label: 'Box',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['box'],
  },
  {
    id: 'braintreepayments-1',
    label: 'Braintreepayments (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['braintree'],
  },
  {
    id: 'braintreepayments-2',
    label: 'Braintreepayments (2)',
    regex: new RegExp("\\b([0-9a-z]{16})\\b", ''),
    keywords: ['braintree'],
  },
  {
    id: 'brandfetch-v1',
    label: 'Brandfetch V1',
    regex: new RegExp("\\b([0-9A-Za-z]{40})\\b", ''),
    keywords: ['brandfetch'],
  },
  {
    id: 'brandfetch-v2',
    label: 'Brandfetch V2',
    regex: new RegExp("([a-zA-Z0-9=+/\\-_!@#$%^&*()]{43}=)", ''),
    keywords: ['brandfetch'],
  },
  {
    id: 'browserstack-1',
    label: 'Browserstack (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['browserstack'],
  },
  {
    id: 'browserstack-2',
    label: 'Browserstack (2)',
    regex: new RegExp("\\b([a-zA-Z\\d]{3,18}[._-]*[a-zA-Z\\d]{6,11})\\b", ''),
    keywords: ['browserstack'],
  },
  {
    id: 'browshot',
    label: 'Browshot',
    regex: new RegExp("\\b([a-zA-Z-0-9]{28})\\b", ''),
    keywords: ['browshot'],
  },
  {
    id: 'bscscan',
    label: 'Bscscan',
    regex: new RegExp("\\b([0-9A-Z]{34})\\b", ''),
    keywords: ['bscscan'],
  },
  {
    id: 'buddyns',
    label: 'Buddyns',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['buddyns'],
  },
  {
    id: 'budibase',
    label: 'Budibase',
    regex: new RegExp("\\b([a-f0-9]{32}-[a-f0-9]{78,80})\\b", ''),
    keywords: ['budibase'],
  },
  {
    id: 'bugherd',
    label: 'Bugherd',
    regex: new RegExp("\\b([0-9a-z]{22})\\b", ''),
    keywords: ['bugherd'],
  },
  {
    id: 'bugsnag',
    label: 'Bugsnag',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['bugsnag'],
  },
  {
    id: 'buildkite-v1',
    label: 'Buildkite V1',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['buildkite'],
  },
  {
    id: 'buildkite-v2',
    label: 'Buildkite V2',
    regex: new RegExp("\\b(bkua_[a-z0-9]{40})\\b", ''),
    keywords: ['bkua_'],
  },
  {
    id: 'bulbul',
    label: 'Bulbul',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['bulbul'],
  },
  {
    id: 'bulksms-1',
    label: 'Bulksms (1)',
    regex: new RegExp("\\b([a-zA-Z0-9!@#$%^&*()]{29})\\b", ''),
    keywords: ['bulksms'],
  },
  {
    id: 'bulksms-2',
    label: 'Bulksms (2)',
    regex: new RegExp("\\b([A-F0-9-]{37})\\b", ''),
    keywords: ['bulksms'],
  },
  {
    id: 'buttercms',
    label: 'Buttercms',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['buttercms'],
  },
  {
    id: 'caflou',
    label: 'Caflou',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiJ9[a-zA-Z0-9._-]{135})\\b", ''),
    keywords: ['caflou'],
  },
  {
    id: 'calendlyapikey',
    label: 'Calendlyapikey',
    regex: new RegExp("\\b(eyJ[A-Za-z0-9-_]{100,300}\\.eyJ[A-Za-z0-9-_]{100,300}\\.[A-Za-z0-9-_]+)\\b", ''),
    keywords: ['calendly'],
  },
  {
    id: 'calorieninja',
    label: 'Calorieninja',
    regex: new RegExp("\\b([0-9A-Za-z]{40})\\b", ''),
    keywords: ['calorieninja'],
  },
  {
    id: 'campayn',
    label: 'Campayn',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['campayn'],
  },
  {
    id: 'cannyio',
    label: 'Cannyio',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['canny'],
  },
  {
    id: 'capsulecrm',
    label: 'Capsulecrm',
    regex: new RegExp("\\b([a-zA-Z0-9-._+=]{64})\\b", ''),
    keywords: ['capsulecrm'],
  },
  {
    id: 'captaindata-v1-1',
    label: 'Captaindata V1 (1)',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['captaindata'],
  },
  {
    id: 'captaindata-v1-2',
    label: 'Captaindata V1 (2)',
    regex: new RegExp("\\b([0-9a-f]{8}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{12})\\b", ''),
    keywords: ['captaindata'],
  },
  {
    id: 'captaindata-v2-1',
    label: 'Captaindata V2 (1)',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['captaindata'],
  },
  {
    id: 'captaindata-v2-2',
    label: 'Captaindata V2 (2)',
    regex: new RegExp("\\b([0-9a-f]{8}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{12})\\b", ''),
    keywords: ['captaindata'],
  },
  {
    id: 'carboninterface',
    label: 'Carboninterface',
    regex: new RegExp("\\b([a-zA-Z0-9]{21})\\b", ''),
    keywords: ['carboninterface'],
  },
  {
    id: 'cashboard-1',
    label: 'Cashboard (1)',
    regex: new RegExp("\\b([0-9A-Z]{3}-[0-9A-Z]{3}-[0-9A-Z]{3}-[0-9A-Z]{3})\\b", ''),
    keywords: ['cashboard'],
  },
  {
    id: 'cashboard-2',
    label: 'Cashboard (2)',
    regex: new RegExp("\\b([0-9a-z]{1,})\\b", ''),
    keywords: ['cashboard'],
  },
  {
    id: 'caspio-1',
    label: 'Caspio (1)',
    regex: new RegExp("\\b([a-z0-9]{50})\\b", ''),
    keywords: ['caspio'],
  },
  {
    id: 'caspio-2',
    label: 'Caspio (2)',
    regex: new RegExp("\\b([a-z0-9]{50})\\b", ''),
    keywords: ['caspio'],
  },
  {
    id: 'caspio-3',
    label: 'Caspio (3)',
    regex: new RegExp("\\b([a-z0-9]{8})\\b", ''),
    keywords: ['caspio'],
  },
  {
    id: 'censys',
    label: 'Censys',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['censys'],
  },
  {
    id: 'centralstationcrm',
    label: 'Centralstationcrm',
    regex: new RegExp("\\b([a-z0-9]{30})\\b", ''),
    keywords: ['centralstationcrm'],
  },
  {
    id: 'cexio-1',
    label: 'Cexio (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{24,27})\\b", ''),
    keywords: ['cexio', 'cex.io'],
  },
  {
    id: 'cexio-2',
    label: 'Cexio (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{24,27})\\b", ''),
    keywords: ['cexio', 'cex.io'],
  },
  {
    id: 'cexio-3',
    label: 'Cexio (3)',
    regex: new RegExp("\\b([a-z]{2}[0-9]{9})\\b", ''),
    keywords: ['cexio', 'cex.io'],
  },
  {
    id: 'chartmogul',
    label: 'Chartmogul',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['chartmogul'],
  },
  {
    id: 'chatbot',
    label: 'Chatbot',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['chatbot'],
  },
  {
    id: 'chatfule',
    label: 'Chatfule',
    regex: new RegExp("\\b([a-zA-Z0-9]{128})\\b", ''),
    keywords: ['chatfuel'],
  },
  {
    id: 'checio',
    label: 'Checio',
    regex: new RegExp("\\b(pk_[a-z0-9]{45})\\b", ''),
    keywords: ['checio'],
  },
  {
    id: 'checklyhq',
    label: 'Checklyhq',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['checklyhq'],
  },
  {
    id: 'checkout-1',
    label: 'Checkout (1)',
    regex: new RegExp("\\b((sk_|sk_test_)[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\\b", ''),
    keywords: ['checkout'],
  },
  {
    id: 'checkout-2',
    label: 'Checkout (2)',
    regex: new RegExp("\\b(cus_[0-9a-zA-Z]{26})\\b", ''),
    keywords: ['checkout'],
  },
  {
    id: 'checkvist',
    label: 'Checkvist',
    regex: new RegExp("\\b([0-9a-zA-Z]{14})\\b", ''),
    keywords: ['checkvist'],
  },
  {
    id: 'cicero',
    label: 'Cicero',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['cicero'],
  },
  {
    id: 'circleci-v1',
    label: 'Circleci V1',
    regex: new RegExp("([a-fA-F0-9]{40})", ''),
    keywords: ['circle'],
  },
  {
    id: 'circleci-v2',
    label: 'Circleci V2',
    regex: new RegExp("(CCIPAT_[a-zA-Z0-9]{22}_[a-fA-F0-9]{40})", ''),
    keywords: ['ccipat_'],
  },
  {
    id: 'clearbit',
    label: 'Clearbit',
    regex: new RegExp("\\b([0-9a-z_]{35})\\b", ''),
    keywords: ['clearbit'],
  },
  {
    id: 'clickhelp-1',
    label: 'Clickhelp (1)',
    regex: new RegExp("\\b([0-9A-Za-z-]{3,20}\\.(?:try\\.)?clickhelp\\.co)\\b", ''),
    keywords: ['clickhelp.co'],
  },
  {
    id: 'clickhelp-2',
    label: 'Clickhelp (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{24})\\b", ''),
    keywords: ['clickhelp.co'],
  },
  {
    id: 'clickuppersonaltoken',
    label: 'Clickuppersonaltoken',
    regex: new RegExp("\\b(pk_[0-9]{7,9}_[0-9A-Z]{32})\\b", ''),
    keywords: ['clickup'],
  },
  {
    id: 'cliengo',
    label: 'Cliengo',
    regex: new RegExp("\\b([0-9a-f]{8}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{4}\\-[0-9a-f]{12})\\b", ''),
    keywords: ['cliengo'],
  },
  {
    id: 'clientary-1',
    label: 'Clientary (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{24,26})\\b", ''),
    keywords: ['ronin', 'clientary'],
  },
  {
    id: 'clientary-2',
    label: 'Clientary (2)',
    regex: new RegExp("\\b([0-9Aa-zA-Z-]{4,25})\\b", ''),
    keywords: ['ronin', 'clientary'],
  },
  {
    id: 'clinchpad',
    label: 'Clinchpad',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['clinchpad'],
  },
  {
    id: 'clockify',
    label: 'Clockify',
    regex: new RegExp("\\b([a-zA-Z0-9]{48})\\b", ''),
    keywords: ['clockify'],
  },
  {
    id: 'clockworksms-1',
    label: 'Clockworksms (1)',
    regex: new RegExp("\\b([0-9]{5})\\b", ''),
    keywords: ['clockworksms', 'textanywhere'],
  },
  {
    id: 'clockworksms-2',
    label: 'Clockworksms (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{24})\\b", ''),
    keywords: ['clockworksms', 'textanywhere'],
  },
  {
    id: 'closecrm',
    label: 'Closecrm',
    regex: new RegExp("\\b(api_[a-z0-9A-Z.]{45})\\b", ''),
    keywords: ['close'],
  },
  {
    id: 'cloudelements-1',
    label: 'Cloudelements (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{43})\\b", ''),
    keywords: ['cloudelements'],
  },
  {
    id: 'cloudelements-2',
    label: 'Cloudelements (2)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['cloudelements'],
  },
  {
    id: 'cloudflareapitoken',
    label: 'Cloudflareapitoken',
    regex: new RegExp("\\b([A-Za-z0-9_-]{40})\\b", ''),
    keywords: ['cloudflare'],
  },
  {
    id: 'cloudflarecakey',
    label: 'Cloudflarecakey',
    regex: new RegExp("\\b(v1\\.0-[A-Za-z0-9-]{171})\\b", ''),
    keywords: ['cloudflare'],
  },
  {
    id: 'cloudflareglobalapikey',
    label: 'Cloudflareglobalapikey',
    regex: new RegExp("\\b([A-Za-z0-9_-]{37})\\b", ''),
    keywords: ['cloudflare'],
  },
  {
    id: 'cloudimage',
    label: 'Cloudimage',
    regex: new RegExp("\\b([a-z0-9_]{30})\\b", ''),
    keywords: ['cloudimage'],
  },
  {
    id: 'cloudmersive',
    label: 'Cloudmersive',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['cloudmersive'],
  },
  {
    id: 'cloudplan',
    label: 'Cloudplan',
    regex: new RegExp("\\b([A-Z0-9-]{32})\\b", ''),
    keywords: ['cloudplan'],
  },
  {
    id: 'cloudsmith',
    label: 'Cloudsmith',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['cloudsmith'],
  },
  {
    id: 'cloverly',
    label: 'Cloverly',
    regex: new RegExp("\\b([a-z0-9:_]{28})\\b", ''),
    keywords: ['cloverly'],
  },
  {
    id: 'cloze',
    label: 'Cloze',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['cloze'],
  },
  {
    id: 'clustdoc',
    label: 'Clustdoc',
    regex: new RegExp("\\b([0-9a-zA-Z]{60})\\b", ''),
    keywords: ['clustdoc'],
  },
  {
    id: 'coda',
    label: 'Coda',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['coda'],
  },
  {
    id: 'codacy',
    label: 'Codacy',
    regex: new RegExp("\\b([0-9A-Za-z]{20})\\b", ''),
    keywords: ['codacy'],
  },
  {
    id: 'codeclimate',
    label: 'Codeclimate',
    regex: new RegExp("\\b([a-f0-9]{40})\\b", ''),
    keywords: ['codeclimate'],
  },
  {
    id: 'codequiry',
    label: 'Codequiry',
    regex: new RegExp("\\b([a-zA-Z-0-9]{64})\\b", ''),
    keywords: ['codequiry'],
  },
  {
    id: 'coinapi',
    label: 'Coinapi',
    regex: new RegExp("\\b([A-Z0-9-]{36})\\b", ''),
    keywords: ['coinapi'],
  },
  {
    id: 'coinbase-1',
    label: 'Coinbase (1)',
    regex: new RegExp("\\b(organizations\\\\*/\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12}\\\\*/apiKeys\\\\*/\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12})\\b", ''),
    keywords: ['begin ec'],
  },
  {
    id: 'coinbase-2',
    label: 'Coinbase (2)',
    regex: new RegExp("(-----BEGIN EC(?:DSA)? PRIVATE KEY-----(?:\\r|\\n|\\\\+r|\\\\+n)(?:[a-zA-Z0-9+/]+={0,2}(?:\\r|\\n|\\\\+r|\\\\+n))+-----END EC(?:DSA)? PRIVATE KEY-----(?:\\r|\\n|\\\\+r|\\\\+n)?)", ''),
    keywords: ['begin ec'],
  },
  {
    id: 'coinlayer',
    label: 'Coinlayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['coinlayer'],
  },
  {
    id: 'coinlib',
    label: 'Coinlib',
    regex: new RegExp("\\b([a-z0-9]{16})\\b", ''),
    keywords: ['coinlib'],
  },
  {
    id: 'collect2',
    label: 'Collect2',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['collect2'],
  },
  {
    id: 'column',
    label: 'Column',
    regex: new RegExp("\\b((?:test|live)_[a-zA-Z0-9]{27})\\b", ''),
    keywords: ['column'],
  },
  {
    id: 'commercejs',
    label: 'Commercejs',
    regex: new RegExp("\\b([a-z0-9_]{48})\\b", ''),
    keywords: ['commercejs'],
  },
  {
    id: 'commodities',
    label: 'Commodities',
    regex: new RegExp("\\b([a-zA-Z0-9]{60})\\b", ''),
    keywords: ['commodities'],
  },
  {
    id: 'companyhub-1',
    label: 'Companyhub (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['companyhub'],
  },
  {
    id: 'companyhub-2',
    label: 'Companyhub (2)',
    regex: new RegExp("\\b([a-zA-Z0-9$%^=-]{4,32})\\b", ''),
    keywords: ['companyhub'],
  },
  {
    id: 'confluent-1',
    label: 'Confluent (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{16})\\b", ''),
    keywords: ['confluent'],
  },
  {
    id: 'confluent-2',
    label: 'Confluent (2)',
    regex: new RegExp("\\b([a-zA-Z0-9\\+\\/]{64})\\b", ''),
    keywords: ['confluent'],
  },
  {
    id: 'contentfulpersonalaccesstoken',
    label: 'Contentfulpersonalaccesstoken',
    regex: new RegExp("\\b(CFPAT-[a-zA-Z0-9_\\-]{43})\\b", ''),
    keywords: ['cfpat-'],
  },
  {
    id: 'conversiontools',
    label: 'Conversiontools',
    regex: new RegExp("\\b(ey[a-zA-Z0-9_.]{157,165})\\b", ''),
    keywords: ['conversiontools'],
  },
  {
    id: 'convertapi',
    label: 'Convertapi',
    regex: new RegExp("\\b(secret_[0-9a-zA-Z]{16})\\b", ''),
    keywords: ['convertapi'],
  },
  {
    id: 'convertkit',
    label: 'Convertkit',
    regex: new RegExp("\\b([a-z0-9A-Z_]{22})\\b", ''),
    keywords: ['convertkit'],
  },
  {
    id: 'convier',
    label: 'Convier',
    regex: new RegExp("\\b([0-9]{2}\\|[a-zA-Z0-9]{40})\\b", ''),
    keywords: ['convier'],
  },
  {
    id: 'copper-1',
    label: 'Copper (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['copper'],
  },
  {
    id: 'copper-2',
    label: 'Copper (2)',
    regex: new RegExp("\\b([a-z0-9]{4,25}@[a-zA-Z0-9]{2,12}.[a-zA-Z0-9]{2,6})\\b", ''),
    keywords: ['copper'],
  },
  {
    id: 'couchbase',
    label: 'Couchbase',
    regex: new RegExp("\\b(cb\\.[a-z0-9]+\\.cloud\\.couchbase\\.com)\\b", ''),
    keywords: ['couchbase://', 'couchbases://'],
  },
  {
    id: 'countrylayer',
    label: 'Countrylayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['countrylayer'],
  },
  {
    id: 'courier',
    label: 'Courier',
    regex: new RegExp("\\b(pk\\_[a-zA-Z0-9]{1,}\\_[a-zA-Z0-9]{28})\\b", ''),
    keywords: ['courier'],
  },
  {
    id: 'coveralls',
    label: 'Coveralls',
    regex: new RegExp("\\b([a-zA-Z0-9-]{37})\\b", ''),
    keywords: ['coveralls'],
  },
  {
    id: 'craftmypdf',
    label: 'Craftmypdf',
    regex: new RegExp("\\b([0-9a-zA-Z]{35})\\b", ''),
    keywords: ['craftmypdf'],
  },
  {
    id: 'crowdin',
    label: 'Crowdin',
    regex: new RegExp("\\b([0-9A-Za-z]{80})\\b", ''),
    keywords: ['crowdin'],
  },
  {
    id: 'cryptocompare',
    label: 'Cryptocompare',
    regex: new RegExp("\\b([a-z-0-9]{64})\\b", ''),
    keywords: ['cryptocompare'],
  },
  {
    id: 'currencycloud',
    label: 'Currencycloud',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['currencycloud'],
  },
  {
    id: 'currencyfreaks',
    label: 'Currencyfreaks',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['currencyfreaks'],
  },
  {
    id: 'currencylayer',
    label: 'Currencylayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['currencylayer'],
  },
  {
    id: 'currencyscoop',
    label: 'Currencyscoop',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['currencyscoop'],
  },
  {
    id: 'currentsapi',
    label: 'Currentsapi',
    regex: new RegExp("([a-zA-Z0-9_-]{48})", ''),
    keywords: ['currentsapi'],
  },
  {
    id: 'customerguru-1',
    label: 'Customerguru (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{30})\\b", ''),
    keywords: ['customerguru'],
  },
  {
    id: 'customerguru-2',
    label: 'Customerguru (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{50})\\b", ''),
    keywords: ['customerguru'],
  },
  {
    id: 'customerio-1',
    label: 'Customerio (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{20})\\b", ''),
    keywords: ['customerio'],
  },
  {
    id: 'customerio-2',
    label: 'Customerio (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{20})\\b", ''),
    keywords: ['customerio'],
  },
  {
    id: 'd7network',
    label: 'D7network',
    regex: new RegExp("\\b([a-zA-Z0-9\\W\\S]{23}\\=)", ''),
    keywords: ['d7network'],
  },
  {
    id: 'dailyco',
    label: 'Dailyco',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['daily'],
  },
  {
    id: 'dandelion',
    label: 'Dandelion',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['dandelion'],
  },
  {
    id: 'dareboost',
    label: 'Dareboost',
    regex: new RegExp("\\b([0-9a-zA-Z]{60})\\b", ''),
    keywords: ['dareboost'],
  },
  {
    id: 'databrickstoken-1',
    label: 'Databrickstoken (1)',
    regex: new RegExp("\\b([a-z0-9-]+(?:\\.[a-z0-9-]+)*\\.(cloud\\.databricks\\.com|gcp\\.databricks\\.com|azuredatabricks\\.net))\\b", ''),
    keywords: ['databricks', 'dapi'],
  },
  {
    id: 'databrickstoken-2',
    label: 'Databrickstoken (2)',
    regex: new RegExp("\\b(dapi[0-9a-f]{32}(-\\d)?)\\b", ''),
    keywords: ['databricks', 'dapi'],
  },
  {
    id: 'datadogtoken-1',
    label: 'Datadogtoken (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{40})\\b", ''),
    keywords: ['datadog'],
  },
  {
    id: 'datadogtoken-2',
    label: 'Datadogtoken (2)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['datadog'],
  },
  {
    id: 'datagov',
    label: 'Datagov',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['data.gov'],
  },
  {
    id: 'debounce',
    label: 'Debounce',
    regex: new RegExp("\\b([a-zA-Z0-9]{13})\\b", ''),
    keywords: ['debounce'],
  },
  {
    id: 'deepai',
    label: 'Deepai',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['deepai'],
  },
  {
    id: 'deepgram',
    label: 'Deepgram',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['deepgram'],
  },
  {
    id: 'deepseek',
    label: 'Deepseek',
    regex: new RegExp("\\b(sk-[a-z0-9]{32})\\b", ''),
    keywords: ['deepseek'],
  },
  {
    id: 'delighted',
    label: 'Delighted',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['delighted'],
  },
  {
    id: 'demio-1',
    label: 'Demio (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['demio'],
  },
  {
    id: 'demio-2',
    label: 'Demio (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{10,20})\\b", ''),
    keywords: ['demio'],
  },
  {
    id: 'deno',
    label: 'Deno',
    regex: new RegExp("\\b(dd[pw]_[a-zA-Z0-9]{36})\\b", ''),
    keywords: ['ddp_', 'ddw_'],
  },
  {
    id: 'deputy-1',
    label: 'Deputy (1)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['deputy'],
  },
  {
    id: 'deputy-2',
    label: 'Deputy (2)',
    regex: new RegExp("\\b([0-9a-z]{1,}\\.as\\.deputy\\.com)\\b", ''),
    keywords: ['deputy'],
  },
  {
    id: 'detectify',
    label: 'Detectify',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['detectify'],
  },
  {
    id: 'detectlanguage',
    label: 'Detectlanguage',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['detectlanguage'],
  },
  {
    id: 'dfuse',
    label: 'Dfuse',
    regex: new RegExp("\\b(web\\_[0-9a-z]{32})\\b", ''),
    keywords: ['dfuse'],
  },
  {
    id: 'diffbot',
    label: 'Diffbot',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['diffbot'],
  },
  {
    id: 'diggernaut',
    label: 'Diggernaut',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['diggernaut'],
  },
  {
    id: 'digitaloceantoken',
    label: 'Digitaloceantoken',
    regex: new RegExp("\\b([A-Za-z0-9_-]{64})\\b", ''),
    keywords: ['digitalocean'],
  },
  {
    id: 'digitaloceanv2',
    label: 'Digitaloceanv2',
    regex: new RegExp("\\b((?:dop|doo|dor)_v1_[a-f0-9]{64})\\b", ''),
    keywords: ['dop_v1_', 'doo_v1_', 'dor_v1_'],
  },
  {
    id: 'discordbottoken-1',
    label: 'Discordbottoken (1)',
    regex: new RegExp("\\b([0-9]{17})\\b", ''),
    keywords: ['discord'],
  },
  {
    id: 'discordbottoken-2',
    label: 'Discordbottoken (2)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{24}\\.[A-Za-z0-9_-]{6}\\.[A-Za-z0-9_-]{27})\\b", ''),
    keywords: ['discord'],
  },
  {
    id: 'discordwebhook',
    label: 'Discordwebhook',
    regex: new RegExp("(https:\\/\\/discord\\.com\\/api\\/webhooks\\/[0-9]{18,19}\\/[0-9a-zA-Z-]{68})", ''),
    keywords: ['https://discord.com/api/webhooks/'],
  },
  {
    id: 'disqus',
    label: 'Disqus',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['disqus'],
  },
  {
    id: 'ditto',
    label: 'Ditto',
    regex: new RegExp("\\b([a-z0-9]{8}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{12}\\.[a-z0-9]{40})\\b", ''),
    keywords: ['ditto'],
  },
  {
    id: 'dnscheck-1',
    label: 'Dnscheck (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['dnscheck'],
  },
  {
    id: 'dnscheck-2',
    label: 'Dnscheck (2)',
    regex: new RegExp("\\b([a-z0-9A-Z-]{36})\\b", ''),
    keywords: ['dnscheck'],
  },
  {
    id: 'docker',
    label: 'Docker',
    regex: new RegExp("{(?:\\s|\\\\+[nrt])*\\\\*\"auths\\\\*\"(?:\\s|\\\\+t)*:(?:\\s|\\\\+t)*{(?:\\s|\\\\+[nrt])*\\\\*\"(?:https?:\\/\\/)?[a-z0-9\\-.:\\/]+\\\\*\"(?:\\s|\\\\+t)*:(?:\\s|\\\\+t)*{(?:(?:\\s|\\\\+[nrt])*\\\\*\"(?:auth|email|username|password)\\\\*\"\\s*:\\s*\\\\*\".*\\\\*\"\\s*,?)+?(?:\\s|\\\\+[nrt])*}(?:\\s|\\\\+[nrt])*}(?:\\s|\\\\+[nrt])*}", 'i'),
    keywords: ['auths'],
  },
  {
    id: 'dockerhub-v1-1',
    label: 'Dockerhub V1 (1)',
    regex: new RegExp("(?:user|usr|-u|id)\\S{0,40}?[:=\\s]{1,3}[ '\"=]?([a-zA-Z0-9]{4,40})\\b", 'im'),
    keywords: ['docker'],
  },
  {
    id: 'dockerhub-v1-2',
    label: 'Dockerhub V1 (2)',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['docker'],
  },
  {
    id: 'dockerhub-v2-1',
    label: 'Dockerhub V2 (1)',
    regex: new RegExp("(?:user|usr|-u|id)\\S{0,40}?[:=\\s]{1,3}[ '\"=]?([a-zA-Z0-9]{4,40})\\b", 'im'),
    keywords: ['docker', 'dckr_pat_', 'dckr_oat_'],
  },
  {
    id: 'dockerhub-v2-2',
    label: 'Dockerhub V2 (2)',
    regex: new RegExp("\\b(dckr_pat_[a-zA-Z0-9_-]{27}|dckr_oat_[a-zA-Z0-9_-]{32})(?:[^a-zA-Z0-9_-]|$)", ''),
    keywords: ['docker', 'dckr_pat_', 'dckr_oat_'],
  },
  {
    id: 'docparser',
    label: 'Docparser',
    regex: new RegExp("\\b([a-f0-9]{40})\\b", ''),
    keywords: ['docparser'],
  },
  {
    id: 'documo',
    label: 'Documo',
    regex: new RegExp("\\b(ey[a-zA-Z0-9]{34}.ey[a-zA-Z0-9]{154}.[a-zA-Z0-9_-]{43})\\b", ''),
    keywords: ['documo'],
  },
  {
    id: 'doppler-1',
    label: 'Doppler (1)',
    regex: new RegExp("\\b(dp\\.pt\\.[a-zA-Z0-9]{43})\\b", ''),
    keywords: ['dp.ct.', 'dp.pt.', 'dp.st', 'dp.sa.', 'dp.scim.', 'dp.audit.'],
  },
  {
    id: 'doppler-2',
    label: 'Doppler (2)',
    regex: new RegExp("\\b(dp\\.(?:ct|pt|st(?:\\.[a-z0-9\\-_]{2,35})?|sa|scim|audit)\\.[a-zA-Z0-9]{40,44})\\b", ''),
    keywords: ['dp.ct.', 'dp.pt.', 'dp.st', 'dp.sa.', 'dp.scim.', 'dp.audit.'],
  },
  {
    id: 'dotdigital-1',
    label: 'Dotdigital (1)',
    regex: new RegExp("\\b(apiuser-[a-z0-9]{12}@apiconnector.com)\\b", ''),
    keywords: ['@apiconnector.com'],
  },
  {
    id: 'dotdigital-2',
    label: 'Dotdigital (2)',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{8,24})\\b", ''),
    keywords: ['@apiconnector.com'],
  },
  {
    id: 'dovico-1',
    label: 'Dovico (1)',
    regex: new RegExp("\\b([0-9a-z]{32}\\.[0-9a-z]{1,}\\b)", ''),
    keywords: ['dovico'],
  },
  {
    id: 'dovico-2',
    label: 'Dovico (2)',
    regex: new RegExp("\\b([0-9a-z]{32}\\.[0-9a-z]{1,}\\b)", ''),
    keywords: ['dovico'],
  },
  {
    id: 'dronahq',
    label: 'Dronahq',
    regex: new RegExp("\\b([a-z0-9]{50})\\b", ''),
    keywords: ['dronahq'],
  },
  {
    id: 'dropbox',
    label: 'Dropbox',
    regex: new RegExp("\\b(sl\\.(u\\.)?[A-Za-z0-9\\-\\_]{130,})\\b", ''),
    keywords: ['dropbox', 'sl.'],
  },
  {
    id: 'duply-1',
    label: 'Duply (1)',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['duply'],
  },
  {
    id: 'duply-2',
    label: 'Duply (2)',
    regex: new RegExp("\\b([0-9A-Z]{7}-[0-9A-Z]{7}-[0-9A-Z]{7}-[0-9A-Z]{7})\\b", ''),
    keywords: ['duply'],
  },
  {
    id: 'dwolla-1',
    label: 'Dwolla (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{50})\\b", ''),
    keywords: ['dwolla'],
  },
  {
    id: 'dwolla-2',
    label: 'Dwolla (2)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{50})\\b", ''),
    keywords: ['dwolla'],
  },
  {
    id: 'dynalist',
    label: 'Dynalist',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{128})\\b", ''),
    keywords: ['dynalist'],
  },
  {
    id: 'dyspatch',
    label: 'Dyspatch',
    regex: new RegExp("\\b([A-Z0-9]{52})\\b", ''),
    keywords: ['dyspatch'],
  },
  {
    id: 'eagleeyenetworks-1',
    label: 'Eagleeyenetworks (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{15})\\b", ''),
    keywords: ['eagleeyenetworks'],
  },
  {
    id: 'eagleeyenetworks-2',
    label: 'Eagleeyenetworks (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{3,20}@[a-zA-Z0-9]{2,12}.[a-zA-Z0-9]{2,5})\\b", ''),
    keywords: ['eagleeyenetworks'],
  },
  {
    id: 'easyinsight-1',
    label: 'Easyinsight (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['easyinsight', 'easy-insight'],
  },
  {
    id: 'easyinsight-2',
    label: 'Easyinsight (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{20})\\b", ''),
    keywords: ['easyinsight', 'easy-insight'],
  },
  {
    id: 'ecostruxureit',
    label: 'Ecostruxureit',
    regex: new RegExp("\\b(AK1[0-9a-zA-Z\\/]{50,55})\\b", ''),
    keywords: ['ecostruxureit'],
  },
  {
    id: 'edamam-1',
    label: 'Edamam (1)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['edamam'],
  },
  {
    id: 'edamam-2',
    label: 'Edamam (2)',
    regex: new RegExp("\\b([0-9a-z]{8})\\b", ''),
    keywords: ['edamam'],
  },
  {
    id: 'edenai',
    label: 'Edenai',
    regex: new RegExp("\\b([a-zA-Z0-9]{36}.[a-zA-Z0-9]{92}.[a-zA-Z0-9_]{43})\\b", ''),
    keywords: ['edenai'],
  },
  {
    id: 'eightxeight-1',
    label: 'Eightxeight (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{43})\\b", ''),
    keywords: ['8x8'],
  },
  {
    id: 'eightxeight-2',
    label: 'Eightxeight (2)',
    regex: new RegExp("\\b([a-zA-Z0-9_]{18,30})\\b", ''),
    keywords: ['8x8'],
  },
  {
    id: 'elasticemail',
    label: 'Elasticemail',
    regex: new RegExp("\\b([A-Za-z0-9_-]{96})\\b", ''),
    keywords: ['elasticemail'],
  },
  {
    id: 'elevenlabs-v1',
    label: 'Elevenlabs V1',
    regex: new RegExp("(?:elevenlabs|xi-api-key|el|token|key)[^\\.].{0,40}[ =:'\"]+([a-f0-9]{32})\\b", 'i'),
    keywords: ['elevenlabs', 'xi-api-key', 'xi_api_key'],
  },
  {
    id: 'elevenlabs-v2',
    label: 'Elevenlabs V2',
    regex: new RegExp("\\b((?:sk)_[a-f0-9]{48})\\b", ''),
    keywords: ['elevenlabs', 'xi-api-key', 'xi_api_key'],
  },
  {
    id: 'enablex-1',
    label: 'Enablex (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{36})\\b", ''),
    keywords: ['enablex'],
  },
  {
    id: 'enablex-2',
    label: 'Enablex (2)',
    regex: new RegExp("\\b([a-z0-9]{24})\\b", ''),
    keywords: ['enablex'],
  },
  {
    id: 'endorlabs',
    label: 'Endorlabs',
    regex: new RegExp("\\b(endr\\+[a-zA-Z0-9-]{16})\\b", ''),
    keywords: ['endr+'],
  },
  {
    id: 'enigma',
    label: 'Enigma',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['enigma'],
  },
  {
    id: 'envoyapikey',
    label: 'Envoyapikey',
    regex: new RegExp("\\b([a-zA-Z0-9]{220})\\b", ''),
    keywords: ['envoy'],
  },
  {
    id: 'eraser',
    label: 'Eraser',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['eraser'],
  },
  {
    id: 'etherscan',
    label: 'Etherscan',
    regex: new RegExp("\\b([0-9A-Z]{34})\\b", ''),
    keywords: ['etherscan'],
  },
  {
    id: 'ethplorer',
    label: 'Ethplorer',
    regex: new RegExp("\\b([a-z0-9A-Z-]{22})\\b", ''),
    keywords: ['ethplorer'],
  },
  {
    id: 'eventbrite',
    label: 'Eventbrite',
    regex: new RegExp("\\b([0-9A-Z]{20})\\b", ''),
    keywords: ['eventbrite'],
  },
  {
    id: 'everhour',
    label: 'Everhour',
    regex: new RegExp("\\b([0-9Aa-f]{4}-[0-9a-f]{4}-[0-9a-f]{6}-[0-9a-f]{6}-[0-9a-f]{8})\\b", ''),
    keywords: ['everhour'],
  },
  {
    id: 'exchangerateapi',
    label: 'Exchangerateapi',
    regex: new RegExp("\\b([a-f0-9]{24})\\b", ''),
    keywords: ['exchangerate', 'exchange-rate'],
  },
  {
    id: 'exchangeratesapi',
    label: 'Exchangeratesapi',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['exchangerates'],
  },
  {
    id: 'exportsdk-1',
    label: 'Exportsdk (1)',
    regex: new RegExp("\\b([0-9a-z]{5,15}_[0-9a-z-]{36})\\b", ''),
    keywords: ['exportsdk'],
  },
  {
    id: 'exportsdk-2',
    label: 'Exportsdk (2)',
    regex: new RegExp("\\b([0-9a-z-]{36})\\b", ''),
    keywords: ['exportsdk'],
  },
  {
    id: 'extractorapi',
    label: 'Extractorapi',
    regex: new RegExp("\\b([a-zA-Z-0-9]{40})\\b", ''),
    keywords: ['extractorapi'],
  },
  {
    id: 'facebookoauth-1',
    label: 'Facebookoauth (1)',
    regex: new RegExp("\\b([0-9]{15,18})\\b", ''),
    keywords: ['facebook'],
  },
  {
    id: 'facebookoauth-2',
    label: 'Facebookoauth (2)',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['facebook'],
  },
  {
    id: 'faceplusplus-1',
    label: 'Faceplusplus (1)',
    regex: new RegExp("\\b([0-9a-zA-Z_-]{32})\\b", ''),
    keywords: ['faceplusplus'],
  },
  {
    id: 'faceplusplus-2',
    label: 'Faceplusplus (2)',
    regex: new RegExp("\\b([0-9a-zA-Z_-]{32})\\b", ''),
    keywords: ['faceplusplus'],
  },
  {
    id: 'fastforex',
    label: 'Fastforex',
    regex: new RegExp("\\b([a-z0-9-]{28})\\b", ''),
    keywords: ['fastforex'],
  },
  {
    id: 'fastlypersonaltoken',
    label: 'Fastlypersonaltoken',
    regex: new RegExp("\\b([A-Za-z0-9_-]{32})\\b", ''),
    keywords: ['fastly'],
  },
  {
    id: 'feedier',
    label: 'Feedier',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['feedier'],
  },
  {
    id: 'fetchrss',
    label: 'Fetchrss',
    regex: new RegExp("\\b([a-zA-Z0-9.]{40})\\b", ''),
    keywords: ['fetchrss'],
  },
  {
    id: 'fibery-1',
    label: 'Fibery (1)',
    regex: new RegExp("\\b([0-9a-f]{8}\\.[0-9a-f]{35})\\b", ''),
    keywords: ['.fibery.io'],
  },
  {
    id: 'fibery-2',
    label: 'Fibery (2)',
    regex: new RegExp("(?:https?:\\/\\/)?([a-zA-Z0-9-]{1,63})\\.fibery\\.io(?:\\/.*)?", ''),
    keywords: ['.fibery.io'],
  },
  {
    id: 'figmapersonalaccesstoken-v1',
    label: 'Figmapersonalaccesstoken V1',
    regex: new RegExp("\\b([0-9]{6}-[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['figma'],
  },
  {
    id: 'figmapersonalaccesstoken-v2',
    label: 'Figmapersonalaccesstoken V2',
    regex: new RegExp("\\b(fig[d|((u|o)(r|h)?)]_[a-z0-9A-Z_-]{40})\\b", ''),
    keywords: ['figma'],
  },
  {
    id: 'fileio',
    label: 'Fileio',
    regex: new RegExp("\\b([A-Z0-9.-]{39})\\b", ''),
    keywords: ['fileio'],
  },
  {
    id: 'finage',
    label: 'Finage',
    regex: new RegExp("\\b(API_KEY[0-9A-Z]{32})\\b", ''),
    keywords: ['finage'],
  },
  {
    id: 'findl',
    label: 'Findl',
    regex: new RegExp("\\b([a-z0-9]{8}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{12})\\b", ''),
    keywords: ['findl'],
  },
  {
    id: 'finnhub',
    label: 'Finnhub',
    regex: new RegExp("\\b([0-9a-z]{20})\\b", ''),
    keywords: ['finnhub'],
  },
  {
    id: 'fixerio',
    label: 'Fixerio',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['fixer'],
  },
  {
    id: 'flatio',
    label: 'Flatio',
    regex: new RegExp("\\b([0-9a-z]{128})\\b", ''),
    keywords: ['flat'],
  },
  {
    id: 'fleetbase',
    label: 'Fleetbase',
    regex: new RegExp("\\b(flb_live_[0-9a-zA-Z]{20})\\b", ''),
    keywords: ['fleetbase'],
  },
  {
    id: 'flexport',
    label: 'Flexport',
    regex: new RegExp("\\b(shltm_[0-9a-zA-Z-_]{40})", ''),
    keywords: ['shltm_'],
  },
  {
    id: 'flickr',
    label: 'Flickr',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['flickr'],
  },
  {
    id: 'flightapi',
    label: 'Flightapi',
    regex: new RegExp("\\b([a-z0-9]{24})\\b", ''),
    keywords: ['flightapi'],
  },
  {
    id: 'flightlabs',
    label: 'Flightlabs',
    regex: new RegExp("\\b(eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9\\.ey[a-zA-Z0-9_-]+\\.[a-zA-Z0-9_-]{86})\\b", ''),
    keywords: ['eyj0exaioijkv1qilcjhbgcioijsuzi1nij9'],
  },
  {
    id: 'flightstats-1',
    label: 'Flightstats (1)',
    regex: new RegExp("\\b([0-9a-z]{8})\\b", ''),
    keywords: ['flightstats'],
  },
  {
    id: 'flightstats-2',
    label: 'Flightstats (2)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['flightstats'],
  },
  {
    id: 'float',
    label: 'Float',
    regex: new RegExp("\\b([a-f0-9]{16}[A-Za-z0-9+/]{42,43}=)", ''),
    keywords: ['float'],
  },
  {
    id: 'flowflu-1',
    label: 'Flowflu (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{51})\\b", ''),
    keywords: ['flowflu'],
  },
  {
    id: 'flowflu-2',
    label: 'Flowflu (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{4,30})\\b", ''),
    keywords: ['flowflu'],
  },
  {
    id: 'flutterwave',
    label: 'Flutterwave',
    regex: new RegExp("\\b(FLWSECK-[0-9a-z]{32}-X)\\b", ''),
    keywords: ['flwseck-'],
  },
  {
    id: 'flyio',
    label: 'Flyio',
    regex: new RegExp("\\b(FlyV1 fm\\d+_[A-Za-z0-9+\\/=,_-]{500,700})\\b", ''),
    keywords: ['flyv1'],
  },
  {
    id: 'fmfw-1',
    label: 'Fmfw (1)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{32})\\b", ''),
    keywords: ['fmfw'],
  },
  {
    id: 'fmfw-2',
    label: 'Fmfw (2)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{32})\\b", ''),
    keywords: ['fmfw'],
  },
  {
    id: 'formbucket',
    label: 'Formbucket',
    regex: new RegExp("\\b([0-9A-Za-z]{1,}.[0-9A-Za-z]{1,}\\.[0-9A-Z-a-z\\-_]{1,})", ''),
    keywords: ['formbucket'],
  },
  {
    id: 'formcraft',
    label: 'Formcraft',
    regex: new RegExp("\\b([0-9a-z]{16})\\b", ''),
    keywords: ['formcraft'],
  },
  {
    id: 'formio',
    label: 'Formio',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9\\.[0-9A-Za-z]{220,310}\\.[0-9A-Z-a-z\\-_]{43}[ \\r\\n]{1})", ''),
    keywords: ['formio'],
  },
  {
    id: 'formsite-1',
    label: 'Formsite (1)',
    regex: new RegExp("\\b(fs[0-9]{1,4})\\b", ''),
    keywords: ['formsite'],
  },
  {
    id: 'formsite-2',
    label: 'Formsite (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{6})\\b", ''),
    keywords: ['formsite'],
  },
  {
    id: 'foursquare-1',
    label: 'Foursquare (1)',
    regex: new RegExp("\\b([0-9A-Z]{48})\\b", ''),
    keywords: ['foursquare'],
  },
  {
    id: 'foursquare-2',
    label: 'Foursquare (2)',
    regex: new RegExp("\\b([0-9A-Z]{48})\\b", ''),
    keywords: ['foursquare'],
  },
  {
    id: 'frameio',
    label: 'Frameio',
    regex: new RegExp("\\b(fio-u-[0-9a-zA-Z_-]{64})\\b", ''),
    keywords: ['fio-u-'],
  },
  {
    id: 'freshbooks-1',
    label: 'Freshbooks (1)',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['freshbooks'],
  },
  {
    id: 'freshbooks-2',
    label: 'Freshbooks (2)',
    regex: new RegExp("\\b(https://www.[0-9A-Za-z_-]{1,}.com)\\b", ''),
    keywords: ['freshbooks'],
  },
  {
    id: 'freshdesk-1',
    label: 'Freshdesk (1)',
    regex: new RegExp("\\b([0-9a-z-]{1,}\\.freshdesk\\.com)\\b", ''),
    keywords: ['freshdesk'],
  },
  {
    id: 'freshdesk-2',
    label: 'Freshdesk (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{20})\\b", ''),
    keywords: ['freshdesk'],
  },
  {
    id: 'front',
    label: 'Front',
    regex: new RegExp("\\b([0-9a-zA-Z]{36}.[0-9a-zA-Z\\.\\-\\_]{188,244})\\b", ''),
    keywords: ['front'],
  },
  {
    id: 'ftp',
    label: 'FTP',
    regex: new RegExp("\\bftp://[\\S]{3,50}:([\\S]{3,50})@[-.%\\w\\/:]+\\b", ''),
    keywords: ['ftp://'],
  },
  {
    id: 'fulcrum',
    label: 'Fulcrum',
    regex: new RegExp("\\b([a-z0-9]{80})\\b", ''),
    keywords: ['fulcrum'],
  },
  {
    id: 'fullstory-v1',
    label: 'Fullstory V1',
    regex: new RegExp("\\b([a-zA-Z-0-9/+]{88})\\b", ''),
    keywords: ['fullstory'],
  },
  {
    id: 'fullstory-v2',
    label: 'Fullstory V2',
    regex: new RegExp("\\b(na1\\.[A-Za-z0-9\\+\\/]{100})\\b", ''),
    keywords: ['fullstory'],
  },
  {
    id: 'fxmarket',
    label: 'Fxmarket',
    regex: new RegExp("\\b([0-9Aa-zA-Z-_=]{20})\\b", ''),
    keywords: ['fxmarket'],
  },
  {
    id: 'gcp',
    label: 'GCP',
    regex: new RegExp("\\{[^{]+auth_provider_x509_cert_url[^}]+\\}", ''),
    keywords: ['provider_x509'],
  },
  {
    id: 'gcpapplicationdefaultcredentials',
    label: 'Gcpapplicationdefaultcredentials',
    regex: new RegExp("\\{[^{]+client_secret[^}]+\\}", ''),
    keywords: ['.apps.googleusercontent.com'],
  },
  {
    id: 'geckoboard',
    label: 'Geckoboard',
    regex: new RegExp("\\b([a-zA-Z0-9]{44})\\b", ''),
    keywords: ['geckoboard'],
  },
  {
    id: 'gemini-1',
    label: 'Gemini (1)',
    regex: new RegExp("\\b((?:master-|account-)[0-9A-Za-z]{20})\\b", ''),
    keywords: ['master-', 'account-'],
  },
  {
    id: 'gemini-2',
    label: 'Gemini (2)',
    regex: new RegExp("[A-Za-z0-9]{27,28}", ''),
    keywords: ['master-', 'account-'],
  },
  {
    id: 'gengo-1',
    label: 'Gengo (1)',
    regex: new RegExp("([ ]{0,1}[0-9a-zA-Z\\[\\]\\-\\(\\)\\{\\}|_^@$=~]{64}[ \\r\\n]{1})", ''),
    keywords: ['gengo'],
  },
  {
    id: 'gengo-2',
    label: 'Gengo (2)',
    regex: new RegExp("([ ]{0,1}[0-9a-zA-Z\\[\\]\\-\\(\\)\\{\\}|_^@$=~]{64}[ \\r\\n]{1})", ''),
    keywords: ['gengo'],
  },
  {
    id: 'geoapify',
    label: 'Geoapify',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['geoapify'],
  },
  {
    id: 'geocode',
    label: 'Geocode',
    regex: new RegExp("\\b([a-z0-9]{28})\\b", ''),
    keywords: ['geocode'],
  },
  {
    id: 'geocodify',
    label: 'Geocodify',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['geocodify'],
  },
  {
    id: 'geocodio-1',
    label: 'Geocodio (1)',
    regex: new RegExp("\\b([a-z0-9]{39})\\b", ''),
    keywords: ['geocod'],
  },
  {
    id: 'geocodio-2',
    label: 'Geocodio (2)',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{7,30})\\b", ''),
    keywords: ['geocod'],
  },
  {
    id: 'geoipifi',
    label: 'Geoipifi',
    regex: new RegExp("\\b([a-z0-9A-Z_]{32})\\b", ''),
    keywords: ['ipifi'],
  },
  {
    id: 'getemail',
    label: 'Getemail',
    regex: new RegExp("\\b([a-zA-Z0-9-]{20})\\b", ''),
    keywords: ['getemail'],
  },
  {
    id: 'getemails-1',
    label: 'Getemails (1)',
    regex: new RegExp("\\b([a-z0-9-]{26})\\b", ''),
    keywords: ['getemails'],
  },
  {
    id: 'getemails-2',
    label: 'Getemails (2)',
    regex: new RegExp("\\b([a-z0-9-]{18})\\b", ''),
    keywords: ['getemails'],
  },
  {
    id: 'getgeoapi',
    label: 'Getgeoapi',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['getgeoapi'],
  },
  {
    id: 'getgist',
    label: 'Getgist',
    regex: new RegExp("\\b([a-z0-9A-Z+=]{68})", ''),
    keywords: ['getgist'],
  },
  {
    id: 'getresponse',
    label: 'Getresponse',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['getresponse'],
  },
  {
    id: 'getsandbox-1',
    label: 'Getsandbox (1)',
    regex: new RegExp("\\b([a-z0-9-]{40})\\b", ''),
    keywords: ['getsandbox'],
  },
  {
    id: 'getsandbox-2',
    label: 'Getsandbox (2)',
    regex: new RegExp("\\b([a-z0-9-]{15,30})\\b", ''),
    keywords: ['getsandbox'],
  },
  {
    id: 'github-v2',
    label: 'Github V2',
    regex: new RegExp("\\b((?:ghp|gho|ghu|ghs|ghr|github_pat)_[a-zA-Z0-9_]{36,255})\\b", ''),
    keywords: ['ghp_', 'gho_', 'ghu_', 'ghs_', 'ghr_', 'github_pat_'],
  },
  {
    id: 'github_oauth2-1',
    label: 'Github_oauth2 (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{20})\\b", ''),
    keywords: ['github'],
  },
  {
    id: 'github_oauth2-2',
    label: 'Github_oauth2 (2)',
    regex: new RegExp("\\b([a-f0-9]{40})\\b", ''),
    keywords: ['github'],
  },
  {
    id: 'githubapp-1',
    label: 'Githubapp (1)',
    regex: new RegExp("\\b([0-9]{6})\\b", ''),
    keywords: ['github'],
  },
  {
    id: 'githubapp-2',
    label: 'Githubapp (2)',
    regex: new RegExp("(-----BEGIN RSA PRIVATE KEY-----\\s[A-Za-z0-9+\\/\\s]*\\s-----END RSA PRIVATE KEY-----)", ''),
    keywords: ['github'],
  },
  {
    id: 'gitlab-v1',
    label: 'Gitlab V1',
    regex: new RegExp("\\b([a-zA-Z0-9][a-zA-Z0-9\\-=_]{19,21})\\b", ''),
    keywords: ['gitlab'],
  },
  {
    id: 'gitlab-v2',
    label: 'Gitlab V2',
    regex: new RegExp("\\b(glpat-[a-zA-Z0-9\\-=_]{20,22})\\b", ''),
    keywords: ['glpat-'],
  },
  {
    id: 'gitlab-v3',
    label: 'Gitlab V3',
    regex: new RegExp("\\b(glpat-[a-zA-Z0-9\\-=_]{27,300}.[0-9a-z]{2}.[a-z0-9]{9})\\b", ''),
    keywords: ['glpat-'],
  },
  {
    id: 'gitter',
    label: 'Gitter',
    regex: new RegExp("\\b([a-z0-9-]{40})\\b", ''),
    keywords: ['gitter'],
  },
  {
    id: 'glassnode',
    label: 'Glassnode',
    regex: new RegExp("\\b([0-9A-Za-z]{27})\\b", ''),
    keywords: ['glassnode'],
  },
  {
    id: 'gocanvas',
    label: 'Gocanvas',
    regex: new RegExp("\\b([0-9A-Za-z/+]{43}=[ \\r\\n]{1})", ''),
    keywords: ['gocanvas'],
  },
  {
    id: 'gocardless',
    label: 'Gocardless',
    regex: new RegExp("\\b(live_[0-9A-Za-z\\_\\-]{40}[ \"'\\r\\n]{1})", ''),
    keywords: ['gocardless'],
  },
  {
    id: 'goodday',
    label: 'Goodday',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['goodday'],
  },
  {
    id: 'googleoauth2',
    label: 'Googleoauth2',
    regex: new RegExp("\\b(ya29\\.(?:[a-z0-9_-]{10,}))(?:[^a-z0-9_-]|$)", 'i'),
    keywords: ['ya29.'],
  },
  {
    id: 'grafana',
    label: 'Grafana',
    regex: new RegExp("\\b(glc_eyJ[A-Za-z0-9+\\/=]{60,160})", ''),
    keywords: ['glc_eyj'],
  },
  {
    id: 'grafanaserviceaccount-1',
    label: 'Grafanaserviceaccount (1)',
    regex: new RegExp("\\b(glsa_[0-9a-zA-Z_]{41})\\b", ''),
    keywords: ['glsa_'],
  },
  {
    id: 'grafanaserviceaccount-2',
    label: 'Grafanaserviceaccount (2)',
    regex: new RegExp("\\b([a-zA-Z0-9-]+\\.grafana\\.net)\\b", ''),
    keywords: ['glsa_'],
  },
  {
    id: 'graphcms-1',
    label: 'Graphcms (1)',
    regex: new RegExp("\\b(ey[a-zA-Z0-9]{73}.ey[a-zA-Z0-9]{365}.[a-zA-Z0-9_-]{683})\\b", ''),
    keywords: ['graphcms'],
  },
  {
    id: 'graphcms-2',
    label: 'Graphcms (2)',
    regex: new RegExp("\\b([a-z0-9]{25})\\b", ''),
    keywords: ['graphcms'],
  },
  {
    id: 'graphhopper',
    label: 'Graphhopper',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['graphhopper'],
  },
  {
    id: 'groovehq',
    label: 'Groovehq',
    regex: new RegExp("\\b([a-z0-9A-Z]{64})", ''),
    keywords: ['groovehq'],
  },
  {
    id: 'groq',
    label: 'Groq',
    regex: new RegExp("\\b(gsk_[a-zA-Z0-9]{52})\\b", ''),
    keywords: ['gsk_'],
  },
  {
    id: 'gtmetrix',
    label: 'Gtmetrix',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['gtmetrix'],
  },
  {
    id: 'guardianapi',
    label: 'Guardianapi',
    regex: new RegExp("\\b([0-9Aa-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['guardianapi'],
  },
  {
    id: 'gumroad',
    label: 'Gumroad',
    regex: new RegExp("\\b([a-z0-9A-Z-]{43})\\b", ''),
    keywords: ['gumroad'],
  },
  {
    id: 'guru-1',
    label: 'Guru (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{3,20}@[a-zA-Z0-9]{2,12}.[a-zA-Z0-9]{2,5})\\b", ''),
    keywords: ['guru'],
  },
  {
    id: 'guru-2',
    label: 'Guru (2)',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['guru'],
  },
  {
    id: 'gyazo',
    label: 'Gyazo',
    regex: new RegExp("\\b([0-9A-Za-z-]{43})\\b", ''),
    keywords: ['gyazo'],
  },
  {
    id: 'happyscribe',
    label: 'Happyscribe',
    regex: new RegExp("\\b([0-9a-zA-Z]{24})\\b", ''),
    keywords: ['happyscribe'],
  },
  {
    id: 'harness',
    label: 'Harness',
    regex: new RegExp("\\b(pat\\.[A-Za-z0-9]{22}\\.[0-9a-f]{24}\\.[A-Za-z0-9]{20})\\b", ''),
    keywords: ['harness'],
  },
  {
    id: 'harvest-1',
    label: 'Harvest (1)',
    regex: new RegExp("\\b([a-z0-9A-Z._]{97})\\b", ''),
    keywords: ['harvest'],
  },
  {
    id: 'harvest-2',
    label: 'Harvest (2)',
    regex: new RegExp("\\b([0-9]{4,9})\\b", ''),
    keywords: ['harvest'],
  },
  {
    id: 'hashicorpvaultauth-1',
    label: 'Hashicorpvaultauth (1)',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['hashicorp'],
  },
  {
    id: 'hashicorpvaultauth-2',
    label: 'Hashicorpvaultauth (2)',
    regex: new RegExp("\\b([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\\b", ''),
    keywords: ['hashicorp'],
  },
  {
    id: 'hashicorpvaultauth-3',
    label: 'Hashicorpvaultauth (3)',
    regex: new RegExp("(https?:\\/\\/[^\\s\\/]*\\.hashicorp\\.cloud(?::\\d+)?)(?:\\/[^\\s]*)?", ''),
    keywords: ['hashicorp'],
  },
  {
    id: 'hasura-1',
    label: 'Hasura (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]+\\.hasura\\.app)\\b", ''),
    keywords: ['hasura'],
  },
  {
    id: 'hasura-2',
    label: 'Hasura (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['hasura'],
  },
  {
    id: 'hellosign',
    label: 'Hellosign',
    regex: new RegExp("\\b([a-zA-Z-0-9/+]{64})\\b", ''),
    keywords: ['hellosign'],
  },
  {
    id: 'helpcrunch',
    label: 'Helpcrunch',
    regex: new RegExp("\\b([a-zA-Z-0-9+/=]{328})", ''),
    keywords: ['helpcrunch'],
  },
  {
    id: 'helpscout',
    label: 'Helpscout',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['helpscout'],
  },
  {
    id: 'hereapi',
    label: 'Hereapi',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{43})\\b", ''),
    keywords: ['hereapi'],
  },
  {
    id: 'heroku-v1',
    label: 'Heroku V1',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['heroku'],
  },
  {
    id: 'heroku-v2',
    label: 'Heroku V2',
    regex: new RegExp("\\b(HRKU-AA[0-9a-zA-Z_-]{58})\\b", ''),
    keywords: ['hrku-aa'],
  },
  {
    id: 'hive-1',
    label: 'Hive (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{17})\\b", ''),
    keywords: ['hive'],
  },
  {
    id: 'hive-2',
    label: 'Hive (2)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['hive'],
  },
  {
    id: 'hiveage',
    label: 'Hiveage',
    regex: new RegExp("\\b([0-9A-Za-z\\_\\-]{20})\\b", ''),
    keywords: ['hiveage'],
  },
  {
    id: 'holidayapi',
    label: 'Holidayapi',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['holidayapi'],
  },
  {
    id: 'holistic',
    label: 'Holistic',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['holistic'],
  },
  {
    id: 'honeycomb',
    label: 'Honeycomb',
    regex: new RegExp("\\b([0-9a-f]{32}|[0-9a-zA-Z]{22})\\b", ''),
    keywords: ['honeycomb'],
  },
  {
    id: 'host',
    label: 'Host',
    regex: new RegExp("\\b([a-z0-9]{14})\\b", ''),
    keywords: ['host.io'],
  },
  {
    id: 'html2pdf',
    label: 'Html2pdf',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['html2pdf'],
  },
  {
    id: 'hubspot_apikey-v1',
    label: 'Hubspot_apikey V1',
    regex: new RegExp("\\b([a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})\\b", ''),
    keywords: ['hubapi', 'hapikey', 'hapi_key', 'hubspot'],
  },
  {
    id: 'hubspot_apikey-v2',
    label: 'Hubspot_apikey V2',
    regex: new RegExp("\\b(pat-(?:eu|na)1-[A-Za-z0-9]{8}\\-[A-Za-z0-9]{4}\\-[A-Za-z0-9]{4}\\-[A-Za-z0-9]{4}\\-[A-Za-z0-9]{12})\\b", ''),
    keywords: ['pat-na1-', 'pat-eu1-'],
  },
  {
    id: 'huggingface',
    label: 'Huggingface',
    regex: new RegExp("\\b(?:hf_|api_org_)[a-zA-Z0-9]{34}\\b", ''),
    keywords: ['hf_', 'api_org_'],
  },
  {
    id: 'humanity',
    label: 'Humanity',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['humanity'],
  },
  {
    id: 'hunter',
    label: 'Hunter',
    regex: new RegExp("\\b([a-z0-9_-]{40})\\b", ''),
    keywords: ['hunter'],
  },
  {
    id: 'hybiscus',
    label: 'Hybiscus',
    regex: new RegExp("\\b([0-9a-zA-Z]{43})\\b", ''),
    keywords: ['hybiscus'],
  },
  {
    id: 'hypertrack-1',
    label: 'Hypertrack (1)',
    regex: new RegExp("\\b([0-9a-zA-Z\\_\\-]{27})\\b", ''),
    keywords: ['hypertrack'],
  },
  {
    id: 'hypertrack-2',
    label: 'Hypertrack (2)',
    regex: new RegExp("\\b([0-9a-zA-Z\\_\\-]{54})\\b", ''),
    keywords: ['hypertrack'],
  },
  {
    id: 'ibmclouduserkey',
    label: 'Ibmclouduserkey',
    regex: new RegExp("\\b([A-Za-z0-9_-]{44})\\b", ''),
    keywords: ['ibm'],
  },
  {
    id: 'iconfinder',
    label: 'Iconfinder',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['iconfinder'],
  },
  {
    id: 'iexapis',
    label: 'Iexapis',
    regex: new RegExp("\\b(sk_[a-z0-9]{32})\\b", ''),
    keywords: ['iexapis'],
  },
  {
    id: 'iexcloud',
    label: 'Iexcloud',
    regex: new RegExp("\\b([a-z0-9_]{35})\\b", ''),
    keywords: ['iexcloud'],
  },
  {
    id: 'imagekit',
    label: 'Imagekit',
    regex: new RegExp("\\b([a-zA-Z0-9_=]{36})", ''),
    keywords: ['imagekit'],
  },
  {
    id: 'imagga',
    label: 'Imagga',
    regex: new RegExp("\\b([a-z0-9A-Z=]{72})", ''),
    keywords: ['imagga'],
  },
  {
    id: 'impala',
    label: 'Impala',
    regex: new RegExp("\\b([0-9A-Za-z_]{46})\\b", ''),
    keywords: ['impala'],
  },
  {
    id: 'infura',
    label: 'Infura',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['infura'],
  },
  {
    id: 'insightly',
    label: 'Insightly',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['insightly'],
  },
  {
    id: 'instabot',
    label: 'Instabot',
    regex: new RegExp("\\b([0-9a-zA-Z=+\\/]{43}[0-9a-zA-Z+\\/=]{1})", ''),
    keywords: ['instabot'],
  },
  {
    id: 'instamojo-1',
    label: 'Instamojo (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{40})\\b", ''),
    keywords: ['instamojo'],
  },
  {
    id: 'instamojo-2',
    label: 'Instamojo (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{128})\\b", ''),
    keywords: ['instamojo'],
  },
  {
    id: 'intercom',
    label: 'Intercom',
    regex: new RegExp("\\b([a-zA-Z0-9\\W\\S]{59}\\=)", ''),
    keywords: ['intercom'],
  },
  {
    id: 'interseller',
    label: 'Interseller',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['interseller'],
  },
  {
    id: 'intra42-1',
    label: 'Intra42 (1)',
    regex: new RegExp("\\b(s-s4t2(?:ud|af)-[a-f0-9]{64})\\b", ''),
    keywords: ['s-s4t2ud-', 's-s4t2af-'],
  },
  {
    id: 'intra42-2',
    label: 'Intra42 (2)',
    regex: new RegExp("\\b(u-s4t2(?:ud|af)-[a-f0-9]{64})\\b", ''),
    keywords: ['s-s4t2ud-', 's-s4t2af-'],
  },
  {
    id: 'intrinio',
    label: 'Intrinio',
    regex: new RegExp("\\b([a-zA-Z0-9]{44})\\b", ''),
    keywords: ['intrinio'],
  },
  {
    id: 'invoiceocean-1',
    label: 'Invoiceocean (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{20})\\b", ''),
    keywords: ['invoiceocean'],
  },
  {
    id: 'invoiceocean-2',
    label: 'Invoiceocean (2)',
    regex: new RegExp("\\b([0-9a-z]{1,}\\.invoiceocean\\.com)\\b", ''),
    keywords: ['invoiceocean'],
  },
  {
    id: 'ip2location',
    label: 'Ip2location',
    regex: new RegExp("\\b([0-9A-Z]{32})\\b", ''),
    keywords: ['ip2location'],
  },
  {
    id: 'ipapi',
    label: 'Ipapi',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['ipapi'],
  },
  {
    id: 'ipgeolocation',
    label: 'Ipgeolocation',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['ipgeolocation'],
  },
  {
    id: 'ipinfo',
    label: 'Ipinfo',
    regex: new RegExp("\\b([a-f0-9]{14})\\b", ''),
    keywords: ['ipinfo'],
  },
  {
    id: 'ipinfodb',
    label: 'Ipinfodb',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['ipinfodb'],
  },
  {
    id: 'ipquality',
    label: 'Ipquality',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['ipquality'],
  },
  {
    id: 'ipstack',
    label: 'Ipstack',
    regex: new RegExp("\\b([a-fA-F0-9]{32})\\b", ''),
    keywords: ['ipstack'],
  },
  {
    id: 'jdbc-1',
    label: 'Jdbc (1)',
    regex: new RegExp("jdbc:[\\w]{3,10}:[^\\s\"'<>,{}[\\]]{10,511}[A-Za-z0-9]", 'i'),
    keywords: ['jdbc'],
  },
  {
    id: 'jdbc-2',
    label: 'Jdbc (2)',
    regex: new RegExp("pass.*?=(.+?)\\b", 'i'),
    keywords: ['jdbc'],
  },
  {
    id: 'jiratoken-v1-1',
    label: 'Jiratoken V1 (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{24})\\b", ''),
    keywords: ['atlassian', 'confluence', 'jira'],
  },
  {
    id: 'jiratoken-v1-2',
    label: 'Jiratoken V1 (2)',
    regex: new RegExp("\\b((?:[a-zA-Z0-9-]{1,24}\\.)+[a-zA-Z0-9-]{2,24}\\.[a-zA-Z0-9-]{2,16})\\b", ''),
    keywords: ['atlassian', 'confluence', 'jira'],
  },
  {
    id: 'jiratoken-v2-1',
    label: 'Jiratoken V2 (1)',
    regex: new RegExp("\\b(ATATT[A-Za-z0-9+/=_-]+=[A-Za-z0-9]{8})\\b", ''),
    keywords: ['atlassian', 'confluence', 'jira'],
  },
  {
    id: 'jiratoken-v2-2',
    label: 'Jiratoken V2 (2)',
    regex: new RegExp("\\b((?:[a-zA-Z0-9-]{1,24}\\.)+[a-zA-Z0-9-]{2,24}\\.[a-zA-Z0-9-]{2,16})\\b", ''),
    keywords: ['atlassian', 'confluence', 'jira'],
  },
  {
    id: 'jotform',
    label: 'Jotform',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['jotform'],
  },
  {
    id: 'jumpcloud',
    label: 'Jumpcloud',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['jumpcloud'],
  },
  {
    id: 'jupiterone',
    label: 'Jupiterone',
    regex: new RegExp("\\b([0-9a-zA-Z]{76})\\b", ''),
    keywords: ['jupiterone'],
  },
  {
    id: 'juro',
    label: 'Juro',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['juro'],
  },
  {
    id: 'jwt',
    label: 'JWT',
    regex: new RegExp("\\b((?:eyJ|ewogIC|ewoid)[A-Za-z0-9_-]{12,}={0,2}\\.(?:eyJ|ewo)[A-Za-z0-9_-]{12,}={0,2}\\.[A-Za-z0-9_-]{12,})\\b", ''),
    keywords: ['ewogic', 'ewoid', 'eyj'],
  },
  {
    id: 'kanban-1',
    label: 'Kanban (1)',
    regex: new RegExp("\\b([0-9A-Z]{12})\\b", ''),
    keywords: ['kanban'],
  },
  {
    id: 'kanban-2',
    label: 'Kanban (2)',
    regex: new RegExp("\\b([0-9a-z]{1,}\\.kanbantool\\.com)\\b", ''),
    keywords: ['kanban'],
  },
  {
    id: 'kanbantool-1',
    label: 'Kanbantool (1)',
    regex: new RegExp("\\b([0-9A-Z]{12})\\b", ''),
    keywords: ['kanbantool'],
  },
  {
    id: 'kanbantool-2',
    label: 'Kanbantool (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{2,22})\\b", ''),
    keywords: ['kanbantool'],
  },
  {
    id: 'karmacrm',
    label: 'Karmacrm',
    regex: new RegExp("\\b([a-zA-Z0-9]{20})\\b", ''),
    keywords: ['karmacrm'],
  },
  {
    id: 'keenio-1',
    label: 'Keenio (1)',
    regex: new RegExp("\\b([0-9A-Z]{64})\\b", ''),
    keywords: ['keen'],
  },
  {
    id: 'keenio-2',
    label: 'Keenio (2)',
    regex: new RegExp("\\b([0-9a-z]{24})\\b", ''),
    keywords: ['keen'],
  },
  {
    id: 'kickbox',
    label: 'Kickbox',
    regex: new RegExp("\\b([a-zA-Z0-9_]+[a-zA-Z0-9]{64})\\b", ''),
    keywords: ['kickbox'],
  },
  {
    id: 'klaviyo',
    label: 'Klaviyo',
    regex: new RegExp("\\b(pk_[a-zA-Z0-9]{34})\\b", ''),
    keywords: ['pk_'],
  },
  {
    id: 'klipfolio',
    label: 'Klipfolio',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['klipfolio'],
  },
  {
    id: 'knapsackpro',
    label: 'Knapsackpro',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['knapsackpro'],
  },
  {
    id: 'kraken-1',
    label: 'Kraken (1)',
    regex: new RegExp("\\b([0-9A-Za-z\\/\\+=]{56}[ \"'\\r\\n]{1})", ''),
    keywords: ['kraken'],
  },
  {
    id: 'kraken-2',
    label: 'Kraken (2)',
    regex: new RegExp("\\b([0-9A-Za-z\\/\\+=]{86,88}[ \"'\\r\\n]{1})", ''),
    keywords: ['kraken'],
  },
  {
    id: 'kucoin-1',
    label: 'Kucoin (1)',
    regex: new RegExp("\\b([0-9a-f]{24})\\b", ''),
    keywords: ['kucoin'],
  },
  {
    id: 'kucoin-2',
    label: 'Kucoin (2)',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['kucoin'],
  },
  {
    id: 'kucoin-3',
    label: 'Kucoin (3)',
    regex: new RegExp("([ \\r\\n]{1}[!-~]{7,32}[ \\r\\n]{1})", ''),
    keywords: ['kucoin'],
  },
  {
    id: 'kylas',
    label: 'Kylas',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['kylas'],
  },
  {
    id: 'langfuse-1',
    label: 'Langfuse (1)',
    regex: new RegExp("\\b(pk-lf-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['pk-lf-', 'sk-lf-'],
  },
  {
    id: 'langfuse-2',
    label: 'Langfuse (2)',
    regex: new RegExp("\\b(sk-lf-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['pk-lf-', 'sk-lf-'],
  },
  {
    id: 'langsmith',
    label: 'Langsmith',
    regex: new RegExp("\\b(lsv2_(?:pt|sk)_[a-f0-9]{32}_[a-f0-9]{10})\\b", ''),
    keywords: ['lsv2_pt_', 'lsv2_sk_'],
  },
  {
    id: 'languagelayer',
    label: 'Languagelayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['languagelayer'],
  },
  {
    id: 'larksuite-1',
    label: 'Larksuite (1)',
    regex: new RegExp("(?:^|[^-])\\b(t-[a-z0-9A-Z_.]{14,50})\\b(?:[^-]|$)", ''),
    keywords: ['lark', 'larksuite'],
  },
  {
    id: 'larksuite-2',
    label: 'Larksuite (2)',
    regex: new RegExp("(?:^|[^-])\\b(u-[a-z0-9A-Z_.]{14,50})\\b(?:[^-]|$)", ''),
    keywords: ['lark', 'larksuite'],
  },
  {
    id: 'larksuite-3',
    label: 'Larksuite (3)',
    regex: new RegExp("(?:^|[^-])\\b(a-[a-z0-9A-Z_.]{14,50})\\b(?:[^-]|$)", ''),
    keywords: ['lark', 'larksuite'],
  },
  {
    id: 'larksuiteapikey-1',
    label: 'Larksuiteapikey (1)',
    regex: new RegExp("\\b(cli_[a-z0-9A-Z]{16})\\b", ''),
    keywords: ['lark', 'larksuite', 'cli_'],
  },
  {
    id: 'larksuiteapikey-2',
    label: 'Larksuiteapikey (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['lark', 'larksuite', 'cli_'],
  },
  {
    id: 'launchdarkly',
    label: 'Launchdarkly',
    regex: new RegExp("\\b((?:api|sdk)-[a-z0-9]{8}-[a-z0-9]{4}-4[a-z0-9]{3}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['api-', 'sdk-'],
  },
  {
    id: 'ldap-1',
    label: 'LDAP (1)',
    regex: new RegExp("\\bldaps?://[\\S]+\\b", 'i'),
    keywords: ['ldaps://', 'ldap://'],
  },
  {
    id: 'ldap-2',
    label: 'LDAP (2)',
    regex: new RegExp("[\"']([a-zA-Z=,]{4,150})[\"']", ''),
    keywords: ['ldaps://', 'ldap://'],
  },
  {
    id: 'ldap-3',
    label: 'LDAP (3)',
    regex: new RegExp("[\"']([\\S]{4,48})[\"']", ''),
    keywords: ['ldaps://', 'ldap://'],
  },
  {
    id: 'ldap-4',
    label: 'LDAP (4)',
    regex: new RegExp("OpenDSObject\\(\\\"(ldaps?://[\\S]+)\\\", ?\\\"([\\S]+)\\\", ?\\\"([\\S]+)\\\",[ \\d]+\\)", 'i'),
    keywords: ['ldaps://', 'ldap://'],
  },
  {
    id: 'leadfeeder',
    label: 'Leadfeeder',
    regex: new RegExp("\\b([a-zA-Z0-9-]{43})\\b", ''),
    keywords: ['leadfeeder'],
  },
  {
    id: 'lemlist',
    label: 'Lemlist',
    regex: new RegExp("\\b([a-f0-9]{32})\\b", ''),
    keywords: ['lemlist'],
  },
  {
    id: 'lemonsqueezy',
    label: 'Lemonsqueezy',
    regex: new RegExp("\\b(eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9\\.[0-9A-Za-z]{314}\\.[0-9A-Za-z-_]{512})\\b", ''),
    keywords: ['lemonsqueezy'],
  },
  {
    id: 'lendflow',
    label: 'Lendflow',
    regex: new RegExp("\\b([a-zA-Z0-9]{36}\\.[a-zA-Z0-9]{235}\\.[a-zA-Z0-9]{32}\\-[a-zA-Z0-9]{47}\\-[a-zA-Z0-9_]{162}\\-[a-zA-Z0-9]{42}\\-[a-zA-Z0-9_]{40}\\-[a-zA-Z0-9_]{66}\\-[a-zA-Z0-9_]{59}\\-[a-zA-Z0-9]{7}\\-[a-zA-Z0-9_]{220})\\b", ''),
    keywords: ['lendflow'],
  },
  {
    id: 'lessannoyingcrm',
    label: 'Lessannoyingcrm',
    regex: new RegExp("\\b([a-zA-Z0-9-]{57})\\b", ''),
    keywords: ['lessannoyingcrm'],
  },
  {
    id: 'lexigram',
    label: 'Lexigram',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{301})\\b", ''),
    keywords: ['lexigram'],
  },
  {
    id: 'linearapi',
    label: 'Linearapi',
    regex: new RegExp("\\b(lin_api_[0-9A-Za-z]{40})\\b", ''),
    keywords: ['lin_api_'],
  },
  {
    id: 'linemessaging',
    label: 'Linemessaging',
    regex: new RegExp("\\b([A-Za-z0-9+/]{171,172})\\b", ''),
    keywords: ['line'],
  },
  {
    id: 'linenotify',
    label: 'Linenotify',
    regex: new RegExp("\\b([0-9A-Za-z]{43})\\b", ''),
    keywords: ['linenotify'],
  },
  {
    id: 'liveagent',
    label: 'Liveagent',
    regex: new RegExp("\\b(https?://[A-Za-z0-9-]+\\.ladesk\\.com)\\b", ''),
    keywords: ['liveagent', 'ladesk'],
  },
  {
    id: 'livestorm',
    label: 'Livestorm',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiJ9\\.eyJhdWQiOiJhcGkubGl2ZXN0b3JtLmNvIiwianRpIjoi[0-9A-Z-a-z]{134}\\.[0-9A-Za-z\\-\\_]{43}[ \\r\\n]{1})", ''),
    keywords: ['livestorm'],
  },
  {
    id: 'loadmill',
    label: 'Loadmill',
    regex: new RegExp("\\b([0-9a-zA-Z]{40})\\b", ''),
    keywords: ['loadmill'],
  },
  {
    id: 'lob',
    label: 'Lob',
    regex: new RegExp("\\b([a-zA-Z0-9_]{40})\\b", ''),
    keywords: ['lob'],
  },
  {
    id: 'locationiq',
    label: 'Locationiq',
    regex: new RegExp("\\b(pk\\.[a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['locationiq'],
  },
  {
    id: 'loggly-1',
    label: 'Loggly (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]+\\.loggly\\.com)\\b", ''),
    keywords: ['loggly'],
  },
  {
    id: 'loggly-2',
    label: 'Loggly (2)',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['loggly'],
  },
  {
    id: 'loginradius',
    label: 'Loginradius',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['loginradius'],
  },
  {
    id: 'logzio',
    label: 'Logzio',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['logz'],
  },
  {
    id: 'lokalisetoken',
    label: 'Lokalisetoken',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['lokalise'],
  },
  {
    id: 'loyverse',
    label: 'Loyverse',
    regex: new RegExp("\\b([0-9-a-z]{32})\\b", ''),
    keywords: ['loyverse'],
  },
  {
    id: 'lunchmoney',
    label: 'Lunchmoney',
    regex: new RegExp("\\b([a-f0-9]{50})\\b", ''),
    keywords: ['lunchmoney'],
  },
  {
    id: 'luno-1',
    label: 'Luno (1)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{43})\\b", ''),
    keywords: ['luno'],
  },
  {
    id: 'luno-2',
    label: 'Luno (2)',
    regex: new RegExp("\\b([a-z0-9]{13})\\b", ''),
    keywords: ['luno'],
  },
  {
    id: 'm3o',
    label: 'M3o',
    regex: new RegExp("\\b([0-9A-Za-z]{48})\\b", ''),
    keywords: ['m3o'],
  },
  {
    id: 'madkudu',
    label: 'Madkudu',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['madkudu'],
  },
  {
    id: 'magicbell',
    label: 'Magicbell',
    regex: new RegExp("\\b([a-zA-Z-0-9]{40})\\b", ''),
    keywords: ['magicbell'],
  },
  {
    id: 'magnetic',
    label: 'Magnetic',
    regex: new RegExp("\\b([0-9Aa-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['magnetic'],
  },
  {
    id: 'mailboxlayer',
    label: 'Mailboxlayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['mailboxlayer'],
  },
  {
    id: 'mailchimp',
    label: 'Mailchimp',
    regex: new RegExp("[0-9a-f]{32}-us[0-9]{1,2}", ''),
    keywords: ['-us'],
  },
  {
    id: 'mailerlite',
    label: 'Mailerlite',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['mailerlite'],
  },
  {
    id: 'mailgun-1',
    label: 'Mailgun (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{72})\\b", ''),
    keywords: ['mailgun', 'key-'],
  },
  {
    id: 'mailgun-2',
    label: 'Mailgun (2)',
    regex: new RegExp("\\b(key-[a-z0-9]{32})\\b", ''),
    keywords: ['mailgun', 'key-'],
  },
  {
    id: 'mailgun-3',
    label: 'Mailgun (3)',
    regex: new RegExp("\\b([a-f0-9]{32}-[a-f0-9]{8}-[a-f0-9]{8})\\b", ''),
    keywords: ['mailgun', 'key-'],
  },
  {
    id: 'mailjetbasicauth',
    label: 'Mailjetbasicauth',
    regex: new RegExp("\\b([A-Za-z0-9]{87}\\=)", ''),
    keywords: ['mailjet'],
  },
  {
    id: 'mailjetsms',
    label: 'Mailjetsms',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['mailjet'],
  },
  {
    id: 'mailmodo',
    label: 'Mailmodo',
    regex: new RegExp("\\b([A-Z0-9]{7}-[A-Z0-9]{7}-[A-Z0-9]{7}-[A-Z0-9]{7})\\b", ''),
    keywords: ['mailmodo'],
  },
  {
    id: 'mailsac',
    label: 'Mailsac',
    regex: new RegExp("\\b(k_[0-9A-Za-z]{36,})\\b", ''),
    keywords: ['mailsac'],
  },
  {
    id: 'mandrill',
    label: 'Mandrill',
    regex: new RegExp("\\b([A-Za-z0-9_-]{22})\\b", ''),
    keywords: ['mandrill'],
  },
  {
    id: 'manifest',
    label: 'Manifest',
    regex: new RegExp("\\b([a-zA-z0-9]{32})\\b", ''),
    keywords: ['manifest'],
  },
  {
    id: 'mapbox-1',
    label: 'Mapbox (1)',
    regex: new RegExp("([a-zA-Z-0-9]{4,32})", ''),
    keywords: ['mapbox'],
  },
  {
    id: 'mapbox-2',
    label: 'Mapbox (2)',
    regex: new RegExp("\\b(sk\\.[a-zA-Z-0-9\\.]{80,240})\\b", ''),
    keywords: ['mapbox'],
  },
  {
    id: 'mapquest',
    label: 'Mapquest',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['mapquest'],
  },
  {
    id: 'marketstack',
    label: 'Marketstack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['marketstack'],
  },
  {
    id: 'mattermostpersonaltoken-1',
    label: 'Mattermostpersonaltoken (1)',
    regex: new RegExp("\\b([a-z0-9]{26})\\b", ''),
    keywords: ['mattermost'],
  },
  {
    id: 'mattermostpersonaltoken-2',
    label: 'Mattermostpersonaltoken (2)',
    regex: new RegExp("\\b([A-Za-z0-9-_]{1,}.cloud.mattermost.com)\\b", ''),
    keywords: ['mattermost'],
  },
  {
    id: 'mavenlink',
    label: 'Mavenlink',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['mavenlink'],
  },
  {
    id: 'maxmindlicense-v1-1',
    label: 'Maxmindlicense V1 (1)',
    regex: new RegExp("\\b([0-9]{2,7})\\b", ''),
    keywords: ['maxmind', 'geoip'],
  },
  {
    id: 'maxmindlicense-v1-2',
    label: 'Maxmindlicense V1 (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{16})\\b", ''),
    keywords: ['maxmind', 'geoip'],
  },
  {
    id: 'maxmindlicense-v2',
    label: 'Maxmindlicense V2',
    regex: new RegExp("\\b([a-zA-Z0-9]{6}_[a-zA-Z0-9]{29}_mmk)\\b", ''),
    keywords: ['_mmk'],
  },
  {
    id: 'meaningcloud',
    label: 'Meaningcloud',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['meaningcloud'],
  },
  {
    id: 'mediastack',
    label: 'Mediastack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['mediastack'],
  },
  {
    id: 'meistertask',
    label: 'Meistertask',
    regex: new RegExp("\\b([a-zA-Z0-9]{43})\\b", ''),
    keywords: ['meistertask'],
  },
  {
    id: 'meraki',
    label: 'Meraki',
    regex: new RegExp("([0-9a-f]{40})", ''),
    keywords: ['meraki'],
  },
  {
    id: 'mesibo',
    label: 'Mesibo',
    regex: new RegExp("\\b([0-9A-Za-z]{64})\\b", ''),
    keywords: ['mesibo'],
  },
  {
    id: 'messagebird',
    label: 'Messagebird',
    regex: new RegExp("\\b([A-Za-z0-9_-]{25})\\b", ''),
    keywords: ['messagebird'],
  },
  {
    id: 'metaapi-1',
    label: 'Metaapi (1)',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['metaapi', 'meta-api'],
  },
  {
    id: 'metaapi-2',
    label: 'Metaapi (2)',
    regex: new RegExp("\\b([0-9a-f]{24})\\b", ''),
    keywords: ['metaapi', 'meta-api'],
  },
  {
    id: 'metabase-1',
    label: 'Metabase (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{36})\\b", ''),
    keywords: ['metabase'],
  },
  {
    id: 'metabase-2',
    label: 'Metabase (2)',
    regex: new RegExp("\\b(https?:\\/\\/[-a-zA-Z0-9@:%._\\+~#=]{7,256})\\b", ''),
    keywords: ['metabase'],
  },
  {
    id: 'metrilo',
    label: 'Metrilo',
    regex: new RegExp("\\b([a-z0-9]{16})\\b", ''),
    keywords: ['metrilo'],
  },
  {
    id: 'microsoftteamswebhook',
    label: 'Microsoftteamswebhook',
    regex: new RegExp("(https:\\/\\/[a-zA-Z-0-9]+\\.webhook\\.office\\.com\\/webhookb2\\/[a-zA-Z-0-9]{8}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{12}\\@[a-zA-Z-0-9]{8}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{12}\\/IncomingWebhook\\/[a-zA-Z-0-9]{32}\\/[a-zA-Z-0-9]{8}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{4}-[a-zA-Z-0-9]{12})", ''),
    keywords: ['webhook.office.com'],
  },
  {
    id: 'mindmeister',
    label: 'Mindmeister',
    regex: new RegExp("\\b([a-zA-Z0-9]{43})\\b", ''),
    keywords: ['mindmeister'],
  },
  {
    id: 'miro',
    label: 'Miro',
    regex: new RegExp("\\b([0-9a-zA-Z]{27})\\b", ''),
    keywords: ['miro'],
  },
  {
    id: 'mite-1',
    label: 'Mite (1)',
    regex: new RegExp("\\b([0-9a-z]{16})\\b", ''),
    keywords: ['mite'],
  },
  {
    id: 'mite-2',
    label: 'Mite (2)',
    regex: new RegExp("\\b([0-9a-z-]{1,}.mite.yo.lk)\\b", ''),
    keywords: ['mite'],
  },
  {
    id: 'mixmax',
    label: 'Mixmax',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{36})\\b", ''),
    keywords: ['mixmax'],
  },
  {
    id: 'mixpanel-1',
    label: 'Mixpanel (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{32})\\b", ''),
    keywords: ['mixpanel'],
  },
  {
    id: 'mixpanel-2',
    label: 'Mixpanel (2)',
    regex: new RegExp("\\b([a-zA-Z0-9.-]{30,40})\\b", ''),
    keywords: ['mixpanel'],
  },
  {
    id: 'mockaroo',
    label: 'Mockaroo',
    regex: new RegExp("\\b([0-9a-z]{8})\\b", ''),
    keywords: ['mockaroo'],
  },
  {
    id: 'moderation',
    label: 'Moderation',
    regex: new RegExp("\\b([a-zA-Z0-9]{36}\\.[a-zA-Z0-9]{115}\\.[a-zA-Z0-9_]{43})\\b", ''),
    keywords: ['moderation'],
  },
  {
    id: 'monday',
    label: 'Monday',
    regex: new RegExp("\\b(eyJ[A-Za-z0-9-_]{15,100}\\.eyJ[A-Za-z0-9-_]{100,300}\\.[A-Za-z0-9-_]{25,100})\\b", ''),
    keywords: ['monday'],
  },
  {
    id: 'mongodb-1',
    label: 'Mongodb (1)',
    regex: new RegExp("\\b(mongodb(?:\\+srv)?://(?<username>\\S{3,50}):(?<password>\\S{3,88})@(?<host>[-.%\\w]+(?::\\d{1,5})?(?:,[-.%\\w]+(?::\\d{1,5})?)*)(?:/(?<authdb>[\\w-]+)?(?<options>\\?\\w+=[\\w@/.$-]+(?:&(?:amp;)?\\w+=[\\w@/.$-]+)*)?)?)(?:\\b|$)", ''),
    keywords: ['mongodb'],
  },
  {
    id: 'mongodb-2',
    label: 'Mongodb (2)',
    regex: new RegExp("^[xX]+|\\*+$", ''),
    keywords: ['mongodb'],
  },
  {
    id: 'monkeylearn',
    label: 'Monkeylearn',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['monkeylearn'],
  },
  {
    id: 'moonclerk',
    label: 'Moonclerk',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['moonclerk'],
  },
  {
    id: 'moosend',
    label: 'Moosend',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['moosend'],
  },
  {
    id: 'moralis',
    label: 'Moralis',
    regex: new RegExp("\\b([0-9a-zA-Z]{64})\\b", ''),
    keywords: ['moralis'],
  },
  {
    id: 'mrticktock',
    label: 'Mrticktock',
    regex: new RegExp("\\b([a-zA-Z0-9!=@#$%()_^]{1,50})", ''),
    keywords: ['mrticktock'],
  },
  {
    id: 'mux-1',
    label: 'Mux (1)',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['mux'],
  },
  {
    id: 'mux-2',
    label: 'Mux (2)',
    regex: new RegExp("([ \\r\\n]{0,1}[0-9A-Za-z\\/\\+]{75}[ \\r\\n]{1})", ''),
    keywords: ['mux'],
  },
  {
    id: 'myfreshworks-1',
    label: 'Myfreshworks (1)',
    regex: new RegExp("\\b([a-z0-9A-Z-_]{22})\\b", ''),
    keywords: ['freshworks'],
  },
  {
    id: 'myfreshworks-2',
    label: 'Myfreshworks (2)',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{2,20})\\b", ''),
    keywords: ['freshworks'],
  },
  {
    id: 'myintervals',
    label: 'Myintervals',
    regex: new RegExp("\\b([0-9a-z]{11})\\b", ''),
    keywords: ['myintervals'],
  },
  {
    id: 'nasdaqdatalink',
    label: 'Nasdaqdatalink',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{20})\\b", ''),
    keywords: ['nasdaq'],
  },
  {
    id: 'nethunt-1',
    label: 'Nethunt (1)',
    regex: new RegExp("\\b([a-z0-9-\\S]{36})\\b", ''),
    keywords: ['nethunt'],
  },
  {
    id: 'nethunt-2',
    label: 'Nethunt (2)',
    regex: new RegExp("\\b([a-zA-Z0-9.-@]{25,30})\\b", ''),
    keywords: ['nethunt'],
  },
  {
    id: 'netlify-v1',
    label: 'Netlify V1',
    regex: new RegExp("\\b([A-Za-z0-9_-]{43,45})\\b", ''),
    keywords: ['netlify'],
  },
  {
    id: 'netlify-v2',
    label: 'Netlify V2',
    regex: new RegExp("\\b(nfp_[a-zA-Z0-9_]{36})\\b", ''),
    keywords: ['netlify'],
  },
  {
    id: 'netsuite-1',
    label: 'Netsuite (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['netsuite'],
  },
  {
    id: 'netsuite-2',
    label: 'Netsuite (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['netsuite'],
  },
  {
    id: 'netsuite-3',
    label: 'Netsuite (3)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['netsuite'],
  },
  {
    id: 'netsuite-4',
    label: 'Netsuite (4)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['netsuite'],
  },
  {
    id: 'netsuite-5',
    label: 'Netsuite (5)',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{6,15})\\b", ''),
    keywords: ['netsuite'],
  },
  {
    id: 'neutrinoapi-1',
    label: 'Neutrinoapi (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{48})\\b", ''),
    keywords: ['neutrinoapi'],
  },
  {
    id: 'neutrinoapi-2',
    label: 'Neutrinoapi (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{6,24})\\b", ''),
    keywords: ['neutrinoapi'],
  },
  {
    id: 'newrelicpersonalapikey',
    label: 'Newrelicpersonalapikey',
    regex: new RegExp("\\b([A-Za-z0-9_\\.]{4}-[A-Za-z0-9_\\.]{42})\\b", ''),
    keywords: ['newrelic'],
  },
  {
    id: 'newsapi',
    label: 'Newsapi',
    regex: new RegExp("\\b([a-z0-9]{32})", ''),
    keywords: ['newsapi'],
  },
  {
    id: 'newscatcher',
    label: 'Newscatcher',
    regex: new RegExp("\\b([0-9A-Za-z_]{43})\\b", ''),
    keywords: ['newscatcher'],
  },
  {
    id: 'nexmoapikey-1',
    label: 'Nexmoapikey (1)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{8})\\b", ''),
    keywords: ['nexmo'],
  },
  {
    id: 'nexmoapikey-2',
    label: 'Nexmoapikey (2)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{16})\\b", ''),
    keywords: ['nexmo'],
  },
  {
    id: 'nftport',
    label: 'Nftport',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['nftport'],
  },
  {
    id: 'ngc-1',
    label: 'Ngc (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{26}:[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})\\b", ''),
    keywords: ['ngc'],
  },
  {
    id: 'ngc-2',
    label: 'Ngc (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{84})\\b", ''),
    keywords: ['ngc'],
  },
  {
    id: 'ngc-3',
    label: 'Ngc (3)',
    regex: new RegExp("\\b([a-zA-Z0-9]{26}:[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})\\b", ''),
    keywords: ['ngc'],
  },
  {
    id: 'ngrok',
    label: 'Ngrok',
    regex: new RegExp("\\b(2[a-zA-Z0-9]{26}_\\d[a-zA-Z0-9]{20})\\b", ''),
    keywords: ['ngrok'],
  },
  {
    id: 'nicereply',
    label: 'Nicereply',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['nicereply'],
  },
  {
    id: 'nightfall',
    label: 'Nightfall',
    regex: new RegExp("\\b(NF\\-[a-zA-Z0-9]{32})\\b", ''),
    keywords: ['nightfall'],
  },
  {
    id: 'nimble',
    label: 'Nimble',
    regex: new RegExp("\\b([a-zA-Z0-9]{30})\\b", ''),
    keywords: ['nimble'],
  },
  {
    id: 'noticeable',
    label: 'Noticeable',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['noticeable'],
  },
  {
    id: 'notion',
    label: 'Notion',
    regex: new RegExp("\\b(secret_[A-Za-z0-9]{43})\\b", ''),
    keywords: ['notion'],
  },
  {
    id: 'nozbeteams',
    label: 'Nozbeteams',
    regex: new RegExp("\\b([0-9A-Za-z]{16}_[0-9A-Za-z\\-_]{64}[ \\r\\n]{1})", ''),
    keywords: ['nozbe', 'nozbeteams'],
  },
  {
    id: 'npmtoken',
    label: 'Npmtoken',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['npm'],
  },
  {
    id: 'npmtokenv2',
    label: 'Npmtokenv2',
    regex: new RegExp("(npm_[0-9a-zA-Z]{36})", ''),
    keywords: ['npm_'],
  },
  {
    id: 'nugetapikey',
    label: 'Nugetapikey',
    regex: new RegExp("\\b([a-z0-9]{46})\\b", ''),
    keywords: ['nuget'],
  },
  {
    id: 'numverify',
    label: 'Numverify',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['numverify'],
  },
  {
    id: 'nutritionix-1',
    label: 'Nutritionix (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['nutritionix'],
  },
  {
    id: 'nutritionix-2',
    label: 'Nutritionix (2)',
    regex: new RegExp("\\b([a-z0-9]{8})\\b", ''),
    keywords: ['nutritionix'],
  },
  {
    id: 'nvapi',
    label: 'Nvapi',
    regex: new RegExp("\\b(nvapi-[a-zA-Z0-9_-]{64})\\b", ''),
    keywords: ['nvapi-'],
  },
  {
    id: 'nylas',
    label: 'Nylas',
    regex: new RegExp("\\b([0-9A-Za-z]{30})\\b", ''),
    keywords: ['nylas'],
  },
  {
    id: 'oanda',
    label: 'Oanda',
    regex: new RegExp("\\b([a-zA-Z0-9]{24})\\b", ''),
    keywords: ['oanda'],
  },
  {
    id: 'okta-1',
    label: 'Okta (1)',
    regex: new RegExp("\\b[a-z0-9-]{1,40}\\.okta(?:preview|-emea){0,1}\\.com\\b", ''),
    keywords: ['.okta'],
  },
  {
    id: 'okta-2',
    label: 'Okta (2)',
    regex: new RegExp("\\b00[a-zA-Z0-9_-]{40}\\b", ''),
    keywords: ['.okta'],
  },
  {
    id: 'omnisend',
    label: 'Omnisend',
    regex: new RegExp("\\b([a-z0-9A-Z-]{75})\\b", ''),
    keywords: ['omnisend'],
  },
  {
    id: 'onedesk',
    label: 'Onedesk',
    regex: new RegExp("\\b([a-zA-Z0-9!=@#$%^]{8,64})", ''),
    keywords: ['onedesk'],
  },
  {
    id: 'onelogin-1',
    label: 'Onelogin (1)',
    regex: new RegExp("id[a-zA-Z0-9_' \"=]{0,20}([a-z0-9]{64})", 'i'),
    keywords: ['onelogin'],
  },
  {
    id: 'onelogin-2',
    label: 'Onelogin (2)',
    regex: new RegExp("secret[a-zA-Z0-9_' \"=]{0,20}([a-z0-9]{64})", 'i'),
    keywords: ['onelogin'],
  },
  {
    id: 'onepagecrm-1',
    label: 'Onepagecrm (1)',
    regex: new RegExp("\\b([a-zA-Z0-9=]{44})", ''),
    keywords: ['onepagecrm'],
  },
  {
    id: 'onepagecrm-2',
    label: 'Onepagecrm (2)',
    regex: new RegExp("\\b([a-z0-9]{24})\\b", ''),
    keywords: ['onepagecrm'],
  },
  {
    id: 'onfleet',
    label: 'Onfleet',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['onfleet'],
  },
  {
    id: 'oopspam',
    label: 'Oopspam',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['oopspam'],
  },
  {
    id: 'openai',
    label: 'Openai',
    regex: new RegExp("\\b(sk-(?:(?:proj|svcacct|service)-[A-Za-z0-9_-]+|[a-zA-Z0-9]+)T3BlbkFJ[A-Za-z0-9_-]+)\\b", ''),
    keywords: ['t3blbkfj'],
  },
  {
    id: 'openaiadmin',
    label: 'Openaiadmin',
    regex: new RegExp("\\b(sk-admin-[A-Za-z0-9_-]{58}T3BlbkFJ[A-Za-z0-9_-]{58})\\b", ''),
    keywords: ['sk-admin-'],
  },
  {
    id: 'opencagedata',
    label: 'Opencagedata',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['opencagedata'],
  },
  {
    id: 'openuv',
    label: 'Openuv',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['openuv'],
  },
  {
    id: 'openvpn-1',
    label: 'Openvpn (1)',
    regex: new RegExp("\\b([A-Za-z0-9-]{3,40}\\.[A-Za-z0-9-]{3,40})\\b", ''),
    keywords: ['openvpn'],
  },
  {
    id: 'openvpn-2',
    label: 'Openvpn (2)',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{64,})\\b", ''),
    keywords: ['openvpn'],
  },
  {
    id: 'openvpn-3',
    label: 'Openvpn (3)',
    regex: new RegExp("\\b(https?://[A-Za-z0-9-]+\\.api\\.openvpn\\.com)\\b", ''),
    keywords: ['openvpn'],
  },
  {
    id: 'openweather',
    label: 'Openweather',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['openweather'],
  },
  {
    id: 'opsgenie',
    label: 'Opsgenie',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['opsgenie'],
  },
  {
    id: 'optimizely',
    label: 'Optimizely',
    regex: new RegExp("\\b([0-9A-Za-z-:]{54})\\b", ''),
    keywords: ['optimizely'],
  },
  {
    id: 'overloop',
    label: 'Overloop',
    regex: new RegExp("\\b([a-zA-Z\\_\\-0-9]{50})\\b", ''),
    keywords: ['overloop'],
  },
  {
    id: 'owlbot',
    label: 'Owlbot',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['owlbot'],
  },
  {
    id: 'packagecloud',
    label: 'Packagecloud',
    regex: new RegExp("\\b([0-9a-f]{48})\\b", ''),
    keywords: ['packagecloud'],
  },
  {
    id: 'pagarme',
    label: 'Pagarme',
    regex: new RegExp("\\b(ak_live_[a-zA-Z0-9]{30})\\b", ''),
    keywords: ['ak_live_'],
  },
  {
    id: 'pagerdutyapikey',
    label: 'Pagerdutyapikey',
    regex: new RegExp("\\b(u\\+[a-zA-Z0-9_+-]{18})\\b", ''),
    keywords: ['pagerduty', 'pager_duty', 'pd_', 'pd-'],
  },
  {
    id: 'pandadoc',
    label: 'Pandadoc',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['pandadoc'],
  },
  {
    id: 'pandascore',
    label: 'Pandascore',
    regex: new RegExp("([ \\r\\n]{0,1}[0-9A-Za-z\\-\\_]{51}[ \\r\\n]{1})", ''),
    keywords: ['pandascore'],
  },
  {
    id: 'paperform',
    label: 'Paperform',
    regex: new RegExp("\\b([a-z0-9A-Z-._]{850,1000})\\b", ''),
    keywords: ['paperform'],
  },
  {
    id: 'paralleldots',
    label: 'Paralleldots',
    regex: new RegExp("\\b([0-9A-Za-z]{43})\\b", ''),
    keywords: ['paralleldots'],
  },
  {
    id: 'parsehub',
    label: 'Parsehub',
    regex: new RegExp("\\b([0-9a-zA-Z]{12})\\b", ''),
    keywords: ['parsehub'],
  },
  {
    id: 'parsers',
    label: 'Parsers',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['parsers'],
  },
  {
    id: 'parseur',
    label: 'Parseur',
    regex: new RegExp("\\b([a-f0-9]{40})\\b", ''),
    keywords: ['parseur'],
  },
  {
    id: 'partnerstack',
    label: 'Partnerstack',
    regex: new RegExp("\\b([0-9A-Za-z]{64})\\b", ''),
    keywords: ['partnerstack'],
  },
  {
    id: 'pastebin',
    label: 'Pastebin',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['pastebin'],
  },
  {
    id: 'paydirtapp',
    label: 'Paydirtapp',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['paydirtapp'],
  },
  {
    id: 'paymoapp',
    label: 'Paymoapp',
    regex: new RegExp("\\b([a-zA-Z0-9]{44})\\b", ''),
    keywords: ['paymoapp'],
  },
  {
    id: 'paymongo',
    label: 'Paymongo',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['paymongo'],
  },
  {
    id: 'paypaloauth-1',
    label: 'Paypaloauth (1)',
    regex: new RegExp("\\b([A-Za-z0-9_\\.]{7}-[A-Za-z0-9_\\.]{72}|[A-Za-z0-9_\\.]{5}-[A-Za-z0-9_\\.]{38})\\b", ''),
    keywords: ['paypal'],
  },
  {
    id: 'paypaloauth-2',
    label: 'Paypaloauth (2)',
    regex: new RegExp("\\b([A-Za-z0-9_\\.\\-]{44,80})\\b", ''),
    keywords: ['paypal'],
  },
  {
    id: 'paystack',
    label: 'Paystack',
    regex: new RegExp("\\b(sk\\_[a-z]{1,}\\_[A-Za-z0-9]{40})\\b", ''),
    keywords: ['paystack'],
  },
  {
    id: 'pdflayer',
    label: 'Pdflayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['pdflayer'],
  },
  {
    id: 'pdfshift',
    label: 'Pdfshift',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['pdfshift'],
  },
  {
    id: 'peopledatalabs',
    label: 'Peopledatalabs',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['peopledatalabs'],
  },
  {
    id: 'pepipost',
    label: 'Pepipost',
    regex: new RegExp("\\b([a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['pepipost', 'netcore'],
  },
  {
    id: 'percy',
    label: 'Percy',
    regex: new RegExp("\\bPERCY_TOKEN=([0-9Aa-f]{64})\\b", ''),
    keywords: ['percy'],
  },
  {
    id: 'photoroom',
    label: 'Photoroom',
    regex: new RegExp("\\b(?:sandbox_)?(sk_pr_[a-zA-Z0-9]{1,64}_[a-fA-F0-9]{40})\\b", ''),
    keywords: ['photoroom'],
  },
  {
    id: 'phraseaccesstoken',
    label: 'Phraseaccesstoken',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['phrase'],
  },
  {
    id: 'pinata-1',
    label: 'Pinata (1)',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['pinata'],
  },
  {
    id: 'pinata-2',
    label: 'Pinata (2)',
    regex: new RegExp("\\b([0-9a-z]{20})\\b", ''),
    keywords: ['pinata'],
  },
  {
    id: 'pipedream',
    label: 'Pipedream',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['pipedream'],
  },
  {
    id: 'pipedrive',
    label: 'Pipedrive',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['pipedrive'],
  },
  {
    id: 'pivotaltracker',
    label: 'Pivotaltracker',
    regex: new RegExp("([a-z0-9]{32})", ''),
    keywords: ['pivotal'],
  },
  {
    id: 'pixabay',
    label: 'Pixabay',
    regex: new RegExp("\\b([a-z0-9-]{34})\\b", ''),
    keywords: ['pixabay'],
  },
  {
    id: 'plaidkey-1',
    label: 'Plaidkey (1)',
    regex: new RegExp("\\b([a-f0-9]{30})\\b", ''),
    keywords: ['plaid'],
  },
  {
    id: 'plaidkey-2',
    label: 'Plaidkey (2)',
    regex: new RegExp("\\b([a-f0-9]{24})\\b", ''),
    keywords: ['plaid'],
  },
  {
    id: 'plaidkey-3',
    label: 'Plaidkey (3)',
    regex: new RegExp("\\b(access-(sandbox|production)-[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})\\b", ''),
    keywords: ['plaid'],
  },
  {
    id: 'planetscale-1',
    label: 'Planetscale (1)',
    regex: new RegExp("\\b[a-z0-9]{12}\\b", ''),
    keywords: ['pscale_tkn_'],
  },
  {
    id: 'planetscale-2',
    label: 'Planetscale (2)',
    regex: new RegExp("\\bpscale_tkn_[A-Za-z0-9_]{43}\\b", ''),
    keywords: ['pscale_tkn_'],
  },
  {
    id: 'planetscaledb-1',
    label: 'Planetscaledb (1)',
    regex: new RegExp("\\b[a-z0-9]{20}\\b", ''),
    keywords: ['pscale_pw_'],
  },
  {
    id: 'planetscaledb-2',
    label: 'Planetscaledb (2)',
    regex: new RegExp("\\bpscale_pw_[A-Za-z0-9_]{43}\\b", ''),
    keywords: ['pscale_pw_'],
  },
  {
    id: 'planetscaledb-3',
    label: 'Planetscaledb (3)',
    regex: new RegExp("\\b(aws|gcp)\\.connect\\.psdb\\.cloud\\b", ''),
    keywords: ['pscale_pw_'],
  },
  {
    id: 'planviewleankit-1',
    label: 'Planviewleankit (1)',
    regex: new RegExp("\\b([0-9a-f]{128})\\b", ''),
    keywords: ['planviewleankit', 'planview'],
  },
  {
    id: 'planviewleankit-2',
    label: 'Planviewleankit (2)',
    regex: new RegExp("(?:subdomain).\\b([a-zA-Z][a-zA-Z0-9.-]{1,23}[a-zA-Z0-9])\\b", ''),
    keywords: ['planviewleankit', 'planview'],
  },
  {
    id: 'planyo',
    label: 'Planyo',
    regex: new RegExp("\\b([0-9a-z]{62})\\b", ''),
    keywords: ['planyo'],
  },
  {
    id: 'plivo-1',
    label: 'Plivo (1)',
    regex: new RegExp("\\b([A-Z]{20})\\b", ''),
    keywords: ['plivo'],
  },
  {
    id: 'plivo-2',
    label: 'Plivo (2)',
    regex: new RegExp("\\b([A-Za-z0-9_-]{40})\\b", ''),
    keywords: ['plivo'],
  },
  {
    id: 'podio',
    label: 'Podio',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['podio'],
  },
  {
    id: 'pollsapi',
    label: 'Pollsapi',
    regex: new RegExp("\\b([A-Z0-9]{28})\\b", ''),
    keywords: ['pollsapi'],
  },
  {
    id: 'poloniex-1',
    label: 'Poloniex (1)',
    regex: new RegExp("\\b([0-9A-Z]{8}-[0-9A-Z]{8}-[0-9A-Z]{8}-[0-9A-Z]{8})\\b", ''),
    keywords: ['poloniex'],
  },
  {
    id: 'poloniex-2',
    label: 'Poloniex (2)',
    regex: new RegExp("\\b([0-9a-f]{128})\\b", ''),
    keywords: ['poloniex'],
  },
  {
    id: 'polygon',
    label: 'Polygon',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['polygon'],
  },
  {
    id: 'portainer-1',
    label: 'Portainer (1)',
    regex: new RegExp("\\b(https?:\\/\\/\\S+(:[0-9]{4,5})?)\\b", ''),
    keywords: ['portainer'],
  },
  {
    id: 'portainer-2',
    label: 'Portainer (2)',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9\\.[0-9A-Za-z]{50,310}\\.[0-9A-Z-a-z\\-_]{43})\\b", ''),
    keywords: ['portainer'],
  },
  {
    id: 'portainertoken-1',
    label: 'Portainertoken (1)',
    regex: new RegExp("\\b(ptr_[A-Za-z0-9\\/_\\-+=]{20,60})", ''),
    keywords: ['portainertoken'],
  },
  {
    id: 'portainertoken-2',
    label: 'Portainertoken (2)',
    regex: new RegExp("\\b(https?:\\/\\/\\S+(:[0-9]{4,5})?)\\b", ''),
    keywords: ['portainertoken'],
  },
  {
    id: 'positionstack',
    label: 'Positionstack',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['positionstack'],
  },
  {
    id: 'postageapp',
    label: 'Postageapp',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['postageapp'],
  },
  {
    id: 'postbacks',
    label: 'Postbacks',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['postbacks'],
  },
  {
    id: 'postgres-1',
    label: 'Postgres (1)',
    regex: new RegExp("\\b(postgres(?:ql)?)://\\S+\\b", 'i'),
    keywords: ['postgres'],
  },
  {
    id: 'postgres-2',
    label: 'Postgres (2)',
    regex: new RegExp("([a-zA-Z]+)='(.+?)' ?", ''),
    keywords: ['postgres'],
  },
  {
    id: 'posthog',
    label: 'Posthog',
    regex: new RegExp("\\b(phx_[a-zA-Z0-9_]{43})\\b", ''),
    keywords: ['phx_'],
  },
  {
    id: 'postman',
    label: 'Postman',
    regex: new RegExp("\\b(PMAK-[a-zA-Z-0-9]{59})\\b", ''),
    keywords: ['pmak-'],
  },
  {
    id: 'postmark',
    label: 'Postmark',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['postmark'],
  },
  {
    id: 'powrbot',
    label: 'Powrbot',
    regex: new RegExp("\\b([a-z0-9A-Z]{40})\\b", ''),
    keywords: ['powrbot'],
  },
  {
    id: 'prefect',
    label: 'Prefect',
    regex: new RegExp("\\b(pnu_[a-zA-Z0-9]{36})\\b", ''),
    keywords: ['pnu_'],
  },
  {
    id: 'privacy',
    label: 'Privacy',
    regex: new RegExp("\\b([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['privacy'],
  },
  {
    id: 'privatekey',
    label: 'Privatekey',
    regex: new RegExp("-----\\s*?BEGIN[ A-Z0-9_-]*?PRIVATE KEY\\s*?-----[\\s\\S]*?----\\s*?END[ A-Z0-9_-]*? PRIVATE KEY\\s*?-----", 'i'),
    keywords: ['private key'],
  },
  {
    id: 'prodpad',
    label: 'Prodpad',
    regex: new RegExp("\\b([a-f0-9]{64})\\b", ''),
    keywords: ['prodpad'],
  },
  {
    id: 'prospectcrm',
    label: 'Prospectcrm',
    regex: new RegExp("\\b([a-z0-9-]{32})\\b", ''),
    keywords: ['prospectcrm'],
  },
  {
    id: 'protocolsio',
    label: 'Protocolsio',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['protocols'],
  },
  {
    id: 'proxycrawl',
    label: 'Proxycrawl',
    regex: new RegExp("\\b([a-zA-Z0-9_]{22})\\b", ''),
    keywords: ['proxycrawl'],
  },
  {
    id: 'pubnubpublishkey-1',
    label: 'Pubnubpublishkey (1)',
    regex: new RegExp("\\b(pub-c-[0-9a-z]{8}-[0-9a-z]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['sub-c-'],
  },
  {
    id: 'pubnubpublishkey-2',
    label: 'Pubnubpublishkey (2)',
    regex: new RegExp("\\b(sub-c-[0-9a-z]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['sub-c-'],
  },
  {
    id: 'pubnubsubscriptionkey',
    label: 'Pubnubsubscriptionkey',
    regex: new RegExp("\\b(sub-c-[0-9a-z]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})\\b", ''),
    keywords: ['sub-c-'],
  },
  {
    id: 'pulumi',
    label: 'Pulumi',
    regex: new RegExp("\\b(pul-[a-z0-9]{40})\\b", ''),
    keywords: ['pul-'],
  },
  {
    id: 'purestake',
    label: 'Purestake',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['purestake'],
  },
  {
    id: 'pushbulletapikey',
    label: 'Pushbulletapikey',
    regex: new RegExp("\\b([A-Za-z0-9_\\.]{34})\\b", ''),
    keywords: ['pushbullet'],
  },
  {
    id: 'pusherchannelkey-1',
    label: 'Pusherchannelkey (1)',
    regex: new RegExp("\\b([0-9]{7})\\b", ''),
    keywords: ['pusher'],
  },
  {
    id: 'pusherchannelkey-2',
    label: 'Pusherchannelkey (2)',
    regex: new RegExp("\\b([a-z0-9]{20})\\b", ''),
    keywords: ['pusher'],
  },
  {
    id: 'pusherchannelkey-3',
    label: 'Pusherchannelkey (3)',
    regex: new RegExp("\\b([a-z0-9]{20})\\b", ''),
    keywords: ['pusher'],
  },
  {
    id: 'qase',
    label: 'Qase',
    regex: new RegExp("\\b([0-9a-zA-Z]{40})\\b", ''),
    keywords: ['qase'],
  },
  {
    id: 'qualaroo',
    label: 'Qualaroo',
    regex: new RegExp("\\b([a-z0-9A-Z=]{64})", ''),
    keywords: ['qualaroo'],
  },
  {
    id: 'qubole',
    label: 'Qubole',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['qubole'],
  },
  {
    id: 'rabbitmq',
    label: 'Rabbitmq',
    regex: new RegExp("\\b(?:amqps?):\\/\\/[\\S]{3,50}:([\\S]{3,50})@[-.%\\w\\/:]+\\b", ''),
    keywords: ['amqp'],
  },
  {
    id: 'ramp-1',
    label: 'Ramp (1)',
    regex: new RegExp("\\b(ramp_id_[a-zA-Z0-9]{40})\\b", ''),
    keywords: ['ramp_'],
  },
  {
    id: 'ramp-2',
    label: 'Ramp (2)',
    regex: new RegExp("\\b(ramp_sec_[a-zA-Z0-9]{48})\\b", ''),
    keywords: ['ramp_'],
  },
  {
    id: 'rapidapi',
    label: 'Rapidapi',
    regex: new RegExp("\\b([A-Za-z0-9_-]{50})\\b", ''),
    keywords: ['rapidapi'],
  },
  {
    id: 'raven',
    label: 'Raven',
    regex: new RegExp("\\b([A-Z0-9-]{16})\\b", ''),
    keywords: ['raven'],
  },
  {
    id: 'rawg',
    label: 'Rawg',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['rawg'],
  },
  {
    id: 'razorpay-1',
    label: 'Razorpay (1)',
    regex: new RegExp("\\brzp_live_[A-Za-z0-9]{14}\\b", 'i'),
    keywords: ['rzp_live_'],
  },
  {
    id: 'razorpay-2',
    label: 'Razorpay (2)',
    regex: new RegExp("\\b[A-Za-z0-9]{24}\\b", ''),
    keywords: ['rzp_live_'],
  },
  {
    id: 'reachmail',
    label: 'Reachmail',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{64})\\b", ''),
    keywords: ['reachmail'],
  },
  {
    id: 'readme',
    label: 'Readme',
    regex: new RegExp("(rdme_[a-z0-9]{70})", ''),
    keywords: ['rdme_'],
  },
  {
    id: 'reallysimplesystems',
    label: 'Reallysimplesystems',
    regex: new RegExp("\\b(ey[a-zA-Z0-9-._]{153}.ey[a-zA-Z0-9-._]{916,1000})\\b", ''),
    keywords: ['reallysimplesystems'],
  },
  {
    id: 'rebrandly',
    label: 'Rebrandly',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['rebrandly'],
  },
  {
    id: 'rechargepayments-1',
    label: 'Rechargepayments (1)',
    regex: new RegExp("\\bsk(_test)?_(1|2|3|5|10)x[123]_[0-9a-fA-F]{64}\\b", ''),
    keywords: ['sk_1x1', 'sk_1x3', 'sk_2x1', 'sk_2x2', 'sk_3x3', 'sk_5x3', 'sk_10x3', 'sk_test_1x1', 'sk_test_1x3', 'sk_test_2x1', 'sk_test_2x2', 'sk_test_3x3', 'sk_test_5x3', 'sk_test_10x3', 'x-recharge-access-token'],
  },
  {
    id: 'rechargepayments-2',
    label: 'Rechargepayments (2)',
    regex: new RegExp("\\b[0-9a-fA-F]{56}\\b", ''),
    keywords: ['sk_1x1', 'sk_1x3', 'sk_2x1', 'sk_2x2', 'sk_3x3', 'sk_5x3', 'sk_10x3', 'sk_test_1x1', 'sk_test_1x3', 'sk_test_2x1', 'sk_test_2x2', 'sk_test_3x3', 'sk_test_5x3', 'sk_test_10x3', 'x-recharge-access-token'],
  },
  {
    id: 'rechargepayments-3',
    label: 'Rechargepayments (3)',
    regex: new RegExp("\\b[0-9a-fA-F]{32}\\b", ''),
    keywords: ['sk_1x1', 'sk_1x3', 'sk_2x1', 'sk_2x2', 'sk_3x3', 'sk_5x3', 'sk_10x3', 'sk_test_1x1', 'sk_test_1x3', 'sk_test_2x1', 'sk_test_2x2', 'sk_test_3x3', 'sk_test_5x3', 'sk_test_10x3', 'x-recharge-access-token'],
  },
  {
    id: 'redis-1',
    label: 'Redis (1)',
    regex: new RegExp("\\bredi[s]{1,2}://[\\S]{3,50}:([\\S]{3,50})@[-.%\\w\\/:]+\\b", ''),
    keywords: ['redis'],
  },
  {
    id: 'redis-2',
    label: 'Redis (2)',
    regex: new RegExp("\\b([\\w\\d.-]{1,100}\\.redis\\.cache\\.windows\\.net:6380),password=([^,]{44}),ssl=True,abortConnect=False\\b", ''),
    keywords: ['redis'],
  },
  {
    id: 'refiner',
    label: 'Refiner',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['refiner'],
  },
  {
    id: 'rentman',
    label: 'Rentman',
    regex: new RegExp("\\b(ey[a-zA-Z0-9]{34}.ey[a-zA-Z0-9._-]{250,300})\\b", ''),
    keywords: ['rentman'],
  },
  {
    id: 'repairshopr-1',
    label: 'Repairshopr (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-]{51})\\b", ''),
    keywords: ['repairshopr'],
  },
  {
    id: 'repairshopr-2',
    label: 'Repairshopr (2)',
    regex: new RegExp("\\b([a-zA-Z0-9_.!+$#^*]{3,32})\\b", ''),
    keywords: ['repairshopr'],
  },
  {
    id: 'replicate',
    label: 'Replicate',
    regex: new RegExp("\\b(r8_[0-9A-Za-z-_]{37})\\b", ''),
    keywords: ['replicate', 'r8_'],
  },
  {
    id: 'replyio',
    label: 'Replyio',
    regex: new RegExp("\\b([0-9A-Za-z]{24})\\b", ''),
    keywords: ['replyio'],
  },
  {
    id: 'requestfinance',
    label: 'Requestfinance',
    regex: new RegExp("\\b([0-9A-Z]{7}-[0-9A-Z]{7}-[0-9A-Z]{7}-[0-9A-Z]{7})\\b", ''),
    keywords: ['requestfinance'],
  },
  {
    id: 'restpackhtmltopdfapi',
    label: 'Restpackhtmltopdfapi',
    regex: new RegExp("\\b([0-9A-Za-z]{48})\\b", ''),
    keywords: ['restpack'],
  },
  {
    id: 'restpackscreenshotapi',
    label: 'Restpackscreenshotapi',
    regex: new RegExp("\\b([0-9A-Za-z]{48})\\b", ''),
    keywords: ['restpack'],
  },
  {
    id: 'rev-1',
    label: 'Rev (1)',
    regex: new RegExp("\\b([0-9a-zA-Z\\/\\+]{27}\\=[ \\r\\n]{1})", ''),
    keywords: ['rev'],
  },
  {
    id: 'rev-2',
    label: 'Rev (2)',
    regex: new RegExp("\\b([0-9a-zA-Z\\-]{27}[ \\r\\n]{1})", ''),
    keywords: ['rev'],
  },
  {
    id: 'revampcrm-1',
    label: 'Revampcrm (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{40}\\b)", ''),
    keywords: ['revampcrm'],
  },
  {
    id: 'revampcrm-2',
    label: 'Revampcrm (2)',
    regex: new RegExp("\\b([a-zA-Z0-9.-@]{25,30})\\b", ''),
    keywords: ['revampcrm'],
  },
  {
    id: 'ringcentral-1',
    label: 'Ringcentral (1)',
    regex: new RegExp("\\b([0-9A-Za-z_-]{22})\\b", ''),
    keywords: ['ringcentral'],
  },
  {
    id: 'ringcentral-2',
    label: 'Ringcentral (2)',
    regex: new RegExp("\\b(https://www.[0-9A-Za-z_-]{1,}.com)\\b", ''),
    keywords: ['ringcentral'],
  },
  {
    id: 'ritekit',
    label: 'Ritekit',
    regex: new RegExp("\\b([0-9a-f]{44})\\b", ''),
    keywords: ['ritekit'],
  },
  {
    id: 'roaring-1',
    label: 'Roaring (1)',
    regex: new RegExp("\\b([0-9A-Za-z_-]{28})\\b", ''),
    keywords: ['roaring'],
  },
  {
    id: 'roaring-2',
    label: 'Roaring (2)',
    regex: new RegExp("\\b([0-9A-Za-z_-]{28})\\b", ''),
    keywords: ['roaring'],
  },
  {
    id: 'robinhoodcrypto-1',
    label: 'Robinhoodcrypto (1)',
    regex: new RegExp("\\b(rh-api-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\\b", ''),
    keywords: ['rh-api-'],
  },
  {
    id: 'robinhoodcrypto-2',
    label: 'Robinhoodcrypto (2)',
    regex: new RegExp("(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\\/]{3}=)", ''),
    keywords: ['rh-api-'],
  },
  {
    id: 'rocketreach',
    label: 'Rocketreach',
    regex: new RegExp("\\b([a-z0-9-]{39})\\b", ''),
    keywords: ['rocketreach'],
  },
  {
    id: 'rootly',
    label: 'Rootly',
    regex: new RegExp("\\b(rootly_[a-f0-9]{64})\\b", ''),
    keywords: ['rootly_'],
  },
  {
    id: 'route4me',
    label: 'Route4me',
    regex: new RegExp("\\b([0-9A-Z]{32})\\b", ''),
    keywords: ['route4me'],
  },
  {
    id: 'rownd-1',
    label: 'Rownd (1)',
    regex: new RegExp("\\b([a-z0-9]{8}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{12})\\b", ''),
    keywords: ['rownd'],
  },
  {
    id: 'rownd-2',
    label: 'Rownd (2)',
    regex: new RegExp("\\b([a-z0-9]{48})\\b", ''),
    keywords: ['rownd'],
  },
  {
    id: 'rownd-3',
    label: 'Rownd (3)',
    regex: new RegExp("\\b([0-9]{18})\\b", ''),
    keywords: ['rownd'],
  },
  {
    id: 'rubygems',
    label: 'Rubygems',
    regex: new RegExp("\\b(rubygems_[a-zA0-9]{48})\\b", ''),
    keywords: ['rubygems'],
  },
  {
    id: 'runrunit-1',
    label: 'Runrunit (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['runrunit'],
  },
  {
    id: 'runrunit-2',
    label: 'Runrunit (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{18,20})\\b", ''),
    keywords: ['runrunit'],
  },
  {
    id: 'saladcloudapikey',
    label: 'Saladcloudapikey',
    regex: new RegExp("\\b(salad_cloud_[0-9A-Za-z]{1,7}_[0-9A-Za-z]{7,235})\\b", ''),
    keywords: ['salad_cloud_'],
  },
  {
    id: 'salesblink',
    label: 'Salesblink',
    regex: new RegExp("\\b(key-[a-zA-Z0-9]{64})\\b", ''),
    keywords: ['salesblink'],
  },
  {
    id: 'salescookie',
    label: 'Salescookie',
    regex: new RegExp("\\b([a-zA-z0-9]{32})\\b", ''),
    keywords: ['salescookie'],
  },
  {
    id: 'salesflare',
    label: 'Salesflare',
    regex: new RegExp("\\b([a-zA-Z0-9_]{45})\\b", ''),
    keywords: ['salesflare'],
  },
  {
    id: 'salesforce-1',
    label: 'Salesforce (1)',
    regex: new RegExp("\\b00[a-zA-Z0-9]{13}![a-zA-Z0-9_.]{96}\\b", ''),
    keywords: ['salesforce'],
  },
  {
    id: 'salesforce-2',
    label: 'Salesforce (2)',
    regex: new RegExp("\\bhttps://[0-9a-zA-Z-\\.]{1,100}\\.my\\.salesforce\\.com\\b", ''),
    keywords: ['salesforce'],
  },
  {
    id: 'salesforceoauth2-1',
    label: 'Salesforceoauth2 (1)',
    regex: new RegExp("\\b(?:https?://)?([0-9a-zA-Z\\-\\.]{1,100}\\.my\\.salesforce\\.com)\\b", ''),
    keywords: ['salesforce', '3mvg9'],
  },
  {
    id: 'salesforceoauth2-2',
    label: 'Salesforceoauth2 (2)',
    regex: new RegExp("\\b(3MVG9[0-9a-zA-Z._+/=]{80,251})", ''),
    keywords: ['salesforce', '3mvg9'],
  },
  {
    id: 'salesforceoauth2-3',
    label: 'Salesforceoauth2 (3)',
    regex: new RegExp("\\b([A-Za-z0-9+/=.]{64}|[0-9]{19})\\b", ''),
    keywords: ['salesforce', '3mvg9'],
  },
  {
    id: 'salesforcerefreshtoken-1',
    label: 'Salesforcerefreshtoken (1)',
    regex: new RegExp("\\b(5AEP861[a-zA-Z0-9._=]{80,})\\b", 'i'),
    keywords: ['salesforce', '5aep861', '3mvg9'],
  },
  {
    id: 'salesforcerefreshtoken-2',
    label: 'Salesforcerefreshtoken (2)',
    regex: new RegExp("\\b(3MVG9[0-9a-zA-Z._+/=]{80,251})", ''),
    keywords: ['salesforce', '5aep861', '3mvg9'],
  },
  {
    id: 'salesforcerefreshtoken-3',
    label: 'Salesforcerefreshtoken (3)',
    regex: new RegExp("\\b([A-Za-z0-9+/=.]{64}|[0-9]{19})\\b", ''),
    keywords: ['salesforce', '5aep861', '3mvg9'],
  },
  {
    id: 'salesmate-1',
    label: 'Salesmate (1)',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['salesmate'],
  },
  {
    id: 'salesmate-2',
    label: 'Salesmate (2)',
    regex: new RegExp("\\b([a-z0-9A-Z]{3,22})\\b", ''),
    keywords: ['salesmate'],
  },
  {
    id: 'sanity',
    label: 'Sanity',
    regex: new RegExp("\\b(sk[A-Za-z0-9]{79})\\b", ''),
    keywords: ['sanity'],
  },
  {
    id: 'satismeterprojectkey-1',
    label: 'Satismeterprojectkey (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{24})\\b", ''),
    keywords: ['satismeter'],
  },
  {
    id: 'satismeterprojectkey-2',
    label: 'Satismeterprojectkey (2)',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['satismeter'],
  },
  {
    id: 'satismeterwritekey-1',
    label: 'Satismeterwritekey (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['satismeter'],
  },
  {
    id: 'satismeterwritekey-2',
    label: 'Satismeterwritekey (2)',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['satismeter'],
  },
  {
    id: 'satismeterwritekey-3',
    label: 'Satismeterwritekey (3)',
    regex: new RegExp("\\b([a-zA-Z0-9]{24})\\b", ''),
    keywords: ['satismeter'],
  },
  {
    id: 'saucelabs-1',
    label: 'Saucelabs (1)',
    regex: new RegExp("\\b([a-zA-Z0-9_\\.-]{2,70})", ''),
    keywords: ['saucelabs'],
  },
  {
    id: 'saucelabs-2',
    label: 'Saucelabs (2)',
    regex: new RegExp("\\b([a-z0-9]{8}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{4}\\-[a-z0-9]{12})\\b", ''),
    keywords: ['saucelabs'],
  },
  {
    id: 'saucelabs-3',
    label: 'Saucelabs (3)',
    regex: new RegExp("\\b(api\\.(?:us|eu)-(?:west|east|central)-[0-9].saucelabs\\.com)\\b", ''),
    keywords: ['saucelabs'],
  },
  {
    id: 'scalewaykey',
    label: 'Scalewaykey',
    regex: new RegExp("\\b([0-9a-z]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['scaleway'],
  },
  {
    id: 'scalr-1',
    label: 'Scalr (1)',
    regex: new RegExp("\\b([0-9a-zA-Z._]{136})", ''),
    keywords: ['scalr'],
  },
  {
    id: 'scalr-2',
    label: 'Scalr (2)',
    regex: new RegExp("\\b([0-9a-z]{4,50})\\b", ''),
    keywords: ['scalr'],
  },
  {
    id: 'scrapeowl',
    label: 'Scrapeowl',
    regex: new RegExp("\\b([0-9a-z]{30})\\b", ''),
    keywords: ['scrapeowl'],
  },
  {
    id: 'scraperapi',
    label: 'Scraperapi',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['scraperapi'],
  },
  {
    id: 'scraperbox',
    label: 'Scraperbox',
    regex: new RegExp("\\b([A-Z0-9]{32})\\b", ''),
    keywords: ['scraperbox'],
  },
  {
    id: 'scrapestack',
    label: 'Scrapestack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['scrapestack'],
  },
  {
    id: 'scrapfly',
    label: 'Scrapfly',
    regex: new RegExp("\\b([a-z0-9]{32}|scp-(?:live|test)-[a-z0-9]{32})\\b", ''),
    keywords: ['scrapfly'],
  },
  {
    id: 'scrapingant',
    label: 'Scrapingant',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['scrapingant'],
  },
  {
    id: 'scrapingbee',
    label: 'Scrapingbee',
    regex: new RegExp("\\b([A-Z0-9]{80})\\b", ''),
    keywords: ['scrapingbee', 'scraping bee', 'scraping-bee', 'scraping_bee'],
  },
  {
    id: 'screenshotapi',
    label: 'Screenshotapi',
    regex: new RegExp("\\b([0-9A-Z]{7}\\-[0-9A-Z]{7}\\-[0-9A-Z]{7}\\-[0-9A-Z]{7})\\b", ''),
    keywords: ['screenshotapi'],
  },
  {
    id: 'screenshotlayer',
    label: 'Screenshotlayer',
    regex: new RegExp("\\b([a-zA-Z0-9_]{32})\\b", ''),
    keywords: ['screenshotlayer'],
  },
  {
    id: 'scrutinizerci',
    label: 'Scrutinizerci',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['scrutinizer'],
  },
  {
    id: 'segmentapikey',
    label: 'Segmentapikey',
    regex: new RegExp("\\b([A-Za-z0-9_\\-a-zA-Z]{43}\\.[A-Za-z0-9_\\-a-zA-Z]{43})\\b", ''),
    keywords: ['segment'],
  },
  {
    id: 'selectpdf',
    label: 'Selectpdf',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['selectpdf'],
  },
  {
    id: 'semaphore',
    label: 'Semaphore',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['semaphore.co'],
  },
  {
    id: 'sendbird-1',
    label: 'Sendbird (1)',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['sendbird'],
  },
  {
    id: 'sendbird-2',
    label: 'Sendbird (2)',
    regex: new RegExp("\\b([0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12})\\b", ''),
    keywords: ['sendbird'],
  },
  {
    id: 'sendbirdorganizationapi',
    label: 'Sendbirdorganizationapi',
    regex: new RegExp("\\b([0-9a-f]{24})\\b", ''),
    keywords: ['sendbird'],
  },
  {
    id: 'sendgrid',
    label: 'Sendgrid',
    regex: new RegExp("\\bSG\\.[\\w\\-]{20,24}\\.[\\w\\-]{39,50}\\b", ''),
    keywords: ['sg.'],
  },
  {
    id: 'sendinbluev2',
    label: 'Sendinbluev2',
    regex: new RegExp("\\b(xkeysib\\-[A-Za-z0-9_-]{81})\\b", ''),
    keywords: ['xkeysib'],
  },
  {
    id: 'sentryorgtoken',
    label: 'Sentryorgtoken',
    regex: new RegExp("\\b(sntrys_eyJ[a-zA-Z0-9=_+/]{197})\\b", ''),
    keywords: ['sntrys_eyj'],
  },
  {
    id: 'sentrytoken-v1',
    label: 'Sentrytoken V1',
    regex: new RegExp("\\b([a-f0-9]{64})\\b", ''),
    keywords: ['sentry'],
  },
  {
    id: 'sentrytoken-v2',
    label: 'Sentrytoken V2',
    regex: new RegExp("\\b(sntryu_[a-f0-9]{64})\\b", ''),
    keywords: ['sentry', 'sntryu'],
  },
  {
    id: 'serphouse',
    label: 'Serphouse',
    regex: new RegExp("\\b([0-9A-Za-z]{60})\\b", ''),
    keywords: ['serphouse'],
  },
  {
    id: 'serpstack',
    label: 'Serpstack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['serpstack'],
  },
  {
    id: 'sheety-1',
    label: 'Sheety (1)',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['sheety'],
  },
  {
    id: 'sheety-2',
    label: 'Sheety (2)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['sheety'],
  },
  {
    id: 'sherpadesk',
    label: 'Sherpadesk',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['sherpadesk'],
  },
  {
    id: 'shipday',
    label: 'Shipday',
    regex: new RegExp("\\b([a-zA-Z0-9.]{11}[a-zA-Z0-9]{20})\\b", ''),
    keywords: ['shipday'],
  },
  {
    id: 'shopify-1',
    label: 'Shopify (1)',
    regex: new RegExp("\\b(shppa_|shpat_)([0-9A-Fa-f]{32})\\b", ''),
    keywords: ['shppa_', 'shpat_'],
  },
  {
    id: 'shopify-2',
    label: 'Shopify (2)',
    regex: new RegExp("[a-zA-Z0-9-]+\\.myshopify\\.com", ''),
    keywords: ['shppa_', 'shpat_'],
  },
  {
    id: 'shortcut',
    label: 'Shortcut',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['shortcut'],
  },
  {
    id: 'shotstack',
    label: 'Shotstack',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['shotstack'],
  },
  {
    id: 'shutterstock-1',
    label: 'Shutterstock (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['shutterstock'],
  },
  {
    id: 'shutterstock-2',
    label: 'Shutterstock (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{16})\\b", ''),
    keywords: ['shutterstock'],
  },
  {
    id: 'shutterstockoauth',
    label: 'Shutterstockoauth',
    regex: new RegExp("\\b(v2/[0-9A-Za-z]{388})\\b", ''),
    keywords: ['shutterstock'],
  },
  {
    id: 'signable-1',
    label: 'Signable (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['signable'],
  },
  {
    id: 'signable-2',
    label: 'Signable (2)',
    regex: new RegExp("([a-z]{2})signable", 'i'),
    keywords: ['signable'],
  },
  {
    id: 'signalwire-1',
    label: 'Signalwire (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{50})\\b", ''),
    keywords: ['signalwire'],
  },
  {
    id: 'signalwire-2',
    label: 'Signalwire (2)',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['signalwire'],
  },
  {
    id: 'signalwire-3',
    label: 'Signalwire (3)',
    regex: new RegExp("\\b([0-9a-z-]{3,64}\\.signalwire\\.com)\\b", ''),
    keywords: ['signalwire'],
  },
  {
    id: 'signaturit',
    label: 'Signaturit',
    regex: new RegExp("\\b([0-9A-Za-z]{86})\\b", ''),
    keywords: ['signaturit'],
  },
  {
    id: 'signupgenius',
    label: 'Signupgenius',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['signupgenius'],
  },
  {
    id: 'sigopt',
    label: 'Sigopt',
    regex: new RegExp("\\b([A-Z0-9]{48})\\b", ''),
    keywords: ['sigopt'],
  },
  {
    id: 'simplesat',
    label: 'Simplesat',
    regex: new RegExp("\\b([a-z0-9]{40})", ''),
    keywords: ['simplesat'],
  },
  {
    id: 'simplynoted',
    label: 'Simplynoted',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{340,360})\\b", ''),
    keywords: ['simplynoted'],
  },
  {
    id: 'simvoly',
    label: 'Simvoly',
    regex: new RegExp("\\b([a-z0-9]{33})\\b", ''),
    keywords: ['simvoly'],
  },
  {
    id: 'sinchmessage-1',
    label: 'Sinchmessage (1)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['sinch'],
  },
  {
    id: 'sinchmessage-2',
    label: 'Sinchmessage (2)',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['sinch'],
  },
  {
    id: 'sirv-1',
    label: 'Sirv (1)',
    regex: new RegExp("\\b([a-zA-Z0-9\\S]{88})", ''),
    keywords: ['sirv'],
  },
  {
    id: 'sirv-2',
    label: 'Sirv (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{26})\\b", ''),
    keywords: ['sirv'],
  },
  {
    id: 'siteleaf-1',
    label: 'Siteleaf (1)',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['siteleaf'],
  },
  {
    id: 'siteleaf-2',
    label: 'Siteleaf (2)',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['siteleaf'],
  },
  {
    id: 'skrappio',
    label: 'Skrappio',
    regex: new RegExp("\\b([a-z0-9A-Z]{42})\\b", ''),
    keywords: ['skrapp'],
  },
  {
    id: 'skybiometry-1',
    label: 'Skybiometry (1)',
    regex: new RegExp("\\b([0-9a-z]{25,26})\\b", ''),
    keywords: ['skybiometry'],
  },
  {
    id: 'skybiometry-2',
    label: 'Skybiometry (2)',
    regex: new RegExp("\\b([0-9a-z]{25,26})\\b", ''),
    keywords: ['skybiometry'],
  },
  {
    id: 'slack-1',
    label: 'Slack (1)',
    regex: new RegExp("xoxb\\-[0-9]{10,13}\\-[0-9]{10,13}[a-zA-Z0-9\\-]*", ''),
    keywords: ['xoxb-', 'xoxp-', 'xoxa-', 'xoxr-'],
  },
  {
    id: 'slack-2',
    label: 'Slack (2)',
    regex: new RegExp("xoxp\\-[0-9]{10,13}\\-[0-9]{10,13}[a-zA-Z0-9\\-]*", ''),
    keywords: ['xoxb-', 'xoxp-', 'xoxa-', 'xoxr-'],
  },
  {
    id: 'slack-3',
    label: 'Slack (3)',
    regex: new RegExp("xoxa\\-[0-9]{10,13}\\-[0-9]{10,13}[a-zA-Z0-9\\-]*", ''),
    keywords: ['xoxb-', 'xoxp-', 'xoxa-', 'xoxr-'],
  },
  {
    id: 'slack-4',
    label: 'Slack (4)',
    regex: new RegExp("xoxr\\-[0-9]{10,13}\\-[0-9]{10,13}[a-zA-Z0-9\\-]*", ''),
    keywords: ['xoxb-', 'xoxp-', 'xoxa-', 'xoxr-'],
  },
  {
    id: 'slackwebhook-1',
    label: 'Slackwebhook (1)',
    regex: new RegExp("(https://hooks\\.slack\\.com/services/T[A-Z0-9]+/B[A-Z0-9]+/[A-Za-z0-9]{23,25})", ''),
    keywords: ['hooks.slack.com'],
  },
  {
    id: 'slackwebhook-2',
    label: 'Slackwebhook (2)',
    regex: new RegExp("(https://hooks\\.slack\\.com/workflows/T[A-Z0-9]+/A[A-Z0-9]+/[0-9]{17,19}/[A-Za-z0-9]{23,25})", ''),
    keywords: ['hooks.slack.com'],
  },
  {
    id: 'smartsheets',
    label: 'Smartsheets',
    regex: new RegExp("\\b([a-zA-Z0-9]{26}|[a-zA-Z0-9]{37})\\b", ''),
    keywords: ['smartsheet'],
  },
  {
    id: 'smartystreets-1',
    label: 'Smartystreets (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{20})\\b", ''),
    keywords: ['smartystreets'],
  },
  {
    id: 'smartystreets-2',
    label: 'Smartystreets (2)',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['smartystreets'],
  },
  {
    id: 'smooch-1',
    label: 'Smooch (1)',
    regex: new RegExp("\\b(act_[0-9a-z]{24})\\b", ''),
    keywords: ['smooch'],
  },
  {
    id: 'smooch-2',
    label: 'Smooch (2)',
    regex: new RegExp("\\b([0-9a-zA-Z_-]{86})\\b", ''),
    keywords: ['smooch'],
  },
  {
    id: 'snipcart',
    label: 'Snipcart',
    regex: new RegExp("\\b([0-9A-Za-z_]{75})\\b", ''),
    keywords: ['snipcart'],
  },
  {
    id: 'snowflake',
    label: 'Snowflake',
    regex: new RegExp("\\b([a-zA-Z]{7}-[0-9a-zA-Z-_]{1,255}(.privatelink)?)\\b", ''),
    keywords: ['snowflake'],
  },
  {
    id: 'snykkey',
    label: 'Snykkey',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['snyk'],
  },
  {
    id: 'sonarcloud',
    label: 'Sonarcloud',
    regex: new RegExp("(?:^|[^@])\\b([0-9a-z]{40})\\b", ''),
    keywords: ['sonar'],
  },
  {
    id: 'sourcegraph',
    label: 'Sourcegraph',
    regex: new RegExp("\\b(sgp_(?:[a-fA-F0-9]{16}|local)_[a-fA-F0-9]{40}|sgp_[a-fA-F0-9]{40}|[a-fA-F0-9]{40})\\b", ''),
    keywords: ['sgp_'],
  },
  {
    id: 'sourcegraphcody',
    label: 'Sourcegraphcody',
    regex: new RegExp("\\b(slk_[a-f0-9]{64})\\b", ''),
    keywords: ['slk_'],
  },
  {
    id: 'sparkpost',
    label: 'Sparkpost',
    regex: new RegExp("\\b([a-zA-Z0-9]{40})\\b", ''),
    keywords: ['sparkpost'],
  },
  {
    id: 'splunkobservabilitytoken',
    label: 'Splunkobservabilitytoken',
    regex: new RegExp("\\b([a-z0-9A-Z]{22})\\b", ''),
    keywords: ['splunk'],
  },
  {
    id: 'spoonacular',
    label: 'Spoonacular',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['spoonacular'],
  },
  {
    id: 'sportsmonk',
    label: 'Sportsmonk',
    regex: new RegExp("\\b([0-9a-zA-Z]{60})\\b", ''),
    keywords: ['sportsmonk'],
  },
  {
    id: 'spotifykey-1',
    label: 'Spotifykey (1)',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['spotify'],
  },
  {
    id: 'spotifykey-2',
    label: 'Spotifykey (2)',
    regex: new RegExp("\\b([A-Za-z0-9]{32})\\b", ''),
    keywords: ['spotify'],
  },
  {
    id: 'square',
    label: 'Square',
    regex: new RegExp("(EAAA[a-zA-Z0-9\\-\\+\\=]{60})", ''),
    keywords: ['eaaa'],
  },
  {
    id: 'squareapp-1',
    label: 'Squareapp (1)',
    regex: new RegExp("(?:sandbox-)?sq0i[a-z]{2}-[0-9A-Za-z_-]{22,43}", ''),
    keywords: ['sq0i'],
  },
  {
    id: 'squareapp-2',
    label: 'Squareapp (2)',
    regex: new RegExp("(?:sandbox-)?sq0c[a-z]{2}-[0-9A-Za-z_-]{40,50}", ''),
    keywords: ['sq0i'],
  },
  {
    id: 'squarespace',
    label: 'Squarespace',
    regex: new RegExp("\\b([0-9Aa-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['squarespace'],
  },
  {
    id: 'squareup',
    label: 'Squareup',
    regex: new RegExp("\\b(sq0idp-[0-9A-Za-z]{22})\\b", ''),
    keywords: ['sq0idp-'],
  },
  {
    id: 'sslmate',
    label: 'Sslmate',
    regex: new RegExp("\\b([a-zA-Z0-9]{36})\\b", ''),
    keywords: ['sslmate'],
  },
  {
    id: 'statuscake',
    label: 'Statuscake',
    regex: new RegExp("\\b([a-zA-Z0-9]{20})\\b", ''),
    keywords: ['statuscake'],
  },
  {
    id: 'statuspage',
    label: 'Statuspage',
    regex: new RegExp("\\b([0-9a-z-]{36})\\b", ''),
    keywords: ['statuspage'],
  },
  {
    id: 'statuspal',
    label: 'Statuspal',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['statuspal'],
  },
  {
    id: 'stitchdata',
    label: 'Stitchdata',
    regex: new RegExp("\\b([0-9a-z_]{35})\\b", ''),
    keywords: ['stitchdata'],
  },
  {
    id: 'stockdata',
    label: 'Stockdata',
    regex: new RegExp("\\b([0-9A-Za-z]{40})\\b", ''),
    keywords: ['stockdata'],
  },
  {
    id: 'storecove',
    label: 'Storecove',
    regex: new RegExp("\\b([a-zA-Z0-9_-]{43})\\b", ''),
    keywords: ['storecove'],
  },
  {
    id: 'stormboard',
    label: 'Stormboard',
    regex: new RegExp("\\b([a-f0-9]{40})\\b", ''),
    keywords: ['stormboard'],
  },
  {
    id: 'stormglass',
    label: 'Stormglass',
    regex: new RegExp("\\b([0-9Aa-z-]{73})\\b", ''),
    keywords: ['stormglass'],
  },
  {
    id: 'storyblok',
    label: 'Storyblok',
    regex: new RegExp("\\b([0-9A-Za-z]{22}tt)\\b", ''),
    keywords: ['storyblok'],
  },
  {
    id: 'storyblokpersonalaccesstoken',
    label: 'Storyblokpersonalaccesstoken',
    regex: new RegExp("\\b([0-9A-Za-z]{22}tt-[0-9]{6}-[A-Za-z0-9_-]{20})\\b", ''),
    keywords: ['storyblok'],
  },
  {
    id: 'storychief',
    label: 'Storychief',
    regex: new RegExp("\\b([a-zA-Z0-9_\\-.]{940,1000})", ''),
    keywords: ['storychief'],
  },
  {
    id: 'strava-1',
    label: 'Strava (1)',
    regex: new RegExp("\\b([0-9]{5})\\b", ''),
    keywords: ['strava'],
  },
  {
    id: 'strava-2',
    label: 'Strava (2)',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['strava'],
  },
  {
    id: 'strava-3',
    label: 'Strava (3)',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['strava'],
  },
  {
    id: 'streak',
    label: 'Streak',
    regex: new RegExp("\\b([0-9Aa-f]{32})\\b", ''),
    keywords: ['streak'],
  },
  {
    id: 'stripe',
    label: 'Stripe',
    regex: new RegExp("[rs]k_live_[a-zA-Z0-9]{20,247}", ''),
    keywords: ['k_live'],
  },
  {
    id: 'stripepaymentintent-1',
    label: 'Stripepaymentintent (1)',
    regex: new RegExp("\\b(pi_[a-zA-Z0-9]{24}_secret_[a-zA-Z0-9]{25})\\b", ''),
    keywords: ['_secret_'],
  },
  {
    id: 'stripepaymentintent-2',
    label: 'Stripepaymentintent (2)',
    regex: new RegExp("\\b([rs]k_live_[a-zA-Z0-9]{20,247})\\b", ''),
    keywords: ['_secret_'],
  },
  {
    id: 'stripepaymentintent-3',
    label: 'Stripepaymentintent (3)',
    regex: new RegExp("\\b(pk_live_[a-zA-Z0-9]{20,247})\\b", ''),
    keywords: ['_secret_'],
  },
  {
    id: 'stripo',
    label: 'Stripo',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiJ9\\.[0-9A-Za-z]{130}\\.[0-9A-Za-z_-]{43})\\b", ''),
    keywords: ['stripo'],
  },
  {
    id: 'stytch-1',
    label: 'Stytch (1)',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{47}=)", ''),
    keywords: ['stytch'],
  },
  {
    id: 'stytch-2',
    label: 'Stytch (2)',
    regex: new RegExp("\\b([a-z0-9-]{49})\\b", ''),
    keywords: ['stytch'],
  },
  {
    id: 'sugester',
    label: 'Sugester',
    regex: new RegExp("\\b([a-zA-Z0-9_.!+$#^*%]{3,32})\\b", ''),
    keywords: ['sugester'],
  },
  {
    id: 'sumologickey-1',
    label: 'Sumologickey (1)',
    regex: new RegExp("api\\.(?:au|ca|de|eu|fed|jp|kr|in|us2)\\.sumologic\\.com", 'i'),
    keywords: ['sumo', 'accessid', 'accesskey'],
  },
  {
    id: 'sumologickey-2',
    label: 'Sumologickey (2)',
    regex: new RegExp("\\b(su[A-Za-z0-9]{12})\\b", ''),
    keywords: ['sumo', 'accessid', 'accesskey'],
  },
  {
    id: 'sumologickey-3',
    label: 'Sumologickey (3)',
    regex: new RegExp("\\b([A-Za-z0-9]{64})\\b", ''),
    keywords: ['sumo', 'accessid', 'accesskey'],
  },
  {
    id: 'supabasetoken',
    label: 'Supabasetoken',
    regex: new RegExp("\\b(sbp_[a-z0-9]{40})\\b", ''),
    keywords: ['sbp_'],
  },
  {
    id: 'supernotesapi',
    label: 'Supernotesapi',
    regex: new RegExp("([ \\r\\n]{0,1}[0-9A-Za-z\\-_]{43}[ \\r\\n]{1})", ''),
    keywords: ['supernotes'],
  },
  {
    id: 'surveyanyplace-1',
    label: 'Surveyanyplace (1)',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['surveyanyplace'],
  },
  {
    id: 'surveyanyplace-2',
    label: 'Surveyanyplace (2)',
    regex: new RegExp("\\b([a-z0-9A-Z-]{36})\\b", ''),
    keywords: ['surveyanyplace'],
  },
  {
    id: 'surveybot',
    label: 'Surveybot',
    regex: new RegExp("\\b([A-Za-z0-9-]{80})\\b", ''),
    keywords: ['surveybot'],
  },
  {
    id: 'surveysparrow',
    label: 'Surveysparrow',
    regex: new RegExp("\\b([a-zA-Z0-9-_]{88})\\b", ''),
    keywords: ['surveysparrow'],
  },
  {
    id: 'survicate',
    label: 'Survicate',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['survicate'],
  },
  {
    id: 'swell',
    label: 'Swell',
    regex: new RegExp("\\b([a-zA-Z0-9]{6,24})\\b", ''),
    keywords: ['swell'],
  },
  {
    id: 'swiftype',
    label: 'Swiftype',
    regex: new RegExp("\\b([a-zA-z-0-9]{6}\\_[a-zA-z-0-9]{6}\\-[a-zA-z-0-9]{6})\\b", ''),
    keywords: ['swiftype'],
  },
  {
    id: 'tableau-1',
    label: 'Tableau (1)',
    regex: new RegExp("([a-zA-Z][a-zA-Z0-9_-]{2,50})", ''),
    keywords: ['tableau', 'online.tableau.com'],
  },
  {
    id: 'tableau-2',
    label: 'Tableau (2)',
    regex: new RegExp("\\b([A-Za-z0-9+/]{22}==:[A-Za-z0-9]{32})\\b", ''),
    keywords: ['tableau', 'online.tableau.com'],
  },
  {
    id: 'tableau-3',
    label: 'Tableau (3)',
    regex: new RegExp("\\b([a-zA-Z0-9\\-]+\\.online\\.tableau\\.com)\\b", ''),
    keywords: ['tableau', 'online.tableau.com'],
  },
  {
    id: 'tailscale',
    label: 'Tailscale',
    regex: new RegExp("\\btskey-[a-z]+-[0-9A-Za-z_]+-[0-9A-Za-z_]+\\b", ''),
    keywords: ['tskey-', 'tskey-api-', 'tskey-oauth-'],
  },
  {
    id: 'tallyfy',
    label: 'Tallyfy',
    regex: new RegExp("\\b([0-9A-Za-z]{36}\\.[0-9A-Za-z]{264}\\.[0-9A-Za-z\\-\\_]{683})\\b", ''),
    keywords: ['tallyfy'],
  },
  {
    id: 'tatumio',
    label: 'Tatumio',
    regex: new RegExp("\\b([0-9a-z-]{36})\\b", ''),
    keywords: ['tatum'],
  },
  {
    id: 'taxjar',
    label: 'Taxjar',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['taxjar'],
  },
  {
    id: 'teamgate-1',
    label: 'Teamgate (1)',
    regex: new RegExp("\\b([a-z0-9]{40})\\b", ''),
    keywords: ['teamgate'],
  },
  {
    id: 'teamgate-2',
    label: 'Teamgate (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{80})\\b", ''),
    keywords: ['teamgate'],
  },
  {
    id: 'teamworkcrm',
    label: 'Teamworkcrm',
    regex: new RegExp("\\b(tkn\\.v1_[0-9A-Za-z]{71}=[ \\r\\n]{1})", ''),
    keywords: ['teamwork', 'teamworkcrm'],
  },
  {
    id: 'teamworkdesk',
    label: 'Teamworkdesk',
    regex: new RegExp("\\b(tkn\\.v1_[0-9A-Za-z]{71}=[ \\r\\n]{1})", ''),
    keywords: ['teamwork', 'teamworkdesk'],
  },
  {
    id: 'teamworkspaces',
    label: 'Teamworkspaces',
    regex: new RegExp("\\b(tkn\\.v1_[0-9A-Za-z]{71}=[ \\r\\n]{1})", ''),
    keywords: ['teamwork', 'teamworkspaces'],
  },
  {
    id: 'technicalanalysisapi',
    label: 'Technicalanalysisapi',
    regex: new RegExp("\\b([A-Z0-9]{48})\\b", ''),
    keywords: ['technicalanalysisapi'],
  },
  {
    id: 'tefter',
    label: 'Tefter',
    regex: new RegExp("\\b([0-9a-zA-Z]{20})\\b", ''),
    keywords: ['tefter'],
  },
  {
    id: 'telegrambottoken',
    label: 'Telegrambottoken',
    regex: new RegExp("\\b([0-9]{8,10}:[a-zA-Z0-9_-]{35})\\b", ''),
    keywords: ['telegram', 'tgram'],
  },
  {
    id: 'teletype',
    label: 'Teletype',
    regex: new RegExp("\\b([0-9a-zA-Z-]{64})\\b", ''),
    keywords: ['teletype'],
  },
  {
    id: 'telnyx',
    label: 'Telnyx',
    regex: new RegExp("\\b(KEY[0-9A-Za-z_-]{55})\\b", ''),
    keywords: ['telnyx'],
  },
  {
    id: 'terraformcloudpersonaltoken',
    label: 'Terraformcloudpersonaltoken',
    regex: new RegExp("\\b([A-Za-z0-9]{14}.atlasv1.[A-Za-z0-9]{67})\\b", ''),
    keywords: ['.atlasv1.'],
  },
  {
    id: 'testingbot-1',
    label: 'Testingbot (1)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['testingbot'],
  },
  {
    id: 'testingbot-2',
    label: 'Testingbot (2)',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['testingbot'],
  },
  {
    id: 'textmagic-1',
    label: 'Textmagic (1)',
    regex: new RegExp("\\b([0-9A-Za-z]{30})\\b", ''),
    keywords: ['textmagic'],
  },
  {
    id: 'textmagic-2',
    label: 'Textmagic (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{1,25})\\b", ''),
    keywords: ['textmagic'],
  },
  {
    id: 'theoddsapi',
    label: 'Theoddsapi',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['theoddsapi', 'the-odds-api'],
  },
  {
    id: 'thinkific-1',
    label: 'Thinkific (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['thinkific'],
  },
  {
    id: 'thinkific-2',
    label: 'Thinkific (2)',
    regex: new RegExp("\\b([0-9A-Za-z]{4,40})\\b", ''),
    keywords: ['thinkific'],
  },
  {
    id: 'thousandeyes',
    label: 'Thousandeyes',
    regex: new RegExp("\\b([a-zA-Z0-9]{3,20}@[a-zA-Z0-9]{2,12}.[a-zA-Z0-9]{2,5})\\b", ''),
    keywords: ['thousandeyes'],
  },
  {
    id: 'tickettailor',
    label: 'Tickettailor',
    regex: new RegExp("\\b(sk_[0-9]{4}_[0-9]{6}_[a-f0-9]{32})", ''),
    keywords: ['tickettailor'],
  },
  {
    id: 'tiingo',
    label: 'Tiingo',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['tiingo'],
  },
  {
    id: 'timecamp',
    label: 'Timecamp',
    regex: new RegExp("\\b([0-9a-z]{26})\\b", ''),
    keywords: ['timecamp'],
  },
  {
    id: 'timezoneapi',
    label: 'Timezoneapi',
    regex: new RegExp("\\b([a-zA-Z]{20})\\b", ''),
    keywords: ['timezoneapi'],
  },
  {
    id: 'tineswebhook',
    label: 'Tineswebhook',
    regex: new RegExp("(https://[\\w-]+\\.tines\\.com/webhook/[a-z0-9]{32}/[a-z0-9]{32})", ''),
    keywords: ['tines.com'],
  },
  {
    id: 'tly',
    label: 'Tly',
    regex: new RegExp("\\b([0-9A-Za-z]{60})\\b", ''),
    keywords: ['tly'],
  },
  {
    id: 'tmetric',
    label: 'Tmetric',
    regex: new RegExp("\\b([0-9A-Z]{64})\\b", ''),
    keywords: ['tmetric'],
  },
  {
    id: 'todoist',
    label: 'Todoist',
    regex: new RegExp("\\b([0-9a-z]{40})\\b", ''),
    keywords: ['todoist'],
  },
  {
    id: 'toggltrack',
    label: 'Toggltrack',
    regex: new RegExp("\\b([0-9Aa-z]{32})\\b", ''),
    keywords: ['toggl'],
  },
  {
    id: 'tokeet-1',
    label: 'Tokeet (1)',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['tokeet'],
  },
  {
    id: 'tokeet-2',
    label: 'Tokeet (2)',
    regex: new RegExp("\\b([0-9]{10}.[0-9]{4})\\b", ''),
    keywords: ['tokeet'],
  },
  {
    id: 'tomtom',
    label: 'Tomtom',
    regex: new RegExp("\\b([0-9Aa-zA-Z]{32})\\b", ''),
    keywords: ['tomtom'],
  },
  {
    id: 'tradier',
    label: 'Tradier',
    regex: new RegExp("\\b([a-zA-Z0-9]{28})\\b", ''),
    keywords: ['tradier'],
  },
  {
    id: 'transferwise',
    label: 'Transferwise',
    regex: new RegExp("\\b([0-9a-f-]{8}-[0-9a-f-]{4}-[0-9a-f-]{4}-[0-9a-f-]{4}-[0-9a-f-]{12})\\b", ''),
    keywords: ['transferwise'],
  },
  {
    id: 'travelpayouts',
    label: 'Travelpayouts',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['travelpayouts'],
  },
  {
    id: 'travisci',
    label: 'Travisci',
    regex: new RegExp("\\b([a-zA-Z0-9A-Z_]{22})\\b", ''),
    keywords: ['travis'],
  },
  {
    id: 'trelloapikey-1',
    label: 'Trelloapikey (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{64})\\b", ''),
    keywords: ['trello'],
  },
  {
    id: 'trelloapikey-2',
    label: 'Trelloapikey (2)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{32})\\b", ''),
    keywords: ['trello'],
  },
  {
    id: 'tru-1',
    label: 'Tru (1)',
    regex: new RegExp("\\b([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})\\b", ''),
    keywords: ['tru'],
  },
  {
    id: 'tru-2',
    label: 'Tru (2)',
    regex: new RegExp("\\b([0-9a-zA-Z.-_]{26})\\b", ''),
    keywords: ['tru'],
  },
  {
    id: 'trufflehogenterprise-1',
    label: 'Trufflehogenterprise (1)',
    regex: new RegExp("\\bthog-key-[0-9a-f]{16}\\b", ''),
    keywords: ['thog'],
  },
  {
    id: 'trufflehogenterprise-2',
    label: 'Trufflehogenterprise (2)',
    regex: new RegExp("\\bthog-secret-[0-9a-f]{32}\\b", ''),
    keywords: ['thog'],
  },
  {
    id: 'trufflehogenterprise-3',
    label: 'Trufflehogenterprise (3)',
    regex: new RegExp("\\b[a-z]+-[a-z]+-[a-z]+\\.[a-z][0-9]\\.[a-z]+\\.trufflehog\\.org\\b", ''),
    keywords: ['thog'],
  },
  {
    id: 'twelvedata',
    label: 'Twelvedata',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['twelvedata'],
  },
  {
    id: 'twilio-1',
    label: 'Twilio (1)',
    regex: new RegExp("\\bAC[0-9a-f]{32}\\b", ''),
    keywords: ['sid', 'twilio'],
  },
  {
    id: 'twilio-2',
    label: 'Twilio (2)',
    regex: new RegExp("\\b[0-9a-f]{32}\\b", ''),
    keywords: ['sid', 'twilio'],
  },
  {
    id: 'twilioapikey-1',
    label: 'Twilioapikey (1)',
    regex: new RegExp("\\bSK[a-zA-Z0-9]{32}\\b", ''),
    keywords: ['twilio'],
  },
  {
    id: 'twilioapikey-2',
    label: 'Twilioapikey (2)',
    regex: new RegExp("\\b[0-9a-zA-Z]{32}\\b", ''),
    keywords: ['twilio'],
  },
  {
    id: 'twist',
    label: 'Twist',
    regex: new RegExp("\\b(?:oauth2:)?([0-9a-f]{40})\\b", ''),
    keywords: ['twist'],
  },
  {
    id: 'twitch-1',
    label: 'Twitch (1)',
    regex: new RegExp("\\b([0-9a-z]{30})\\b", ''),
    keywords: ['twitch'],
  },
  {
    id: 'twitch-2',
    label: 'Twitch (2)',
    regex: new RegExp("\\b([0-9a-z]{30})\\b", ''),
    keywords: ['twitch'],
  },
  {
    id: 'twitchaccesstoken',
    label: 'Twitchaccesstoken',
    regex: new RegExp("\\b([0-9a-z]{30})\\b", ''),
    keywords: ['twitch'],
  },
  {
    id: 'twitter-v1',
    label: 'Twitter V1',
    regex: new RegExp("\\b([A-Z]{22}%[a-zA-Z-0-9]{23}%[a-zA-Z-0-9]{6}%[a-zA-Z-0-9]{3}%[a-zA-Z-0-9]{9}%[a-zA-Z-0-9]{52})\\b", ''),
    keywords: ['twitter'],
  },
  {
    id: 'twitter-v2',
    label: 'Twitter V2',
    regex: new RegExp("\\b([a-zA-Z0-9]{20,59}%([a-zA-Z0-9]{3,}%){0,2}[a-zA-Z0-9]{52})\\b", ''),
    keywords: ['twitter'],
  },
  {
    id: 'twitterconsumerkey-1',
    label: 'Twitterconsumerkey (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{25})\\b", ''),
    keywords: ['twitter'],
  },
  {
    id: 'twitterconsumerkey-2',
    label: 'Twitterconsumerkey (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{50})\\b", ''),
    keywords: ['twitter'],
  },
  {
    id: 'typeform-v1',
    label: 'Typeform V1',
    regex: new RegExp("\\b([0-9A-Za-z]{44})\\b", ''),
    keywords: ['typeform'],
  },
  {
    id: 'typeform-v2',
    label: 'Typeform V2',
    regex: new RegExp("\\btfp_[a-zA-Z0-9_]{40,59}\\b", ''),
    keywords: ['tfp_'],
  },
  {
    id: 'typetalk-1',
    label: 'Typetalk (1)',
    regex: new RegExp("\\b([0-9a-zA-Z]{64})\\b", ''),
    keywords: ['typetalk'],
  },
  {
    id: 'typetalk-2',
    label: 'Typetalk (2)',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['typetalk'],
  },
  {
    id: 'ubidots',
    label: 'Ubidots',
    regex: new RegExp("\\b(BBFF-[0-9a-zA-Z]{30})\\b", ''),
    keywords: ['bbff-'],
  },
  {
    id: 'uclassify',
    label: 'Uclassify',
    regex: new RegExp("\\b([a-z0-9A-Z]{12})\\b", ''),
    keywords: ['uclassify'],
  },
  {
    id: 'unifyid',
    label: 'Unifyid',
    regex: new RegExp("\\b([0-9A-Za-z_=-]{44})", ''),
    keywords: ['unify'],
  },
  {
    id: 'unplugg',
    label: 'Unplugg',
    regex: new RegExp("\\b([a-z0-9]{64})\\b", ''),
    keywords: ['unplu'],
  },
  {
    id: 'unsplash',
    label: 'Unsplash',
    regex: new RegExp("\\b([0-9A-Za-z_]{43})\\b", ''),
    keywords: ['unsplash'],
  },
  {
    id: 'upcdatabase',
    label: 'Upcdatabase',
    regex: new RegExp("\\b([A-Z0-9]{32})\\b", ''),
    keywords: ['upcdatabase'],
  },
  {
    id: 'uplead',
    label: 'Uplead',
    regex: new RegExp("\\b([a-z0-9-]{32})\\b", ''),
    keywords: ['uplead'],
  },
  {
    id: 'uploadcare-1',
    label: 'Uploadcare (1)',
    regex: new RegExp("\\b([a-z0-9]{20})\\b", ''),
    keywords: ['uploadcare'],
  },
  {
    id: 'uploadcare-2',
    label: 'Uploadcare (2)',
    regex: new RegExp("\\b([a-z0-9]{20})\\b", ''),
    keywords: ['uploadcare'],
  },
  {
    id: 'uptimerobot',
    label: 'Uptimerobot',
    regex: new RegExp("\\b([a-zA-Z0-9]{9}-[a-zA-Z0-9]{24})\\b", ''),
    keywords: ['uptimerobot'],
  },
  {
    id: 'upwave',
    label: 'Upwave',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['upwave'],
  },
  {
    id: 'uri',
    label: 'URI',
    regex: new RegExp("\\bhttps?:\\/\\/[\\w!#$%&()*+,\\-./;<=>?@[\\\\\\]^_{|}~]{0,50}:([\\w!#$%&()*+,\\-./:;<=>?[\\\\\\]^_{|}~]{3,50})@[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})?(?::\\d{1,5})?[\\w/]+\\b", ''),
    keywords: ['http://', 'https://'],
  },
  {
    id: 'urlscan',
    label: 'Urlscan',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['urlscan'],
  },
  {
    id: 'user',
    label: 'User',
    regex: new RegExp("\\b([a-zA-Z0-9-._+=]{64})\\b", ''),
    keywords: ['user'],
  },
  {
    id: 'userflow',
    label: 'Userflow',
    regex: new RegExp("\\b([0-9a-z_]{29})\\b", ''),
    keywords: ['userflow'],
  },
  {
    id: 'userstack',
    label: 'Userstack',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['userstack'],
  },
  {
    id: 'vagrantcloudpersonaltoken',
    label: 'Vagrantcloudpersonaltoken',
    regex: new RegExp("\\b([A-Za-z0-9]{14}.atlasv1.[A-Za-z0-9]{67})\\b", ''),
    keywords: ['vagrant'],
  },
  {
    id: 'vatlayer',
    label: 'Vatlayer',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['vatlayer'],
  },
  {
    id: 'vbout',
    label: 'Vbout',
    regex: new RegExp("\\b([0-9]{25})\\b", ''),
    keywords: ['vbout'],
  },
  {
    id: 'vercel',
    label: 'Vercel',
    regex: new RegExp("\\b([a-zA-Z0-9]{24})\\b", ''),
    keywords: ['vercel'],
  },
  {
    id: 'verifier',
    label: 'Verifier',
    regex: new RegExp("\\b([a-z0-9]{96})\\b", ''),
    keywords: ['verifier'],
  },
  {
    id: 'verimail',
    label: 'Verimail',
    regex: new RegExp("\\b([A-Z0-9]{32})\\b", ''),
    keywords: ['verimail'],
  },
  {
    id: 'veriphone',
    label: 'Veriphone',
    regex: new RegExp("\\b([0-9A-Z]{32})\\b", ''),
    keywords: ['veriphone'],
  },
  {
    id: 'versioneye',
    label: 'Versioneye',
    regex: new RegExp("\\b([a-zA-Z0-9-]{40})\\b", ''),
    keywords: ['versioneye'],
  },
  {
    id: 'viewneo',
    label: 'Viewneo',
    regex: new RegExp("\\b([a-z0-9A-Z]{120,300}.[a-z0-9A-Z]{150,300}.[a-z0-9A-Z-_]{600,800})", ''),
    keywords: ['viewneo'],
  },
  {
    id: 'virustotal',
    label: 'Virustotal',
    regex: new RegExp("\\b([a-f0-9]{64})\\b", ''),
    keywords: ['virustotal'],
  },
  {
    id: 'visualcrossing',
    label: 'Visualcrossing',
    regex: new RegExp("\\b([0-9A-Z]{25})\\b", ''),
    keywords: ['visualcrossing'],
  },
  {
    id: 'voiceflow',
    label: 'Voiceflow',
    regex: new RegExp("\\b(VF\\.(?:(?:DM|WS)\\.)?[a-fA-F0-9]{24}\\.[a-zA-Z0-9]{16})\\b", ''),
    keywords: ['vf', 'dm'],
  },
  {
    id: 'voicegain',
    label: 'Voicegain',
    regex: new RegExp("\\b(ey[0-9a-zA-Z_-]{34}.ey[0-9a-zA-Z_-]{108}.[0-9a-zA-Z_-]{43})\\b", ''),
    keywords: ['voicegain'],
  },
  {
    id: 'voodoosms',
    label: 'Voodoosms',
    regex: new RegExp("\\b([0-9a-zA-Z]{46})\\b", ''),
    keywords: ['voodoosms'],
  },
  {
    id: 'vouchery-1',
    label: 'Vouchery (1)',
    regex: new RegExp("\\b([a-z0-9-]{36})\\b", ''),
    keywords: ['vouchery'],
  },
  {
    id: 'vouchery-2',
    label: 'Vouchery (2)',
    regex: new RegExp("\\b([a-zA-Z0-9-\\S]{2,20})\\b", ''),
    keywords: ['vouchery'],
  },
  {
    id: 'vpnapi',
    label: 'Vpnapi',
    regex: new RegExp("\\b([a-z0-9A-Z]{32})\\b", ''),
    keywords: ['vpnapi'],
  },
  {
    id: 'vultrapikey',
    label: 'Vultrapikey',
    regex: new RegExp("\\b([A-Z0-9]{36})\\b", ''),
    keywords: ['vultr'],
  },
  {
    id: 'vyte',
    label: 'Vyte',
    regex: new RegExp("\\b([0-9a-z]{50})\\b", ''),
    keywords: ['vyte'],
  },
  {
    id: 'walkscore',
    label: 'Walkscore',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['walkscore'],
  },
  {
    id: 'weatherbit',
    label: 'Weatherbit',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['weatherbit'],
  },
  {
    id: 'weatherstack',
    label: 'Weatherstack',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['weatherstack'],
  },
  {
    id: 'web3storage',
    label: 'Web3storage',
    regex: new RegExp("\\b(eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9\\.eyJ[A-Za-z0-9-_]{100,300}\\.[A-Za-z0-9-_]{25,100})\\b", ''),
    keywords: ['web3'],
  },
  {
    id: 'webex-1',
    label: 'Webex (1)',
    regex: new RegExp("\\b([a-f0-9]{64})\\b", ''),
    keywords: ['webex'],
  },
  {
    id: 'webex-2',
    label: 'Webex (2)',
    regex: new RegExp("\\b(C[a-f0-9]{64})\\b", ''),
    keywords: ['webex'],
  },
  {
    id: 'webex-3',
    label: 'Webex (3)',
    regex: new RegExp("(redirect_uri_mismatch)", ''),
    keywords: ['webex'],
  },
  {
    id: 'webexbot',
    label: 'Webexbot',
    regex: new RegExp("([a-zA-Z0-9]{64}_[a-zA-Z0-9]{4}_[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})", ''),
    keywords: ['spark', 'webex'],
  },
  {
    id: 'webflow',
    label: 'Webflow',
    regex: new RegExp("\\b([a-zA0-9]{64})\\b", ''),
    keywords: ['webflow'],
  },
  {
    id: 'webscraper',
    label: 'Webscraper',
    regex: new RegExp("\\b([a-zA-Z0-9]{60})\\b", ''),
    keywords: ['webscraper'],
  },
  {
    id: 'webscraping',
    label: 'Webscraping',
    regex: new RegExp("\\b([0-9A-Za-z]{32})\\b", ''),
    keywords: ['webscraping'],
  },
  {
    id: 'websitepulse-1',
    label: 'Websitepulse (1)',
    regex: new RegExp("\\b([0-9a-f]{32})\\b", ''),
    keywords: ['websitepulse'],
  },
  {
    id: 'websitepulse-2',
    label: 'Websitepulse (2)',
    regex: new RegExp("\\b([0-9a-zA-Z._]{4,22})\\b", ''),
    keywords: ['websitepulse'],
  },
  {
    id: 'weightsandbiases',
    label: 'Weightsandbiases',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['wandb'],
  },
  {
    id: 'wepay-1',
    label: 'Wepay (1)',
    regex: new RegExp("\\b(\\d{6})\\b", ''),
    keywords: ['wepay'],
  },
  {
    id: 'wepay-2',
    label: 'Wepay (2)',
    regex: new RegExp("\\b([a-zA-Z0-9_?]{62})\\b", ''),
    keywords: ['wepay'],
  },
  {
    id: 'whoxy',
    label: 'Whoxy',
    regex: new RegExp("\\b([0-9a-z]{33})\\b", ''),
    keywords: ['whoxy'],
  },
  {
    id: 'wistia',
    label: 'Wistia',
    regex: new RegExp("\\b([0-9a-z]{64})\\b", ''),
    keywords: ['wistia'],
  },
  {
    id: 'wit',
    label: 'Wit',
    regex: new RegExp("\\b([A-Z0-9]{32})\\b", ''),
    keywords: ['wit'],
  },
  {
    id: 'wiz-1',
    label: 'Wiz (1)',
    regex: new RegExp("\\b([a-zA-Z0-9]{53})\\b", ''),
    keywords: ['wiz'],
  },
  {
    id: 'wiz-2',
    label: 'Wiz (2)',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['wiz'],
  },
  {
    id: 'worksnaps',
    label: 'Worksnaps',
    regex: new RegExp("\\b([0-9A-Za-z]{40})\\b", ''),
    keywords: ['worksnaps'],
  },
  {
    id: 'workstack',
    label: 'Workstack',
    regex: new RegExp("\\b([0-9Aa-zA-Z]{60})\\b", ''),
    keywords: ['workstack'],
  },
  {
    id: 'worldcoinindex',
    label: 'Worldcoinindex',
    regex: new RegExp("\\b([a-zA-Z0-9]{35})\\b", ''),
    keywords: ['worldcoinindex'],
  },
  {
    id: 'worldweather',
    label: 'Worldweather',
    regex: new RegExp("\\b([0-9a-z]{31})\\b", ''),
    keywords: ['worldweather'],
  },
  {
    id: 'wrike',
    label: 'Wrike',
    regex: new RegExp("\\b(ey[a-zA-Z0-9-._]{333})\\b", ''),
    keywords: ['wrike'],
  },
  {
    id: 'xai',
    label: 'Xai',
    regex: new RegExp("\\b(xai-[0-9a-zA-Z_]{80})\\b", ''),
    keywords: ['xai-'],
  },
  {
    id: 'yandex',
    label: 'Yandex',
    regex: new RegExp("\\b([a-z0-9A-Z.]{83})\\b", ''),
    keywords: ['yandex'],
  },
  {
    id: 'yelp',
    label: 'Yelp',
    regex: new RegExp("\\b([a-zA-Z0-9_\\\\=\\.\\-]{128})\\b", ''),
    keywords: ['yelp'],
  },
  {
    id: 'youneedabudget',
    label: 'Youneedabudget',
    regex: new RegExp("\\b([0-9a-f]{64})\\b", ''),
    keywords: ['youneedabudget'],
  },
  {
    id: 'yousign',
    label: 'Yousign',
    regex: new RegExp("\\b([0-9a-z]{32})\\b", ''),
    keywords: ['yousign'],
  },
  {
    id: 'youtubeapikey-1',
    label: 'Youtubeapikey (1)',
    regex: new RegExp("\\b([a-zA-Z-0-9_]{39})\\b", ''),
    keywords: ['youtube'],
  },
  {
    id: 'youtubeapikey-2',
    label: 'Youtubeapikey (2)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{24})\\b", ''),
    keywords: ['youtube'],
  },
  {
    id: 'zapierwebhook',
    label: 'Zapierwebhook',
    regex: new RegExp("(https:\\/\\/hooks\\.zapier\\.com\\/hooks\\/catch\\/[A-Za-z0-9\\/]{16})", ''),
    keywords: ['hooks.zapier.com/hooks/catch/'],
  },
  {
    id: 'zendeskapi-1',
    label: 'Zendeskapi (1)',
    regex: new RegExp("([A-Za-z0-9_-]{40})", ''),
    keywords: ['zendesk'],
  },
  {
    id: 'zendeskapi-2',
    label: 'Zendeskapi (2)',
    regex: new RegExp("\\b([a-zA-Z-0-9-]{5,16}\\@[a-zA-Z-0-9]{4,16}\\.[a-zA-Z-0-9]{3,6})\\b", ''),
    keywords: ['zendesk'],
  },
  {
    id: 'zendeskapi-3',
    label: 'Zendeskapi (3)',
    regex: new RegExp("\\b([a-zA-Z-0-9]{3,25}\\.zendesk\\.com)\\b", ''),
    keywords: ['zendesk'],
  },
  {
    id: 'zenkitapi',
    label: 'Zenkitapi',
    regex: new RegExp("\\b([0-9a-z]{8}\\-[0-9A-Za-z]{32})\\b", ''),
    keywords: ['zenkit'],
  },
  {
    id: 'zenrows',
    label: 'Zenrows',
    regex: new RegExp("\\b([0-9a-f]{40})\\b", ''),
    keywords: ['zenrows'],
  },
  {
    id: 'zenscrape',
    label: 'Zenscrape',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['zenscrape'],
  },
  {
    id: 'zenserp',
    label: 'Zenserp',
    regex: new RegExp("\\b([0-9a-z-]{36})\\b", ''),
    keywords: ['zenserp'],
  },
  {
    id: 'zeplin',
    label: 'Zeplin',
    regex: new RegExp("\\b([a-zA-Z0-9-.]{350,400})\\b", ''),
    keywords: ['zeplin'],
  },
  {
    id: 'zerobounce',
    label: 'Zerobounce',
    regex: new RegExp("\\b([a-z0-9]{32})\\b", ''),
    keywords: ['zerobounce'],
  },
  {
    id: 'zerotier',
    label: 'Zerotier',
    regex: new RegExp("\\b([0-9a-zA-Z]{32})\\b", ''),
    keywords: ['zerotier'],
  },
  {
    id: 'zipapi-1',
    label: 'Zipapi (1)',
    regex: new RegExp("\\b([A-Z0-9a-z]{32})\\b", ''),
    keywords: ['zipapi'],
  },
  {
    id: 'zipapi-2',
    label: 'Zipapi (2)',
    regex: new RegExp("\\b([a-zA-Z0-9!=@#$%^]{7,})", ''),
    keywords: ['zipapi'],
  },
  {
    id: 'zipbooks',
    label: 'Zipbooks',
    regex: new RegExp("\\b([a-zA-Z0-9!=@#$%^]{8,})", ''),
    keywords: ['zipbooks'],
  },
  {
    id: 'zipcodeapi',
    label: 'Zipcodeapi',
    regex: new RegExp("\\b([a-zA-Z0-9]{64})\\b", ''),
    keywords: ['zipcodeapi'],
  },
  {
    id: 'zipcodebase',
    label: 'Zipcodebase',
    regex: new RegExp("\\b([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\\b", ''),
    keywords: ['zipcodebase'],
  },
  {
    id: 'zohocrm',
    label: 'Zohocrm',
    regex: new RegExp("\\b(1000\\.[a-f0-9]{32}\\.[a-f0-9]{32})\\b", ''),
    keywords: ['1000.'],
  },
  {
    id: 'zonkafeedback',
    label: 'Zonkafeedback',
    regex: new RegExp("\\b([A-Za-z0-9]{36})\\b", ''),
    keywords: ['zonka'],
  },
  {
    id: 'zulipchat-1',
    label: 'Zulipchat (1)',
    regex: new RegExp("\\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})\\b", ''),
    keywords: ['zulip'],
  },
  {
    id: 'zulipchat-2',
    label: 'Zulipchat (2)',
    regex: new RegExp("\\b([a-z0-9-]+\\.zulip(?:chat)?\\.com|chat\\.zulip\\.org)\\b", 'i'),
    keywords: ['zulip'],
  }
]
